/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * CloudQuery Platform OpenAPI Spec
 * Welcome to the CloudQuery Platform API documentation! This API can be used to interact with the CloudQuery platform. As a user, the API allows you to search the CloudQuery asset inventory, run SQL queries against the data warehouse, save and load searches, and much more. As an administrator, it allows you to manage your teams, syncs, and other objects.
### Authentication
The API is secured using bearer tokens. To get started, you can generate an API key for your Platform deployment from your platform dashboard. For a step-by-step guide, see: https://docs.cloudquery.io/docs/deployment/generate-api-key.
The base URL for the API depends on where your CloudQuery Platform is hosted. If running locally, this is usually http://localhost:3000/api. In a production deployment it should be an HTTPS URL. For purposes of illustration, we will assume the platform instance is available at https://cloudquery.mycompany.com. In this case, the base API endpoint will be https://cloudquery.mycompany.com/api.
### Example Request
To test your connection to the API, we can use the `/plugins` endpoint. For example:
`curl -v -H "Authorization: Bearer $CLOUDQUERY_API_KEY" \ https://cloudquery.mycompany.com/api/plugins`

 * OpenAPI spec version: 1.0.0
 */

//@ts-nocheck 

 import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PlatformAcceptTeamInvitationBody,
  PlatformAddLocalUserBody,
  PlatformAlertCreate,
  PlatformAssetViewListLogsParams,
  PlatformAuthRegistryRequestParams,
  PlatformAuthenticateLocalUserBody,
  PlatformBadRequestResponse,
  PlatformBatchTableSchemasParams,
  PlatformBatchTableSchemasTeamParams,
  PlatformChangeLocalUserPasswordBody,
  PlatformConflictResponse,
  PlatformConnectorAuthFinishRequestAWS,
  PlatformConnectorAuthFinishRequestOAuth,
  PlatformConnectorAuthRequestAWS,
  PlatformConnectorAuthRequestGCP,
  PlatformConnectorAuthRequestOAuth,
  PlatformConnectorCreate,
  PlatformConnectorUpdate,
  PlatformCreateAWSOnboardingBody,
  PlatformCreateOrUpdatePolicy,
  PlatformCreatePluginVersionBody,
  PlatformCreatePluginVersionDocsBody,
  PlatformCreatePluginVersionTablesBody,
  PlatformCreateSyncRunProgressBody,
  PlatformCreateTeamAPIKeyBody,
  PlatformCreateTeamBody,
  PlatformCreateTeamImagesBody,
  PlatformCustomColumnCreateOrUpdate,
  PlatformCustomColumnDataImport,
  PlatformCustomColumnDataValues,
  PlatformDeletePluginVersionDocsBody,
  PlatformDeletePluginVersionTablesBody,
  PlatformDeleteTeamInvitationBody,
  PlatformDockerErrorResponse,
  PlatformExecuteAdHocQueryTeamBody,
  PlatformExecuteAdHocQueryTeamParams,
  PlatformExecuteSavedQueryTeamParams,
  PlatformFilterCreate,
  PlatformFilterUpdate,
  PlatformFinalizePluginUIAssetUploadBody,
  PlatformForbiddenResponse,
  PlatformGetCurrentUser401,
  PlatformGetCurrentUserMembershipsParams,
  PlatformGetGroupedTeamUsageSummaryParams,
  PlatformGetNotificationDestinationAlertsParams,
  PlatformGetPolicyViolationsHistoryParams,
  PlatformGetSyncDestinationTestConnectionLogs200One,
  PlatformGetSyncRunLogs200One,
  PlatformGetSyncRunLogsParams,
  PlatformGetSyncRunTablesParams,
  PlatformGetSyncSourceTestConnectionLogs200One,
  PlatformGetSyncTransformerTestConnectionLogs200One,
  PlatformGetTeamMembershipsParams,
  PlatformGetTeamUsageSummaryParams,
  PlatformIndex400,
  PlatformInternalErrorResponse,
  PlatformListAllAlertsParams,
  PlatformListAllCustomColumnsParams,
  PlatformListAllFrameworksParams,
  PlatformListAllNotificationDestinationsParams,
  PlatformListAllQueriesTeamParams,
  PlatformListAuditLogsParams,
  PlatformListConnectorsParams,
  PlatformListCurrentUserInvitationsParams,
  PlatformListFilterTagsParams,
  PlatformListFilterTagsTeamParams,
  PlatformListFiltersParams,
  PlatformListFiltersTeamParams,
  PlatformListLocalUsersParams,
  PlatformListPlatformVersionsParams,
  PlatformListPluginVersionDocsParams,
  PlatformListPluginVersionTablesParams,
  PlatformListPluginVersionsParams,
  PlatformListPluginsByTeamParams,
  PlatformListPluginsParams,
  PlatformListPoliciesParams,
  PlatformListPolicyFrameworksParams,
  PlatformListPolicyRuleDetailsParams,
  PlatformListPolicyRulesParams,
  PlatformListQueryTagsTeamParams,
  PlatformListReportTemplatesParams,
  PlatformListReportsParams,
  PlatformListSyncDestinationSyncsParams,
  PlatformListSyncDestinationsParams,
  PlatformListSyncRunsParams,
  PlatformListSyncSourceSyncsParams,
  PlatformListSyncSourcesParams,
  PlatformListSyncTransformerSyncDestinationsParams,
  PlatformListSyncTransformerSyncsParams,
  PlatformListSyncTransformersParams,
  PlatformListSyncUpgradesParams,
  PlatformListSyncsParams,
  PlatformListTablesParams,
  PlatformListTablesTeamParams,
  PlatformListTeamAPIKeysParams,
  PlatformListTeamInvitationsParams,
  PlatformListTeamsParams,
  PlatformListUserSnapshotsParams,
  PlatformListUsersByTeamParams,
  PlatformLoginUserBody,
  PlatformManageAddTeamMemberBody,
  PlatformManageListAllTeamsParams,
  PlatformManageListTeamMembersParams,
  PlatformManageRegisterPlatformBody,
  PlatformManageRegisterPlatformWithOfflineLicenseBody,
  PlatformManageRemoveTeamMemberBody,
  PlatformMethodNotAllowedResponse,
  PlatformNotFoundResponse,
  PlatformNotificationDestinationCreate,
  PlatformNotificationDestinationData,
  PlatformNotificationDestinationUpdate,
  PlatformOnboardingAWSNotification,
  PlatformOnboardingAWSProvision,
  PlatformPluginCreate,
  PlatformPluginUpdate,
  PlatformPluginVersionUpdate,
  PlatformPromoteSyncDestinationTestConnection,
  PlatformPromoteSyncSourceTestConnection,
  PlatformPromoteSyncTransformerTestConnection,
  PlatformQueryCreate,
  PlatformQueryListFilterTagsTeamParams,
  PlatformQueryListFiltersTeamParams,
  PlatformQueryUpdate,
  PlatformRemoveTeamMembershipBody,
  PlatformReplacePluginVersionDocsBody,
  PlatformReportCreateOrUpdate,
  PlatformReportTemplateCreateOrUpdate,
  PlatformRequiresAuthenticationResponse,
  PlatformResetLocalUserPasswordBody,
  PlatformSAMLConfigUpdate,
  PlatformSendAnonymousEventBody,
  PlatformSendUserEventBody,
  PlatformSyncCreate,
  PlatformSyncDestinationTestConnectionCreate,
  PlatformSyncDestinationUpdate,
  PlatformSyncSourceTestConnectionCreate,
  PlatformSyncSourceUpdate,
  PlatformSyncTransformerTestConnectionCreate,
  PlatformSyncTransformerUpdate,
  PlatformSyncUpdate,
  PlatformTableColumnListValuesParams,
  PlatformTableColumnListValuesTeamParams,
  PlatformTableListColumnsParams,
  PlatformTableListColumnsTeamParams,
  PlatformTableListFilterTagsParams,
  PlatformTableListFilterTagsTeamParams,
  PlatformTableListFiltersParams,
  PlatformTableListFiltersTeamParams,
  PlatformTableListRelationsParams,
  PlatformTableListRelationsTeamParams,
  PlatformTableListRowsParams,
  PlatformTableListRowsTeamParams,
  PlatformTableRowByIdParams,
  PlatformTableRowByIdTeamParams,
  PlatformTestUnsavedAlertParams,
  PlatformTogglePolicyParams,
  PlatformTooManyRequestsResponse,
  PlatformUnprocessableEntityResponse,
  PlatformUpdateCurrentUserBody,
  PlatformUpdateCustomerBody,
  PlatformUpdateLocalUserBody,
  PlatformUpdateSyncRunBody,
  PlatformUpdateSyncTestConnectionForSyncDestinationBody,
  PlatformUpdateSyncTestConnectionForSyncSourceBody,
  PlatformUpdateSyncTestConnectionForSyncTransformerBody,
  PlatformUpdateTeamBody,
  PlatformUpdateUserSnapshotBody,
  PlatformUploadImageBody,
  PlatformUploadPluginUIAssetsBody,
  PlatformUserSnapshotCreate
} from './models';

import {
  faker
} from '@faker-js/faker';

import {
  HttpResponse,
  delay,
  http
} from 'msw';

import {
  PlatformAPIKeyRole,
  PlatformAlertSeverity,
  PlatformAlertState,
  PlatformAssetViewRunType,
  PlatformConnectorStatus,
  PlatformCustomColumnColumnType,
  PlatformCustomColumnValueType,
  PlatformLocalUserProvider,
  PlatformPluginCategory,
  PlatformPluginKind,
  PlatformPluginPackageType,
  PlatformPluginPriceCategory,
  PlatformPluginReleaseStage,
  PlatformPluginTier,
  PlatformRole,
  PlatformSyncDestinationMigrateMode,
  PlatformSyncDestinationWriteMode,
  PlatformSyncLastUpdateSource,
  PlatformSyncRunStatus,
  PlatformSyncRunStatusReason,
  PlatformSyncRunWorkerPhase,
  PlatformSyncTestConnectionStatus,
  PlatformTableSchemaColumnKind,
  PlatformTeamPlan,
  PlatformUserSnapshotStatus,
  PlatformUserSnapshotStatusReason
} from './models';
import type {
  PlatformAPIKey,
  PlatformAssetViewGetStatus200,
  PlatformAssetViewListLogs200,
  PlatformAuditLogEvent,
  PlatformAuthenticateLocalUser200,
  PlatformBatchTableSchemas200,
  PlatformBatchTableSchemasTeam200,
  PlatformConnector,
  PlatformConnectorAuthResponseAWS,
  PlatformConnectorAuthResponseGCP,
  PlatformConnectorAuthResponseOAuth,
  PlatformCreateLocalUserResetToken200,
  PlatformCreatePluginVersionDocs201,
  PlatformCreatePluginVersionTables201,
  PlatformCreatePolicy201,
  PlatformCreateReport201,
  PlatformCreateReportTemplate201,
  PlatformCreateTeamImages201,
  PlatformCreateUserToken201,
  PlatformCustomColumn,
  PlatformExecuteAdHocQueryTeam200,
  PlatformExecuteSavedQueryTeam200,
  PlatformFilter,
  PlatformGetConnectorAuthStatusAWS200,
  PlatformGetConnectorAuthStatusGCP200,
  PlatformGetCurrentUser200,
  PlatformGetCurrentUserMemberships200,
  PlatformGetNotificationDestinationAlerts200,
  PlatformGetOpenAPIJSON200,
  PlatformGetPlatformInfo200,
  PlatformGetPolicy200,
  PlatformGetPolicyViolationsHistory200,
  PlatformGetReport200,
  PlatformGetReportTemplate200,
  PlatformGetSyncRunConnectorCredentials200,
  PlatformGetSyncRunConnectorIdentity200,
  PlatformGetSyncRunTables200,
  PlatformGetTeamMemberships200,
  PlatformGetTestConnectionConnectorCredentials200,
  PlatformGetTestConnectionConnectorIdentity200,
  PlatformImageURL,
  PlatformListAllAlerts200,
  PlatformListAllCustomColumns200,
  PlatformListAllFrameworks200,
  PlatformListAllNotificationDestinations200,
  PlatformListAllQueriesTeam200,
  PlatformListAuditLogs200,
  PlatformListConnectors200,
  PlatformListCurrentUserInvitations200,
  PlatformListFilterTags200,
  PlatformListFilterTagsTeam200,
  PlatformListFilters200,
  PlatformListFiltersTeam200,
  PlatformListLocalUsers200,
  PlatformListPlatformVersions200,
  PlatformListPlugin,
  PlatformListPluginVersionDocs200,
  PlatformListPluginVersionTables200,
  PlatformListPluginVersions200,
  PlatformListPlugins200,
  PlatformListPluginsByTeam200,
  PlatformListPolicies200,
  PlatformListPolicyFrameworks200,
  PlatformListPolicyRuleDetails200,
  PlatformListPolicyRules200,
  PlatformListQueryTagsTeam200,
  PlatformListReportTemplates200,
  PlatformListReports200,
  PlatformListSyncDestinationSyncs200,
  PlatformListSyncDestinations200,
  PlatformListSyncRuns200,
  PlatformListSyncSourceSyncs200,
  PlatformListSyncSources200,
  PlatformListSyncTransformerSyncDestinations200,
  PlatformListSyncTransformerSyncs200,
  PlatformListSyncTransformers200,
  PlatformListSyncUpgrades200,
  PlatformListSyncs200,
  PlatformListTables200,
  PlatformListTablesTeam200,
  PlatformListTeamAPIKeys200,
  PlatformListTeamInvitations200,
  PlatformListTeams200,
  PlatformListUserSnapshots200,
  PlatformListUsersByTeam200,
  PlatformLocalUser,
  PlatformLocalUserWithTeams,
  PlatformManageGetPlatformRegistry200,
  PlatformManageListAllTeams200,
  PlatformManageListTeamMembers200,
  PlatformManageRegisterPlatform200,
  PlatformManageRegisterPlatform205,
  PlatformManageRegisterPlatformWithOfflineLicense200,
  PlatformMembershipWithTeam,
  PlatformNotificationDestination,
  PlatformNotificationDestinationTestResponse,
  PlatformOnboardingAWS,
  PlatformOnboardingAWSAccounts,
  PlatformOnboardingAWSCreateResponse,
  PlatformPlugin,
  PlatformPluginAsset,
  PlatformPluginTableDetails,
  PlatformPluginVersion,
  PlatformPluginVersionDetails,
  PlatformPutCustomColumnData202,
  PlatformPutCustomColumnValues200,
  PlatformQueryDetail,
  PlatformQueryListFilterTagsTeam200,
  PlatformQueryListFiltersTeam200,
  PlatformRegistryAuthToken,
  PlatformReleaseURL,
  PlatformReplacePluginVersionDocs201,
  PlatformSAMLConfig,
  PlatformSync,
  PlatformSyncDestination,
  PlatformSyncDestinationTestConnection,
  PlatformSyncRun,
  PlatformSyncRunDetails,
  PlatformSyncRunStats,
  PlatformSyncSource,
  PlatformSyncSourceTestConnection,
  PlatformSyncTestConnection,
  PlatformSyncTransformer,
  PlatformSyncTransformerTestConnection,
  PlatformTableColumnListValues200,
  PlatformTableColumnListValuesTeam200,
  PlatformTableListColumns200,
  PlatformTableListColumnsTeam200,
  PlatformTableListFilterTags200,
  PlatformTableListFilterTagsTeam200,
  PlatformTableListFilters200,
  PlatformTableListFiltersTeam200,
  PlatformTableListRelations200,
  PlatformTableListRelationsTeam200,
  PlatformTableListRows200,
  PlatformTableListRowsTeam200,
  PlatformTableRowById200,
  PlatformTableRowByIdTeam200,
  PlatformTableSchema200,
  PlatformTableSchemaTeam200,
  PlatformTeam,
  PlatformTestUnsavedAlert200,
  PlatformUpdatePolicy200,
  PlatformUpdateReport200,
  PlatformUpdateReportTemplate200,
  PlatformUploadPluginUIAssets201,
  PlatformUsageSummary,
  PlatformUser,
  PlatformUserSnapshot
} from './models';

import { customFetch } from '../../utils/customFetch';
/**
 * Index endpoint, returns 200
 */
export const platformIndex = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformIndexQueryKey = () => {
    return [`/`] as const;
    }

    
export const getPlatformIndexQueryOptions = <TData = Awaited<ReturnType<typeof platformIndex>>, TError = PlatformIndex400>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformIndex>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformIndexQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformIndex>>> = ({ signal }) => platformIndex(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformIndex>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformIndexQueryResult = NonNullable<Awaited<ReturnType<typeof platformIndex>>>
export type PlatformIndexQueryError = PlatformIndex400



export function usePlatformIndex<TData = Awaited<ReturnType<typeof platformIndex>>, TError = PlatformIndex400>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformIndex>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformIndexQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List audit log events with pagination and filtering
 */
export const platformListAuditLogs = (
    params?: PlatformListAuditLogsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListAuditLogs200>(
      {url: `/audit-logs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListAuditLogsQueryKey = (params?: PlatformListAuditLogsParams,) => {
    return [`/audit-logs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAuditLogs>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(params?: PlatformListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAuditLogs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAuditLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAuditLogs>>> = ({ signal }) => platformListAuditLogs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAuditLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAuditLogs>>>
export type PlatformListAuditLogsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformListAuditLogs<TData = Awaited<ReturnType<typeof platformListAuditLogs>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 params?: PlatformListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAuditLogs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a specific audit log event by ID
 */
export const platformGetAuditLog = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformAuditLogEvent>(
      {url: `/audit-logs/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetAuditLogQueryKey = (id: string,) => {
    return [`/audit-logs/${id}`] as const;
    }

    
export const getPlatformGetAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAuditLog>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAuditLog>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAuditLogQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAuditLog>>> = ({ signal }) => platformGetAuditLog(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAuditLog>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAuditLog>>>
export type PlatformGetAuditLogQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAuditLog<TData = Awaited<ReturnType<typeof platformGetAuditLog>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAuditLog>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAuditLogQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Filters
 */
export const platformListFilters = (
    params?: PlatformListFiltersParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListFilters200>(
      {url: `/filters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListFiltersQueryKey = (params?: PlatformListFiltersParams,) => {
    return [`/filters`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListFiltersQueryOptions = <TData = Awaited<ReturnType<typeof platformListFilters>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params?: PlatformListFiltersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilters>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListFiltersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListFilters>>> = ({ signal }) => platformListFilters(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListFilters>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof platformListFilters>>>
export type PlatformListFiltersQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListFilters<TData = Awaited<ReturnType<typeof platformListFilters>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params?: PlatformListFiltersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilters>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Filter Tags
 */
export const platformListFilterTags = (
    params?: PlatformListFilterTagsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListFilterTags200>(
      {url: `/filters/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListFilterTagsQueryKey = (params?: PlatformListFilterTagsParams,) => {
    return [`/filters/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListFilterTagsQueryOptions = <TData = Awaited<ReturnType<typeof platformListFilterTags>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params?: PlatformListFilterTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTags>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListFilterTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListFilterTags>>> = ({ signal }) => platformListFilterTags(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTags>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListFilterTagsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListFilterTags>>>
export type PlatformListFilterTagsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListFilterTags<TData = Awaited<ReturnType<typeof platformListFilterTags>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params?: PlatformListFilterTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTags>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListFilterTagsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a table filter by ID
 */
export const platformGetFilterByID = (
    filterId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformFilter>(
      {url: `/filters/${filterId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetFilterByIDQueryKey = (filterId: string,) => {
    return [`/filters/${filterId}`] as const;
    }

    
export const getPlatformGetFilterByIDQueryOptions = <TData = Awaited<ReturnType<typeof platformGetFilterByID>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(filterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByID>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetFilterByIDQueryKey(filterId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetFilterByID>>> = ({ signal }) => platformGetFilterByID(filterId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(filterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByID>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetFilterByIDQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetFilterByID>>>
export type PlatformGetFilterByIDQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetFilterByID<TData = Awaited<ReturnType<typeof platformGetFilterByID>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 filterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByID>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetFilterByIDQueryOptions(filterId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a table filter
 */
export const platformUpdateFilter = (
    filterId: string,
    platformFilterUpdate: PlatformFilterUpdate,
 ) => {
      
      
      return customFetch<PlatformFilter>(
      {url: `/filters/${filterId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformFilterUpdate
    },
      );
    }
  


export const getPlatformUpdateFilterMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilter>>, TError,{filterId: string;data: PlatformFilterUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilter>>, TError,{filterId: string;data: PlatformFilterUpdate}, TContext> => {

const mutationKey = ['platformUpdateFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateFilter>>, {filterId: string;data: PlatformFilterUpdate}> = (props) => {
          const {filterId,data} = props ?? {};

          return  platformUpdateFilter(filterId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateFilterMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateFilter>>>
    export type PlatformUpdateFilterMutationBody = PlatformFilterUpdate
    export type PlatformUpdateFilterMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateFilter = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilter>>, TError,{filterId: string;data: PlatformFilterUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateFilter>>,
        TError,
        {filterId: string;data: PlatformFilterUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateFilterMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a table filter
 */
export const platformDeleteFilter = (
    filterId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/filters/${filterId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteFilterMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilter>>, TError,{filterId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilter>>, TError,{filterId: string}, TContext> => {

const mutationKey = ['platformDeleteFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteFilter>>, {filterId: string}> = (props) => {
          const {filterId} = props ?? {};

          return  platformDeleteFilter(filterId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteFilterMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteFilter>>>
    
    export type PlatformDeleteFilterMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteFilter = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilter>>, TError,{filterId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteFilter>>,
        TError,
        {filterId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteFilterMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Health check endpoint, returns 200
 */
export const platformHealthCheckHead = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/healthcheck`, method: 'HEAD', signal
    },
      );
    }
  


export const getPlatformHealthCheckHeadMutationOptions = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformHealthCheckHead>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformHealthCheckHead>>, TError,void, TContext> => {

const mutationKey = ['platformHealthCheckHead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformHealthCheckHead>>, void> = () => {
          

          return  platformHealthCheckHead()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformHealthCheckHeadMutationResult = NonNullable<Awaited<ReturnType<typeof platformHealthCheckHead>>>
    
    export type PlatformHealthCheckHeadMutationError = PlatformBadRequestResponse | PlatformInternalErrorResponse

    export const usePlatformHealthCheckHead = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformHealthCheckHead>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformHealthCheckHead>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPlatformHealthCheckHeadMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Health check endpoint, returns 200
 */
export const platformHealthCheck = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/healthcheck`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformHealthCheckQueryKey = () => {
    return [`/healthcheck`] as const;
    }

    
export const getPlatformHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof platformHealthCheck>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformHealthCheck>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformHealthCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformHealthCheck>>> = ({ signal }) => platformHealthCheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformHealthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformHealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof platformHealthCheck>>>
export type PlatformHealthCheckQueryError = PlatformBadRequestResponse | PlatformInternalErrorResponse



export function usePlatformHealthCheck<TData = Awaited<ReturnType<typeof platformHealthCheck>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformHealthCheck>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the OpenAPI definition in JSON format.
 * @summary Get OpenAPI JSON
 */
export const platformGetOpenAPIJSON = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetOpenAPIJSON200>(
      {url: `/openapi.json`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetOpenAPIJSONQueryKey = () => {
    return [`/openapi.json`] as const;
    }

    
export const getPlatformGetOpenAPIJSONQueryOptions = <TData = Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError = PlatformBadRequestResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetOpenAPIJSONQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>> = ({ signal }) => platformGetOpenAPIJSON(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetOpenAPIJSONQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>>
export type PlatformGetOpenAPIJSONQueryError = PlatformBadRequestResponse


/**
 * @summary Get OpenAPI JSON
 */

export function usePlatformGetOpenAPIJSON<TData = Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError = PlatformBadRequestResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetOpenAPIJSON>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetOpenAPIJSONQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get assetview status
 */
export const platformAssetViewGetStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformAssetViewGetStatus200>(
      {url: `/manage/assetview`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformAssetViewGetStatusQueryKey = () => {
    return [`/manage/assetview`] as const;
    }

    
export const getPlatformAssetViewGetStatusQueryOptions = <TData = Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformAssetViewGetStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAssetViewGetStatus>>> = ({ signal }) => platformAssetViewGetStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformAssetViewGetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof platformAssetViewGetStatus>>>
export type PlatformAssetViewGetStatusQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformAssetViewGetStatus<TData = Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewGetStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformAssetViewGetStatusQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trigger assetview run
 */
export const platformAssetViewTrigger = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/manage/assetview`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformAssetViewTriggerMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAssetViewTrigger>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAssetViewTrigger>>, TError,void, TContext> => {

const mutationKey = ['platformAssetViewTrigger'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAssetViewTrigger>>, void> = () => {
          

          return  platformAssetViewTrigger()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAssetViewTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof platformAssetViewTrigger>>>
    
    export type PlatformAssetViewTriggerMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAssetViewTrigger = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAssetViewTrigger>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAssetViewTrigger>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPlatformAssetViewTriggerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List asset view logs
 */
export const platformAssetViewListLogs = (
    params?: PlatformAssetViewListLogsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformAssetViewListLogs200>(
      {url: `/manage/assetview/logs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformAssetViewListLogsQueryKey = (params?: PlatformAssetViewListLogsParams,) => {
    return [`/manage/assetview/logs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformAssetViewListLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(params?: PlatformAssetViewListLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformAssetViewListLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAssetViewListLogs>>> = ({ signal }) => platformAssetViewListLogs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformAssetViewListLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformAssetViewListLogs>>>
export type PlatformAssetViewListLogsQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformAssetViewListLogs<TData = Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 params?: PlatformAssetViewListLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAssetViewListLogs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformAssetViewListLogsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get SAML integration information
 */
export const platformManageGetSAML = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSAMLConfig>(
      {url: `/manage/auth/saml`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformManageGetSAMLQueryKey = () => {
    return [`/manage/auth/saml`] as const;
    }

    
export const getPlatformManageGetSAMLQueryOptions = <TData = Awaited<ReturnType<typeof platformManageGetSAML>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetSAML>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageGetSAMLQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageGetSAML>>> = ({ signal }) => platformManageGetSAML(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageGetSAML>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageGetSAMLQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageGetSAML>>>
export type PlatformManageGetSAMLQueryError = PlatformBadRequestResponse | PlatformInternalErrorResponse



export function usePlatformManageGetSAML<TData = Awaited<ReturnType<typeof platformManageGetSAML>>, TError = PlatformBadRequestResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetSAML>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageGetSAMLQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update SAML integration information
 */
export const platformManageUpdateSAML = (
    platformSAMLConfigUpdate: PlatformSAMLConfigUpdate,
 ) => {
      
      
      return customFetch<PlatformSAMLConfig>(
      {url: `/manage/auth/saml`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformSAMLConfigUpdate
    },
      );
    }
  


export const getPlatformManageUpdateSAMLMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageUpdateSAML>>, TError,{data: PlatformSAMLConfigUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformManageUpdateSAML>>, TError,{data: PlatformSAMLConfigUpdate}, TContext> => {

const mutationKey = ['platformManageUpdateSAML'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageUpdateSAML>>, {data: PlatformSAMLConfigUpdate}> = (props) => {
          const {data} = props ?? {};

          return  platformManageUpdateSAML(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageUpdateSAMLMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageUpdateSAML>>>
    export type PlatformManageUpdateSAMLMutationBody = PlatformSAMLConfigUpdate
    export type PlatformManageUpdateSAMLMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageUpdateSAML = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageUpdateSAML>>, TError,{data: PlatformSAMLConfigUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageUpdateSAML>>,
        TError,
        {data: PlatformSAMLConfigUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformManageUpdateSAMLMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get platform registry information
 */
export const platformManageGetPlatformRegistry = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformManageGetPlatformRegistry200>(
      {url: `/manage/register-platform`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformManageGetPlatformRegistryQueryKey = () => {
    return [`/manage/register-platform`] as const;
    }

    
export const getPlatformManageGetPlatformRegistryQueryOptions = <TData = Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageGetPlatformRegistryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>> = ({ signal }) => platformManageGetPlatformRegistry(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageGetPlatformRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>>
export type PlatformManageGetPlatformRegistryQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse



export function usePlatformManageGetPlatformRegistry<TData = Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetPlatformRegistry>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageGetPlatformRegistryQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Register platform usage by API key
 */
export const platformManageRegisterPlatform = (
    platformManageRegisterPlatformBody: PlatformManageRegisterPlatformBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205>(
      {url: `/manage/register-platform`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformManageRegisterPlatformBody, signal
    },
      );
    }
  


export const getPlatformManageRegisterPlatformMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, TError,{data: PlatformManageRegisterPlatformBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, TError,{data: PlatformManageRegisterPlatformBody}, TContext> => {

const mutationKey = ['platformManageRegisterPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, {data: PlatformManageRegisterPlatformBody}> = (props) => {
          const {data} = props ?? {};

          return  platformManageRegisterPlatform(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageRegisterPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageRegisterPlatform>>>
    export type PlatformManageRegisterPlatformMutationBody = PlatformManageRegisterPlatformBody
    export type PlatformManageRegisterPlatformMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformManageRegisterPlatform = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatform>>, TError,{data: PlatformManageRegisterPlatformBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageRegisterPlatform>>,
        TError,
        {data: PlatformManageRegisterPlatformBody},
        TContext
      > => {

      const mutationOptions = getPlatformManageRegisterPlatformMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Register platform usage by offline license
 */
export const platformManageRegisterPlatformWithOfflineLicense = (
    platformManageRegisterPlatformWithOfflineLicenseBody: PlatformManageRegisterPlatformWithOfflineLicenseBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformManageRegisterPlatformWithOfflineLicense200>(
      {url: `/manage/register-platform/offline`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformManageRegisterPlatformWithOfflineLicenseBody, signal
    },
      );
    }
  


export const getPlatformManageRegisterPlatformWithOfflineLicenseMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, TError,{data: PlatformManageRegisterPlatformWithOfflineLicenseBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, TError,{data: PlatformManageRegisterPlatformWithOfflineLicenseBody}, TContext> => {

const mutationKey = ['platformManageRegisterPlatformWithOfflineLicense'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, {data: PlatformManageRegisterPlatformWithOfflineLicenseBody}> = (props) => {
          const {data} = props ?? {};

          return  platformManageRegisterPlatformWithOfflineLicense(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageRegisterPlatformWithOfflineLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>>
    export type PlatformManageRegisterPlatformWithOfflineLicenseMutationBody = PlatformManageRegisterPlatformWithOfflineLicenseBody
    export type PlatformManageRegisterPlatformWithOfflineLicenseMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformManageRegisterPlatformWithOfflineLicense = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>, TError,{data: PlatformManageRegisterPlatformWithOfflineLicenseBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageRegisterPlatformWithOfflineLicense>>,
        TError,
        {data: PlatformManageRegisterPlatformWithOfflineLicenseBody},
        TContext
      > => {

      const mutationOptions = getPlatformManageRegisterPlatformWithOfflineLicenseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all teams
 */
export const platformManageListAllTeams = (
    params?: PlatformManageListAllTeamsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformManageListAllTeams200>(
      {url: `/manage/teams`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformManageListAllTeamsQueryKey = (params?: PlatformManageListAllTeamsParams,) => {
    return [`/manage/teams`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformManageListAllTeamsQueryOptions = <TData = Awaited<ReturnType<typeof platformManageListAllTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params?: PlatformManageListAllTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListAllTeams>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageListAllTeamsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageListAllTeams>>> = ({ signal }) => platformManageListAllTeams(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageListAllTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageListAllTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageListAllTeams>>>
export type PlatformManageListAllTeamsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformManageListAllTeams<TData = Awaited<ReturnType<typeof platformManageListAllTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params?: PlatformManageListAllTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListAllTeams>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageListAllTeamsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a team
 */
export const platformManageGetTeam = (
    teamName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTeam>(
      {url: `/manage/teams/${teamName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformManageGetTeamQueryKey = (teamName: string,) => {
    return [`/manage/teams/${teamName}`] as const;
    }

    
export const getPlatformManageGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformManageGetTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageGetTeamQueryKey(teamName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageGetTeam>>> = ({ signal }) => platformManageGetTeam(teamName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageGetTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageGetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageGetTeam>>>
export type PlatformManageGetTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformManageGetTeam<TData = Awaited<ReturnType<typeof platformManageGetTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageGetTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageGetTeamQueryOptions(teamName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete a team
 */
export const platformManageDeleteTeam = (
    teamName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/manage/teams/${teamName}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformManageDeleteTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageDeleteTeam>>, TError,{teamName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformManageDeleteTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['platformManageDeleteTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageDeleteTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  platformManageDeleteTeam(teamName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageDeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageDeleteTeam>>>
    
    export type PlatformManageDeleteTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageDeleteTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageDeleteTeam>>, TError,{teamName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageDeleteTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {

      const mutationOptions = getPlatformManageDeleteTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List team members
 */
export const platformManageListTeamMembers = (
    teamName: string,
    params?: PlatformManageListTeamMembersParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformManageListTeamMembers200>(
      {url: `/manage/teams/${teamName}/members`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformManageListTeamMembersQueryKey = (teamName: string,
    params?: PlatformManageListTeamMembersParams,) => {
    return [`/manage/teams/${teamName}/members`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformManageListTeamMembersQueryOptions = <TData = Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformManageListTeamMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformManageListTeamMembersQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformManageListTeamMembers>>> = ({ signal }) => platformManageListTeamMembers(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformManageListTeamMembersQueryResult = NonNullable<Awaited<ReturnType<typeof platformManageListTeamMembers>>>
export type PlatformManageListTeamMembersQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformManageListTeamMembers<TData = Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformManageListTeamMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformManageListTeamMembers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformManageListTeamMembersQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Add team member
 */
export const platformManageAddTeamMember = (
    teamName: string,
    platformManageAddTeamMemberBody: PlatformManageAddTeamMemberBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/manage/teams/${teamName}/members`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformManageAddTeamMemberBody
    },
      );
    }
  


export const getPlatformManageAddTeamMemberMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageAddTeamMember>>, TError,{teamName: string;data: PlatformManageAddTeamMemberBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformManageAddTeamMember>>, TError,{teamName: string;data: PlatformManageAddTeamMemberBody}, TContext> => {

const mutationKey = ['platformManageAddTeamMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageAddTeamMember>>, {teamName: string;data: PlatformManageAddTeamMemberBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformManageAddTeamMember(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageAddTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageAddTeamMember>>>
    export type PlatformManageAddTeamMemberMutationBody = PlatformManageAddTeamMemberBody
    export type PlatformManageAddTeamMemberMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageAddTeamMember = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageAddTeamMember>>, TError,{teamName: string;data: PlatformManageAddTeamMemberBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageAddTeamMember>>,
        TError,
        {teamName: string;data: PlatformManageAddTeamMemberBody},
        TContext
      > => {

      const mutationOptions = getPlatformManageAddTeamMemberMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Remove team member
 */
export const platformManageRemoveTeamMember = (
    teamName: string,
    platformManageRemoveTeamMemberBody: PlatformManageRemoveTeamMemberBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/manage/teams/${teamName}/members`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: platformManageRemoveTeamMemberBody
    },
      );
    }
  


export const getPlatformManageRemoveTeamMemberMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, TError,{teamName: string;data: PlatformManageRemoveTeamMemberBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, TError,{teamName: string;data: PlatformManageRemoveTeamMemberBody}, TContext> => {

const mutationKey = ['platformManageRemoveTeamMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, {teamName: string;data: PlatformManageRemoveTeamMemberBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformManageRemoveTeamMember(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformManageRemoveTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>>
    export type PlatformManageRemoveTeamMemberMutationBody = PlatformManageRemoveTeamMemberBody
    export type PlatformManageRemoveTeamMemberMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformManageRemoveTeamMember = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformManageRemoveTeamMember>>, TError,{teamName: string;data: PlatformManageRemoveTeamMemberBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformManageRemoveTeamMember>>,
        TError,
        {teamName: string;data: PlatformManageRemoveTeamMemberBody},
        TContext
      > => {

      const mutationOptions = getPlatformManageRemoveTeamMemberMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all users
 */
export const platformListLocalUsers = (
    params?: PlatformListLocalUsersParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListLocalUsers200>(
      {url: `/manage/users`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListLocalUsersQueryKey = (params?: PlatformListLocalUsersParams,) => {
    return [`/manage/users`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListLocalUsersQueryOptions = <TData = Awaited<ReturnType<typeof platformListLocalUsers>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params?: PlatformListLocalUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListLocalUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListLocalUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListLocalUsers>>> = ({ signal }) => platformListLocalUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListLocalUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListLocalUsersQueryResult = NonNullable<Awaited<ReturnType<typeof platformListLocalUsers>>>
export type PlatformListLocalUsersQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListLocalUsers<TData = Awaited<ReturnType<typeof platformListLocalUsers>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params?: PlatformListLocalUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListLocalUsers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListLocalUsersQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Add new user
 */
export const platformAddLocalUser = (
    platformAddLocalUserBody: PlatformAddLocalUserBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformLocalUser>(
      {url: `/manage/users/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformAddLocalUserBody, signal
    },
      );
    }
  


export const getPlatformAddLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddLocalUser>>, TError,{data: PlatformAddLocalUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAddLocalUser>>, TError,{data: PlatformAddLocalUserBody}, TContext> => {

const mutationKey = ['platformAddLocalUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAddLocalUser>>, {data: PlatformAddLocalUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformAddLocalUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAddLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformAddLocalUser>>>
    export type PlatformAddLocalUserMutationBody = PlatformAddLocalUserBody
    export type PlatformAddLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAddLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAddLocalUser>>, TError,{data: PlatformAddLocalUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAddLocalUser>>,
        TError,
        {data: PlatformAddLocalUserBody},
        TContext
      > => {

      const mutationOptions = getPlatformAddLocalUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get user details
 */
export const platformGetLocalUser = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformLocalUserWithTeams>(
      {url: `/manage/users/${userId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetLocalUserQueryKey = (userId: string,) => {
    return [`/manage/users/${userId}`] as const;
    }

    
export const getPlatformGetLocalUserQueryOptions = <TData = Awaited<ReturnType<typeof platformGetLocalUser>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetLocalUser>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetLocalUserQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetLocalUser>>> = ({ signal }) => platformGetLocalUser(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetLocalUser>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetLocalUserQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetLocalUser>>>
export type PlatformGetLocalUserQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetLocalUser<TData = Awaited<ReturnType<typeof platformGetLocalUser>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetLocalUser>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetLocalUserQueryOptions(userId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update user
 */
export const platformUpdateLocalUser = (
    userId: string,
    platformUpdateLocalUserBody: PlatformUpdateLocalUserBody,
 ) => {
      
      
      return customFetch<PlatformLocalUser>(
      {url: `/manage/users/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateLocalUserBody
    },
      );
    }
  


export const getPlatformUpdateLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateLocalUser>>, TError,{userId: string;data: PlatformUpdateLocalUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateLocalUser>>, TError,{userId: string;data: PlatformUpdateLocalUserBody}, TContext> => {

const mutationKey = ['platformUpdateLocalUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateLocalUser>>, {userId: string;data: PlatformUpdateLocalUserBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  platformUpdateLocalUser(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateLocalUser>>>
    export type PlatformUpdateLocalUserMutationBody = PlatformUpdateLocalUserBody
    export type PlatformUpdateLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateLocalUser>>, TError,{userId: string;data: PlatformUpdateLocalUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateLocalUser>>,
        TError,
        {userId: string;data: PlatformUpdateLocalUserBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateLocalUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete user
 */
export const platformDeleteLocalUser = (
    userId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/manage/users/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteLocalUser>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteLocalUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['platformDeleteLocalUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteLocalUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  platformDeleteLocalUser(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteLocalUser>>>
    
    export type PlatformDeleteLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteLocalUser>>, TError,{userId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteLocalUser>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteLocalUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Create password reset token for user
 */
export const platformCreateLocalUserResetToken = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCreateLocalUserResetToken200>(
      {url: `/manage/users/${userId}/reset`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformCreateLocalUserResetTokenMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, TError,{userId: string}, TContext> => {

const mutationKey = ['platformCreateLocalUserResetToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  platformCreateLocalUserResetToken(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateLocalUserResetTokenMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>>
    
    export type PlatformCreateLocalUserResetTokenMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateLocalUserResetToken = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>, TError,{userId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateLocalUserResetToken>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPlatformCreateLocalUserResetTokenMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Information about the platform
 */
export const platformGetPlatformInfo = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetPlatformInfo200>(
      {url: `/platform-info`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetPlatformInfoQueryKey = () => {
    return [`/platform-info`] as const;
    }

    
export const getPlatformGetPlatformInfoQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPlatformInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPlatformInfo>>> = ({ signal }) => platformGetPlatformInfo(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPlatformInfoQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPlatformInfo>>>
export type PlatformGetPlatformInfoQueryError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse



export function usePlatformGetPlatformInfo<TData = Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlatformInfo>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPlatformInfoQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List platform versions
 */
export const platformListPlatformVersions = (
    params?: PlatformListPlatformVersionsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPlatformVersions200>(
      {url: `/platform-versions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPlatformVersionsQueryKey = (params?: PlatformListPlatformVersionsParams,) => {
    return [`/platform-versions`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPlatformVersionsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPlatformVersions>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(params?: PlatformListPlatformVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlatformVersions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPlatformVersionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPlatformVersions>>> = ({ signal }) => platformListPlatformVersions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPlatformVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPlatformVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPlatformVersions>>>
export type PlatformListPlatformVersionsQueryError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse



export function usePlatformListPlatformVersions<TData = Awaited<ReturnType<typeof platformListPlatformVersions>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(
 params?: PlatformListPlatformVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlatformVersions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPlatformVersionsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all plugins
 */
export const platformListPlugins = (
    params?: PlatformListPluginsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPlugins200>(
      {url: `/plugins`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPluginsQueryKey = (params?: PlatformListPluginsParams,) => {
    return [`/plugins`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPluginsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPlugins>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(params?: PlatformListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlugins>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPlugins>>> = ({ signal }) => platformListPlugins(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPlugins>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPlugins>>>
export type PlatformListPluginsQueryError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse



export function usePlatformListPlugins<TData = Awaited<ReturnType<typeof platformListPlugins>>, TError = PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse>(
 params?: PlatformListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPlugins>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a plugin owned by the specified team. User must be part of that team.
 */
export const platformCreatePlugin = (
    platformPluginCreate: PlatformPluginCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformPlugin>(
      {url: `/plugins`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformPluginCreate, signal
    },
      );
    }
  


export const getPlatformCreatePluginMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePlugin>>, TError,{data: PlatformPluginCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePlugin>>, TError,{data: PlatformPluginCreate}, TContext> => {

const mutationKey = ['platformCreatePlugin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePlugin>>, {data: PlatformPluginCreate}> = (props) => {
          const {data} = props ?? {};

          return  platformCreatePlugin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePlugin>>>
    export type PlatformCreatePluginMutationBody = PlatformPluginCreate
    export type PlatformCreatePluginMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePlugin = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePlugin>>, TError,{data: PlatformPluginCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePlugin>>,
        TError,
        {data: PlatformPluginCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreatePluginMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get details about a given plugin.
 */
export const platformGetPlugin = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPlugin>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetPluginQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}`] as const;
    }

    
export const getPlatformGetPluginQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPlugin>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlugin>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPluginQueryKey(teamName,pluginKind,pluginName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPlugin>>> = ({ signal }) => platformGetPlugin(teamName,pluginKind,pluginName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPlugin>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPluginQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPlugin>>>
export type PlatformGetPluginQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetPlugin<TData = Awaited<ReturnType<typeof platformGetPlugin>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPlugin>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPluginQueryOptions(teamName,pluginKind,pluginName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a plugin
 */
export const platformUpdatePlugin = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    platformPluginUpdate: PlatformPluginUpdate,
 ) => {
      
      
      return customFetch<PlatformPlugin>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformPluginUpdate
    },
      );
    }
  


export const getPlatformUpdatePluginMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}, TContext> => {

const mutationKey = ['platformUpdatePlugin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdatePlugin>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,data} = props ?? {};

          return  platformUpdatePlugin(teamName,pluginKind,pluginName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdatePlugin>>>
    export type PlatformUpdatePluginMutationBody = PlatformPluginUpdate
    export type PlatformUpdatePluginMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdatePlugin = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdatePlugin>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PlatformPluginUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdatePluginMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete plugin by team and plugin name
 */
export const platformDeletePluginByTeamAndPluginName = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeletePluginByTeamAndPluginNameMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['platformDeletePluginByTeamAndPluginName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {teamName,pluginKind,pluginName} = props ?? {};

          return  platformDeletePluginByTeamAndPluginName(teamName,pluginKind,pluginName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginByTeamAndPluginNameMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>>
    
    export type PlatformDeletePluginByTeamAndPluginNameMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginByTeamAndPluginName = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginByTeamAndPluginName>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeletePluginByTeamAndPluginNameMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all versions for a given plugin
 */
export const platformListPluginVersions = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPluginVersions200>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPluginVersionsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPluginVersionsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginVersions>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginVersionsQueryKey(teamName,pluginKind,pluginName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginVersions>>> = ({ signal }) => platformListPluginVersions(teamName,pluginKind,pluginName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginVersions>>>
export type PlatformListPluginVersionsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginVersions<TData = Awaited<ReturnType<typeof platformListPluginVersions>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: PlatformListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginVersionsQueryOptions(teamName,pluginKind,pluginName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get details about a given plugin version.
 */
export const platformGetPluginVersion = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformPluginVersionDetails>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetPluginVersionQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`] as const;
    }

    
export const getPlatformGetPluginVersionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPluginVersion>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersion>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPluginVersionQueryKey(teamName,pluginKind,pluginName,versionName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPluginVersion>>> = ({ signal }) => platformGetPluginVersion(teamName,pluginKind,pluginName,versionName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPluginVersionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPluginVersion>>>
export type PlatformGetPluginVersionQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetPluginVersion<TData = Awaited<ReturnType<typeof platformGetPluginVersion>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersion>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPluginVersionQueryOptions(teamName,pluginKind,pluginName,versionName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new plugin version, or update a draft version
 */
export const platformCreatePluginVersion = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformCreatePluginVersionBody: PlatformCreatePluginVersionBody,
 ) => {
      
      
      return customFetch<PlatformPluginVersion>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformCreatePluginVersionBody
    },
      );
    }
  


export const getPlatformCreatePluginVersionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}, TContext> => {

const mutationKey = ['platformCreatePluginVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformCreatePluginVersion(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePluginVersion>>>
    export type PlatformCreatePluginVersionMutationBody = PlatformCreatePluginVersionBody
    export type PlatformCreatePluginVersionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePluginVersion = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreatePluginVersionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Update a given plugin version
 */
export const platformUpdatePluginVersion = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformPluginVersionUpdate: PlatformPluginVersionUpdate,
 ) => {
      
      
      return customFetch<PlatformPluginVersion>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformPluginVersionUpdate
    },
      );
    }
  


export const getPlatformUpdatePluginVersionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}, TContext> => {

const mutationKey = ['platformUpdatePluginVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformUpdatePluginVersion(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdatePluginVersion>>>
    export type PlatformUpdatePluginVersionMutationBody = PlatformPluginVersionUpdate
    export type PlatformUpdatePluginVersionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdatePluginVersion = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdatePluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformPluginVersionUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdatePluginVersionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Download an asset for a given plugin version and target
 */
export const platformDownloadPluginAsset = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformPluginAsset>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformDownloadPluginAssetQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`] as const;
    }

    
export const getPlatformDownloadPluginAssetQueryOptions = <TData = Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformDownloadPluginAssetQueryKey(teamName,pluginKind,pluginName,versionName,targetName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformDownloadPluginAsset>>> = ({ signal }) => platformDownloadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformDownloadPluginAssetQueryResult = NonNullable<Awaited<ReturnType<typeof platformDownloadPluginAsset>>>
export type PlatformDownloadPluginAssetQueryError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse



export function usePlatformDownloadPluginAsset<TData = Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAsset>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformDownloadPluginAssetQueryOptions(teamName,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a URL to upload an asset for a given plugin version and target
 */
export const platformUploadPluginAsset = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformReleaseURL>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformUploadPluginAssetMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext> => {

const mutationKey = ['platformUploadPluginAsset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUploadPluginAsset>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,targetName} = props ?? {};

          return  platformUploadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUploadPluginAssetMutationResult = NonNullable<Awaited<ReturnType<typeof platformUploadPluginAsset>>>
    
    export type PlatformUploadPluginAssetMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformUploadPluginAsset = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUploadPluginAsset>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string},
        TContext
      > => {

      const mutationOptions = getPlatformUploadPluginAssetMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all documentation pages for a given plugin version
 */
export const platformListPluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPluginVersionDocs200>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPluginVersionDocsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPluginVersionDocsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginVersionDocsQueryKey(teamName,pluginKind,pluginName,versionName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginVersionDocs>>> = ({ signal }) => platformListPluginVersionDocs(teamName,pluginKind,pluginName,versionName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginVersionDocsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginVersionDocs>>>
export type PlatformListPluginVersionDocsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginVersionDocs<TData = Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionDocs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginVersionDocsQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create or update one or more plugin version docs pages
 */
export const platformCreatePluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformCreatePluginVersionDocsBody: PlatformCreatePluginVersionDocsBody,
 ) => {
      
      
      return customFetch<PlatformCreatePluginVersionDocs201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformCreatePluginVersionDocsBody
    },
      );
    }
  


export const getPlatformCreatePluginVersionDocsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}, TContext> => {

const mutationKey = ['platformCreatePluginVersionDocs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformCreatePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>>
    export type PlatformCreatePluginVersionDocsMutationBody = PlatformCreatePluginVersionDocsBody
    export type PlatformCreatePluginVersionDocsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePluginVersionDocs = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionDocsBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreatePluginVersionDocsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Replace (override) multiple plugin version docs pages
 */
export const platformReplacePluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformReplacePluginVersionDocsBody: PlatformReplacePluginVersionDocsBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformReplacePluginVersionDocs201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformReplacePluginVersionDocsBody, signal
    },
      );
    }
  


export const getPlatformReplacePluginVersionDocsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}, TContext> => {

const mutationKey = ['platformReplacePluginVersionDocs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformReplacePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformReplacePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>>
    export type PlatformReplacePluginVersionDocsMutationBody = PlatformReplacePluginVersionDocsBody
    export type PlatformReplacePluginVersionDocsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformReplacePluginVersionDocs = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformReplacePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformReplacePluginVersionDocsBody},
        TContext
      > => {

      const mutationOptions = getPlatformReplacePluginVersionDocsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete one or more plugin version docs pages.
 */
export const platformDeletePluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformDeletePluginVersionDocsBody: PlatformDeletePluginVersionDocsBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: platformDeletePluginVersionDocsBody
    },
      );
    }
  


export const getPlatformDeletePluginVersionDocsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}, TContext> => {

const mutationKey = ['platformDeletePluginVersionDocs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformDeletePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>>
    export type PlatformDeletePluginVersionDocsMutationBody = PlatformDeletePluginVersionDocsBody
    export type PlatformDeletePluginVersionDocsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginVersionDocs = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionDocsBody},
        TContext
      > => {

      const mutationOptions = getPlatformDeletePluginVersionDocsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List tables for a given plugin version. This only applies to source plugins.
 */
export const platformListPluginVersionTables = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPluginVersionTables200>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPluginVersionTablesQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPluginVersionTablesQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginVersionTablesQueryKey(teamName,pluginKind,pluginName,versionName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginVersionTables>>> = ({ signal }) => platformListPluginVersionTables(teamName,pluginKind,pluginName,versionName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginVersionTablesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginVersionTables>>>
export type PlatformListPluginVersionTablesQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginVersionTables<TData = Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: PlatformListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginVersionTables>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginVersionTablesQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create or update one or more plugin version tables. This only applies to source plugins, and can only be done if the plugin version is in draft.
 */
export const platformCreatePluginVersionTables = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformCreatePluginVersionTablesBody: PlatformCreatePluginVersionTablesBody,
 ) => {
      
      
      return customFetch<PlatformCreatePluginVersionTables201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformCreatePluginVersionTablesBody
    },
      );
    }
  


export const getPlatformCreatePluginVersionTablesMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}, TContext> => {

const mutationKey = ['platformCreatePluginVersionTables'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformCreatePluginVersionTables(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>>
    export type PlatformCreatePluginVersionTablesMutationBody = PlatformCreatePluginVersionTablesBody
    export type PlatformCreatePluginVersionTablesMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreatePluginVersionTables = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformCreatePluginVersionTablesBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreatePluginVersionTablesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete one or more plugin version tables.
 */
export const platformDeletePluginVersionTables = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformDeletePluginVersionTablesBody: PlatformDeletePluginVersionTablesBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: platformDeletePluginVersionTablesBody
    },
      );
    }
  


export const getPlatformDeletePluginVersionTablesMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}, TContext> => {

const mutationKey = ['platformDeletePluginVersionTables'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformDeletePluginVersionTables(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>>
    export type PlatformDeletePluginVersionTablesMutationBody = PlatformDeletePluginVersionTablesBody
    export type PlatformDeletePluginVersionTablesMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginVersionTables = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformDeletePluginVersionTablesBody},
        TContext
      > => {

      const mutationOptions = getPlatformDeletePluginVersionTablesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get schema for a given table and plugin version. This only applies to source plugins.
 */
export const platformGetPluginVersionTable = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformPluginTableDetails>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetPluginVersionTableQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`] as const;
    }

    
export const getPlatformGetPluginVersionTableQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPluginVersionTableQueryKey(teamName,pluginKind,pluginName,versionName,tableName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPluginVersionTable>>> = ({ signal }) => platformGetPluginVersionTable(teamName,pluginKind,pluginName,versionName,tableName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPluginVersionTableQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPluginVersionTable>>>
export type PlatformGetPluginVersionTableQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetPluginVersionTable<TData = Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPluginVersionTable>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPluginVersionTableQueryOptions(teamName,pluginKind,pluginName,versionName,tableName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get URLs to upload UI assets for a given plugin version
 */
export const platformUploadPluginUIAssets = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformUploadPluginUIAssetsBody: PlatformUploadPluginUIAssetsBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformUploadPluginUIAssets201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformUploadPluginUIAssetsBody, signal
    },
      );
    }
  


export const getPlatformUploadPluginUIAssetsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformConflictResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}, TContext> => {

const mutationKey = ['platformUploadPluginUIAssets'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformUploadPluginUIAssets(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUploadPluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>>
    export type PlatformUploadPluginUIAssetsMutationBody = PlatformUploadPluginUIAssetsBody
    export type PlatformUploadPluginUIAssetsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformConflictResponse | PlatformInternalErrorResponse

    export const usePlatformUploadPluginUIAssets = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformConflictResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUploadPluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformUploadPluginUIAssetsBody},
        TContext
      > => {

      const mutationOptions = getPlatformUploadPluginUIAssetsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Finalize UI asset upload
 */
export const platformFinalizePluginUIAssetUpload = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    platformFinalizePluginUIAssetUploadBody: PlatformFinalizePluginUIAssetUploadBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformFinalizePluginUIAssetUploadBody
    },
      );
    }
  


export const getPlatformFinalizePluginUIAssetUploadMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}, TContext> => {

const mutationKey = ['platformFinalizePluginUIAssetUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  platformFinalizePluginUIAssetUpload(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformFinalizePluginUIAssetUploadMutationResult = NonNullable<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>>
    export type PlatformFinalizePluginUIAssetUploadMutationBody = PlatformFinalizePluginUIAssetUploadBody
    export type PlatformFinalizePluginUIAssetUploadMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformFinalizePluginUIAssetUpload = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformFinalizePluginUIAssetUpload>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PlatformFinalizePluginUIAssetUploadBody},
        TContext
      > => {

      const mutationOptions = getPlatformFinalizePluginUIAssetUploadMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Remove UI assets for a given plugin version
 */
export const platformRemovePluginUIAssets = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformRemovePluginUIAssetsMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext> => {

const mutationKey = ['platformRemovePluginUIAssets'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName} = props ?? {};

          return  platformRemovePluginUIAssets(teamName,pluginKind,pluginName,versionName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformRemovePluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>>
    
    export type PlatformRemovePluginUIAssetsMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformRemovePluginUIAssets = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemovePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformRemovePluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string},
        TContext
      > => {

      const mutationOptions = getPlatformRemovePluginUIAssetsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Tables
 */
export const platformListTables = (
    params?: PlatformListTablesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListTables200>(
      {url: `/tables`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListTablesQueryKey = (params?: PlatformListTablesParams,) => {
    return [`/tables`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListTablesQueryOptions = <TData = Awaited<ReturnType<typeof platformListTables>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params?: PlatformListTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTables>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTablesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTables>>> = ({ signal }) => platformListTables(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTables>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTablesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTables>>>
export type PlatformListTablesQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListTables<TData = Awaited<ReturnType<typeof platformListTables>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params?: PlatformListTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTables>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTablesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Table Rows
 */
export const platformTableListRows = (
    tableName: string,
    params?: PlatformTableListRowsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListRows200>(
      {url: `/tables/${tableName}/data`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListRowsQueryKey = (tableName: string,
    params?: PlatformTableListRowsParams,) => {
    return [`/tables/${tableName}/data`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListRowsQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListRows>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(tableName: string,
    params?: PlatformTableListRowsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRows>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListRowsQueryKey(tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListRows>>> = ({ signal }) => platformTableListRows(tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListRows>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListRowsQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListRows>>>
export type PlatformTableListRowsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListRows<TData = Awaited<ReturnType<typeof platformTableListRows>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 tableName: string,
    params?: PlatformTableListRowsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRows>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListRowsQueryOptions(tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table row
 */
export const platformTableRowById = (
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableRowById200>(
      {url: `/tables/${tableName}/data/${tableRowId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableRowByIdQueryKey = (tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdParams,) => {
    return [`/tables/${tableName}/data/${tableRowId}`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableRowByIdQueryOptions = <TData = Awaited<ReturnType<typeof platformTableRowById>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableRowById>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableRowByIdQueryKey(tableName,tableRowId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableRowById>>> = ({ signal }) => platformTableRowById(tableName,tableRowId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName && tableRowId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableRowById>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableRowByIdQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableRowById>>>
export type PlatformTableRowByIdQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableRowById<TData = Awaited<ReturnType<typeof platformTableRowById>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableRowById>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableRowByIdQueryOptions(tableName,tableRowId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Schema
 */
export const platformTableSchema = (
    tableName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableSchema200>(
      {url: `/tables/${tableName}/schema`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformTableSchemaQueryKey = (tableName: string,) => {
    return [`/tables/${tableName}/schema`] as const;
    }

    
export const getPlatformTableSchemaQueryOptions = <TData = Awaited<ReturnType<typeof platformTableSchema>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableSchema>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableSchemaQueryKey(tableName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableSchema>>> = ({ signal }) => platformTableSchema(tableName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableSchema>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableSchema>>>
export type PlatformTableSchemaQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableSchema<TData = Awaited<ReturnType<typeof platformTableSchema>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableSchema>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableSchemaQueryOptions(tableName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Schemas
 */
export const platformBatchTableSchemas = (
    params: PlatformBatchTableSchemasParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformBatchTableSchemas200>(
      {url: `/tables/schemas`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformBatchTableSchemasQueryKey = (params: PlatformBatchTableSchemasParams,) => {
    return [`/tables/schemas`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformBatchTableSchemasQueryOptions = <TData = Awaited<ReturnType<typeof platformBatchTableSchemas>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(params: PlatformBatchTableSchemasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemas>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformBatchTableSchemasQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformBatchTableSchemas>>> = ({ signal }) => platformBatchTableSchemas(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemas>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformBatchTableSchemasQueryResult = NonNullable<Awaited<ReturnType<typeof platformBatchTableSchemas>>>
export type PlatformBatchTableSchemasQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformBatchTableSchemas<TData = Awaited<ReturnType<typeof platformBatchTableSchemas>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 params: PlatformBatchTableSchemasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemas>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformBatchTableSchemasQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Columns
 */
export const platformTableListColumns = (
    tableName: string,
    params?: PlatformTableListColumnsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListColumns200>(
      {url: `/tables/${tableName}/columns`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListColumnsQueryKey = (tableName: string,
    params?: PlatformTableListColumnsParams,) => {
    return [`/tables/${tableName}/columns`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListColumnsQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListColumns>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(tableName: string,
    params?: PlatformTableListColumnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListColumnsQueryKey(tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListColumns>>> = ({ signal }) => platformTableListColumns(tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumns>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListColumns>>>
export type PlatformTableListColumnsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListColumns<TData = Awaited<ReturnType<typeof platformTableListColumns>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 tableName: string,
    params?: PlatformTableListColumnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListColumnsQueryOptions(tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Column Values
 */
export const platformTableColumnListValues = (
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableColumnListValues200>(
      {url: `/tables/${tableName}/columns/${columnName}/values`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableColumnListValuesQueryKey = (tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesParams,) => {
    return [`/tables/${tableName}/columns/${columnName}/values`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableColumnListValuesQueryOptions = <TData = Awaited<ReturnType<typeof platformTableColumnListValues>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValues>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableColumnListValuesQueryKey(tableName,columnName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableColumnListValues>>> = ({ signal }) => platformTableColumnListValues(tableName,columnName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName && columnName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValues>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableColumnListValuesQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableColumnListValues>>>
export type PlatformTableColumnListValuesQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableColumnListValues<TData = Awaited<ReturnType<typeof platformTableColumnListValues>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValues>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableColumnListValuesQueryOptions(tableName,columnName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Table Filters
 */
export const platformTableListFilters = (
    tableName: string,
    params?: PlatformTableListFiltersParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListFilters200>(
      {url: `/tables/${tableName}/filters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListFiltersQueryKey = (tableName: string,
    params?: PlatformTableListFiltersParams,) => {
    return [`/tables/${tableName}/filters`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListFiltersQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListFilters>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(tableName: string,
    params?: PlatformTableListFiltersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilters>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListFiltersQueryKey(tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListFilters>>> = ({ signal }) => platformTableListFilters(tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilters>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListFilters>>>
export type PlatformTableListFiltersQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListFilters<TData = Awaited<ReturnType<typeof platformTableListFilters>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 tableName: string,
    params?: PlatformTableListFiltersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilters>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListFiltersQueryOptions(tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Save Table Filter
 */
export const platformTableSaveFilter = (
    tableName: string,
    platformFilterCreate: PlatformFilterCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformFilter>(
      {url: `/tables/${tableName}/filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformFilterCreate, signal
    },
      );
    }
  


export const getPlatformTableSaveFilterMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilter>>, TError,{tableName: string;data: PlatformFilterCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilter>>, TError,{tableName: string;data: PlatformFilterCreate}, TContext> => {

const mutationKey = ['platformTableSaveFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTableSaveFilter>>, {tableName: string;data: PlatformFilterCreate}> = (props) => {
          const {tableName,data} = props ?? {};

          return  platformTableSaveFilter(tableName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformTableSaveFilterMutationResult = NonNullable<Awaited<ReturnType<typeof platformTableSaveFilter>>>
    export type PlatformTableSaveFilterMutationBody = PlatformFilterCreate
    export type PlatformTableSaveFilterMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTableSaveFilter = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilter>>, TError,{tableName: string;data: PlatformFilterCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTableSaveFilter>>,
        TError,
        {tableName: string;data: PlatformFilterCreate},
        TContext
      > => {

      const mutationOptions = getPlatformTableSaveFilterMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Filter Tags For A Table
 */
export const platformTableListFilterTags = (
    tableName: string,
    params?: PlatformTableListFilterTagsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListFilterTags200>(
      {url: `/tables/${tableName}/filters/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListFilterTagsQueryKey = (tableName: string,
    params?: PlatformTableListFilterTagsParams,) => {
    return [`/tables/${tableName}/filters/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListFilterTagsQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListFilterTags>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(tableName: string,
    params?: PlatformTableListFilterTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTags>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListFilterTagsQueryKey(tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListFilterTags>>> = ({ signal }) => platformTableListFilterTags(tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTags>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListFilterTagsQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListFilterTags>>>
export type PlatformTableListFilterTagsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListFilterTags<TData = Awaited<ReturnType<typeof platformTableListFilterTags>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 tableName: string,
    params?: PlatformTableListFilterTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTags>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListFilterTagsQueryOptions(tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Table Relations
 */
export const platformTableListRelations = (
    tableName: string,
    params?: PlatformTableListRelationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListRelations200>(
      {url: `/tables/${tableName}/relations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListRelationsQueryKey = (tableName: string,
    params?: PlatformTableListRelationsParams,) => {
    return [`/tables/${tableName}/relations`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListRelationsQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListRelations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(tableName: string,
    params?: PlatformTableListRelationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListRelationsQueryKey(tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListRelations>>> = ({ signal }) => platformTableListRelations(tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListRelationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListRelations>>>
export type PlatformTableListRelationsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformTableListRelations<TData = Awaited<ReturnType<typeof platformTableListRelations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 tableName: string,
    params?: PlatformTableListRelationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListRelationsQueryOptions(tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all teams
 */
export const platformListTeams = (
    params?: PlatformListTeamsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListTeams200>(
      {url: `/teams`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListTeamsQueryKey = (params?: PlatformListTeamsParams,) => {
    return [`/teams`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListTeamsQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(params?: PlatformListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeams>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeams>>> = ({ signal }) => platformListTeams(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeams>>>
export type PlatformListTeamsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListTeams<TData = Awaited<ReturnType<typeof platformListTeams>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 params?: PlatformListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeams>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTeamsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a team owned by the current user.
 */
export const platformCreateTeam = (
    platformCreateTeamBody: PlatformCreateTeamBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTeam>(
      {url: `/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformCreateTeamBody, signal
    },
      );
    }
  


export const getPlatformCreateTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamBody}, TContext> => {

const mutationKey = ['platformCreateTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateTeam>>, {data: PlatformCreateTeamBody}> = (props) => {
          const {data} = props ?? {};

          return  platformCreateTeam(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateTeam>>>
    export type PlatformCreateTeamMutationBody = PlatformCreateTeamBody
    export type PlatformCreateTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeam>>, TError,{data: PlatformCreateTeamBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateTeam>>,
        TError,
        {data: PlatformCreateTeamBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreateTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a team by name
 */
export const platformGetTeamByName = (
    teamName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTeam>(
      {url: `/teams/${teamName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetTeamByNameQueryKey = (teamName: string,) => {
    return [`/teams/${teamName}`] as const;
    }

    
export const getPlatformGetTeamByNameQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeamByName>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamByName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamByNameQueryKey(teamName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeamByName>>> = ({ signal }) => platformGetTeamByName(teamName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamByName>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTeamByNameQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeamByName>>>
export type PlatformGetTeamByNameQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTeamByName<TData = Awaited<ReturnType<typeof platformGetTeamByName>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamByName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTeamByNameQueryOptions(teamName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update team attributes
 */
export const platformUpdateTeam = (
    teamName: string,
    platformUpdateTeamBody: PlatformUpdateTeamBody,
 ) => {
      
      
      return customFetch<PlatformTeam>(
      {url: `/teams/${teamName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateTeamBody
    },
      );
    }
  


export const getPlatformUpdateTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{teamName: string;data: PlatformUpdateTeamBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{teamName: string;data: PlatformUpdateTeamBody}, TContext> => {

const mutationKey = ['platformUpdateTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateTeam>>, {teamName: string;data: PlatformUpdateTeamBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformUpdateTeam(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateTeam>>>
    export type PlatformUpdateTeamMutationBody = PlatformUpdateTeamBody
    export type PlatformUpdateTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateTeam>>, TError,{teamName: string;data: PlatformUpdateTeamBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateTeam>>,
        TError,
        {teamName: string;data: PlatformUpdateTeamBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete team
 */
export const platformDeleteTeam = (
    teamName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{teamName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['platformDeleteTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  platformDeleteTeam(teamName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeam>>>
    
    export type PlatformDeleteTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeam>>, TError,{teamName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all alerts
 */
export const platformListAllAlerts = (
    teamName: string,
    params?: PlatformListAllAlertsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListAllAlerts200>(
      {url: `/teams/${teamName}/alerts`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListAllAlertsQueryKey = (teamName: string,
    params?: PlatformListAllAlertsParams,) => {
    return [`/teams/${teamName}/alerts`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListAllAlertsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllAlerts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllAlertsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllAlerts>>> = ({ signal }) => platformListAllAlerts(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllAlerts>>>
export type PlatformListAllAlertsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllAlerts<TData = Awaited<ReturnType<typeof platformListAllAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllAlerts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllAlertsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Test an unsaved alert
 */
export const platformTestUnsavedAlert = (
    teamName: string,
    platformAlertCreate: PlatformAlertCreate,
    params?: PlatformTestUnsavedAlertParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTestUnsavedAlert200>(
      {url: `/teams/${teamName}/alerts/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformAlertCreate,
        params, signal
    },
      );
    }
  


export const getPlatformTestUnsavedAlertMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, TError,{teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, TError,{teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}, TContext> => {

const mutationKey = ['platformTestUnsavedAlert'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, {teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}> = (props) => {
          const {teamName,data,params} = props ?? {};

          return  platformTestUnsavedAlert(teamName,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformTestUnsavedAlertMutationResult = NonNullable<Awaited<ReturnType<typeof platformTestUnsavedAlert>>>
    export type PlatformTestUnsavedAlertMutationBody = PlatformAlertCreate
    export type PlatformTestUnsavedAlertMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTestUnsavedAlert = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedAlert>>, TError,{teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTestUnsavedAlert>>,
        TError,
        {teamName: string;data: PlatformAlertCreate;params?: PlatformTestUnsavedAlertParams},
        TContext
      > => {

      const mutationOptions = getPlatformTestUnsavedAlertMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all team API Keys
 */
export const platformListTeamAPIKeys = (
    teamName: string,
    params?: PlatformListTeamAPIKeysParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListTeamAPIKeys200>(
      {url: `/teams/${teamName}/apikeys`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListTeamAPIKeysQueryKey = (teamName: string,
    params?: PlatformListTeamAPIKeysParams,) => {
    return [`/teams/${teamName}/apikeys`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListTeamAPIKeysQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamAPIKeysQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamAPIKeys>>> = ({ signal }) => platformListTeamAPIKeys(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTeamAPIKeysQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamAPIKeys>>>
export type PlatformListTeamAPIKeysQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListTeamAPIKeys<TData = Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamAPIKeys>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTeamAPIKeysQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new team API Key.
 */
export const platformCreateTeamAPIKey = (
    teamName: string,
    platformCreateTeamAPIKeyBody: PlatformCreateTeamAPIKeyBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformAPIKey>(
      {url: `/teams/${teamName}/apikeys`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformCreateTeamAPIKeyBody, signal
    },
      );
    }
  


export const getPlatformCreateTeamAPIKeyMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, TError,{teamName: string;data: PlatformCreateTeamAPIKeyBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, TError,{teamName: string;data: PlatformCreateTeamAPIKeyBody}, TContext> => {

const mutationKey = ['platformCreateTeamAPIKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, {teamName: string;data: PlatformCreateTeamAPIKeyBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateTeamAPIKey(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>>
    export type PlatformCreateTeamAPIKeyMutationBody = PlatformCreateTeamAPIKeyBody
    export type PlatformCreateTeamAPIKeyMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateTeamAPIKey = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamAPIKey>>, TError,{teamName: string;data: PlatformCreateTeamAPIKeyBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateTeamAPIKey>>,
        TError,
        {teamName: string;data: PlatformCreateTeamAPIKeyBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreateTeamAPIKeyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete API Key. This will remove any future access by this API Key.
 */
export const platformDeleteTeamAPIKey = (
    teamName: string,
    apikeyId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/apikeys/${apikeyId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteTeamAPIKeyMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext> => {

const mutationKey = ['platformDeleteTeamAPIKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, {teamName: string;apikeyId: string}> = (props) => {
          const {teamName,apikeyId} = props ?? {};

          return  platformDeleteTeamAPIKey(teamName,apikeyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>>
    
    export type PlatformDeleteTeamAPIKeyMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteTeamAPIKey = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeamAPIKey>>,
        TError,
        {teamName: string;apikeyId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteTeamAPIKeyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all configured connectors
 */
export const platformListConnectors = (
    teamName: string,
    params?: PlatformListConnectorsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListConnectors200>(
      {url: `/teams/${teamName}/connectors`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListConnectorsQueryKey = (teamName: string,
    params?: PlatformListConnectorsParams,) => {
    return [`/teams/${teamName}/connectors`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListConnectorsQueryOptions = <TData = Awaited<ReturnType<typeof platformListConnectors>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListConnectorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListConnectors>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListConnectorsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListConnectors>>> = ({ signal }) => platformListConnectors(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListConnectors>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListConnectorsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListConnectors>>>
export type PlatformListConnectorsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListConnectors<TData = Awaited<ReturnType<typeof platformListConnectors>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListConnectorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListConnectors>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListConnectorsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new connector
 */
export const platformCreateConnector = (
    teamName: string,
    platformConnectorCreate: PlatformConnectorCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformConnector>(
      {url: `/teams/${teamName}/connectors`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformConnectorCreate, signal
    },
      );
    }
  


export const getPlatformCreateConnectorMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateConnector>>, TError,{teamName: string;data: PlatformConnectorCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateConnector>>, TError,{teamName: string;data: PlatformConnectorCreate}, TContext> => {

const mutationKey = ['platformCreateConnector'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateConnector>>, {teamName: string;data: PlatformConnectorCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateConnector(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateConnector>>>
    export type PlatformCreateConnectorMutationBody = PlatformConnectorCreate
    export type PlatformCreateConnectorMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateConnector = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateConnector>>, TError,{teamName: string;data: PlatformConnectorCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateConnector>>,
        TError,
        {teamName: string;data: PlatformConnectorCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateConnectorMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a configured connector
 */
export const platformGetConnector = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformConnector>(
      {url: `/teams/${teamName}/connectors/${connectorId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetConnectorQueryKey = (teamName: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/connectors/${connectorId}`] as const;
    }

    
export const getPlatformGetConnectorQueryOptions = <TData = Awaited<ReturnType<typeof platformGetConnector>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnector>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetConnectorQueryKey(teamName,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetConnector>>> = ({ signal }) => platformGetConnector(teamName,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetConnector>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetConnectorQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetConnector>>>
export type PlatformGetConnectorQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetConnector<TData = Awaited<ReturnType<typeof platformGetConnector>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnector>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetConnectorQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a connector
 */
export const platformUpdateConnector = (
    teamName: string,
    connectorId: string,
    platformConnectorUpdate: PlatformConnectorUpdate,
 ) => {
      
      
      return customFetch<PlatformConnector>(
      {url: `/teams/${teamName}/connectors/${connectorId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformConnectorUpdate
    },
      );
    }
  


export const getPlatformUpdateConnectorMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateConnector>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateConnector>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorUpdate}, TContext> => {

const mutationKey = ['platformUpdateConnector'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateConnector>>, {teamName: string;connectorId: string;data: PlatformConnectorUpdate}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformUpdateConnector(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateConnector>>>
    export type PlatformUpdateConnectorMutationBody = PlatformConnectorUpdate
    export type PlatformUpdateConnectorMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateConnector = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateConnector>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateConnector>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateConnectorMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Revoke authentication for a given connector. Any syncs relying on this connector will stop running until the connector is reauthenticated or sync references are updated.
 */
export const platformRevokeConnector = (
    teamName: string,
    connectorId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformRevokeConnectorMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRevokeConnector>>, TError,{teamName: string;connectorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformRevokeConnector>>, TError,{teamName: string;connectorId: string}, TContext> => {

const mutationKey = ['platformRevokeConnector'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRevokeConnector>>, {teamName: string;connectorId: string}> = (props) => {
          const {teamName,connectorId} = props ?? {};

          return  platformRevokeConnector(teamName,connectorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformRevokeConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof platformRevokeConnector>>>
    
    export type PlatformRevokeConnectorMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformRevokeConnector = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRevokeConnector>>, TError,{teamName: string;connectorId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformRevokeConnector>>,
        TError,
        {teamName: string;connectorId: string},
        TContext
      > => {

      const mutationOptions = getPlatformRevokeConnectorMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get authentication status for the given AWS connector
 */
export const platformGetConnectorAuthStatusAWS = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetConnectorAuthStatusAWS200>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetConnectorAuthStatusAWSQueryKey = (teamName: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/connectors/${connectorId}/authenticate/aws`] as const;
    }

    
export const getPlatformGetConnectorAuthStatusAWSQueryOptions = <TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetConnectorAuthStatusAWSQueryKey(teamName,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>> = ({ signal }) => platformGetConnectorAuthStatusAWS(teamName,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetConnectorAuthStatusAWSQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>>
export type PlatformGetConnectorAuthStatusAWSQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetConnectorAuthStatusAWS<TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusAWS>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetConnectorAuthStatusAWSQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Authenticate or reauthenticate the given AWS connector
 */
export const platformAuthenticateConnectorAWS = (
    teamName: string,
    connectorId: string,
    platformConnectorAuthRequestAWS: PlatformConnectorAuthRequestAWS,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformConnectorAuthResponseAWS>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformConnectorAuthRequestAWS, signal
    },
      );
    }
  


export const getPlatformAuthenticateConnectorAWSMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorAWS'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorAWS(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorAWSMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>>
    export type PlatformAuthenticateConnectorAWSMutationBody = PlatformConnectorAuthRequestAWS
    export type PlatformAuthenticateConnectorAWSMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorAWS = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorAWS>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestAWS},
        TContext
      > => {

      const mutationOptions = getPlatformAuthenticateConnectorAWSMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Complete authentication for the given AWS connector
 */
export const platformAuthenticateConnectorFinishAWS = (
    teamName: string,
    connectorId: string,
    platformConnectorAuthFinishRequestAWS: PlatformConnectorAuthFinishRequestAWS,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformConnectorAuthFinishRequestAWS
    },
      );
    }
  


export const getPlatformAuthenticateConnectorFinishAWSMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorFinishAWS'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorFinishAWS(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorFinishAWSMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>>
    export type PlatformAuthenticateConnectorFinishAWSMutationBody = PlatformConnectorAuthFinishRequestAWS
    export type PlatformAuthenticateConnectorFinishAWSMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorFinishAWS = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorFinishAWS>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestAWS},
        TContext
      > => {

      const mutationOptions = getPlatformAuthenticateConnectorFinishAWSMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get authentication status for the given GCP connector
 */
export const platformGetConnectorAuthStatusGCP = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetConnectorAuthStatusGCP200>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetConnectorAuthStatusGCPQueryKey = (teamName: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`] as const;
    }

    
export const getPlatformGetConnectorAuthStatusGCPQueryOptions = <TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetConnectorAuthStatusGCPQueryKey(teamName,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>> = ({ signal }) => platformGetConnectorAuthStatusGCP(teamName,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetConnectorAuthStatusGCPQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>>
export type PlatformGetConnectorAuthStatusGCPQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetConnectorAuthStatusGCP<TData = Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetConnectorAuthStatusGCP>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetConnectorAuthStatusGCPQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Authenticate or reauthenticate the given GCP connector
 */
export const platformAuthenticateConnectorGCP = (
    teamName: string,
    connectorId: string,
    platformConnectorAuthRequestGCP: PlatformConnectorAuthRequestGCP,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformConnectorAuthResponseGCP>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformConnectorAuthRequestGCP, signal
    },
      );
    }
  


export const getPlatformAuthenticateConnectorGCPMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorGCP'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorGCP(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorGCPMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>>
    export type PlatformAuthenticateConnectorGCPMutationBody = PlatformConnectorAuthRequestGCP
    export type PlatformAuthenticateConnectorGCPMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorGCP = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorGCP>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestGCP},
        TContext
      > => {

      const mutationOptions = getPlatformAuthenticateConnectorGCPMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Complete authentication for the given GCP connector
 */
export const platformAuthenticateConnectorFinishGCP = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp/finish`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformAuthenticateConnectorFinishGCPMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorFinishGCP'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, {teamName: string;connectorId: string}> = (props) => {
          const {teamName,connectorId} = props ?? {};

          return  platformAuthenticateConnectorFinishGCP(teamName,connectorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorFinishGCPMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>>
    
    export type PlatformAuthenticateConnectorFinishGCPMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorFinishGCP = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorFinishGCP>>,
        TError,
        {teamName: string;connectorId: string},
        TContext
      > => {

      const mutationOptions = getPlatformAuthenticateConnectorFinishGCPMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Authenticate or reauthenticate the given OAuth connector
 */
export const platformAuthenticateConnectorOAuth = (
    teamName: string,
    connectorId: string,
    platformConnectorAuthRequestOAuth: PlatformConnectorAuthRequestOAuth,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformConnectorAuthResponseOAuth>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/oauth`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformConnectorAuthRequestOAuth, signal
    },
      );
    }
  


export const getPlatformAuthenticateConnectorOAuthMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorOAuth'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorOAuth(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorOAuthMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>>
    export type PlatformAuthenticateConnectorOAuthMutationBody = PlatformConnectorAuthRequestOAuth
    export type PlatformAuthenticateConnectorOAuthMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorOAuth = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorOAuth>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthRequestOAuth},
        TContext
      > => {

      const mutationOptions = getPlatformAuthenticateConnectorOAuthMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Complete authentication for the given OAuth connector
 */
export const platformAuthenticateConnectorFinishOAuth = (
    teamName: string,
    connectorId: string,
    platformConnectorAuthFinishRequestOAuth: PlatformConnectorAuthFinishRequestOAuth,
 ) => {
      
      
      return customFetch<PlatformConnectorAuthResponseOAuth | void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/oauth`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformConnectorAuthFinishRequestOAuth
    },
      );
    }
  


export const getPlatformAuthenticateConnectorFinishOAuthMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}, TContext> => {

const mutationKey = ['platformAuthenticateConnectorFinishOAuth'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  platformAuthenticateConnectorFinishOAuth(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateConnectorFinishOAuthMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>>
    export type PlatformAuthenticateConnectorFinishOAuthMutationBody = PlatformConnectorAuthFinishRequestOAuth
    export type PlatformAuthenticateConnectorFinishOAuthMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateConnectorFinishOAuth = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateConnectorFinishOAuth>>,
        TError,
        {teamName: string;connectorId: string;data: PlatformConnectorAuthFinishRequestOAuth},
        TContext
      > => {

      const mutationOptions = getPlatformAuthenticateConnectorFinishOAuthMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all custom columns
 */
export const platformListAllCustomColumns = (
    teamName: string,
    params?: PlatformListAllCustomColumnsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListAllCustomColumns200>(
      {url: `/teams/${teamName}/custom-columns`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListAllCustomColumnsQueryKey = (teamName: string,
    params?: PlatformListAllCustomColumnsParams,) => {
    return [`/teams/${teamName}/custom-columns`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListAllCustomColumnsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllCustomColumnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllCustomColumnsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllCustomColumns>>> = ({ signal }) => platformListAllCustomColumns(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllCustomColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllCustomColumns>>>
export type PlatformListAllCustomColumnsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllCustomColumns<TData = Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllCustomColumnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllCustomColumns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllCustomColumnsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Save a custom column
 */
export const platformSaveCustomColumn = (
    teamName: string,
    platformCustomColumnCreateOrUpdate: PlatformCustomColumnCreateOrUpdate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCustomColumn>(
      {url: `/teams/${teamName}/custom-columns`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformCustomColumnCreateOrUpdate, signal
    },
      );
    }
  


export const getPlatformSaveCustomColumnMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveCustomColumn>>, TError,{teamName: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformSaveCustomColumn>>, TError,{teamName: string;data: PlatformCustomColumnCreateOrUpdate}, TContext> => {

const mutationKey = ['platformSaveCustomColumn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSaveCustomColumn>>, {teamName: string;data: PlatformCustomColumnCreateOrUpdate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformSaveCustomColumn(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformSaveCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof platformSaveCustomColumn>>>
    export type PlatformSaveCustomColumnMutationBody = PlatformCustomColumnCreateOrUpdate
    export type PlatformSaveCustomColumnMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformSaveCustomColumn = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveCustomColumn>>, TError,{teamName: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSaveCustomColumn>>,
        TError,
        {teamName: string;data: PlatformCustomColumnCreateOrUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformSaveCustomColumnMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a custom column
 */
export const platformGetCustomColumn = (
    teamName: string,
    customColumnId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCustomColumn>(
      {url: `/teams/${teamName}/custom-columns/${customColumnId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetCustomColumnQueryKey = (teamName: string,
    customColumnId: string,) => {
    return [`/teams/${teamName}/custom-columns/${customColumnId}`] as const;
    }

    
export const getPlatformGetCustomColumnQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCustomColumn>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    customColumnId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCustomColumn>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCustomColumnQueryKey(teamName,customColumnId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCustomColumn>>> = ({ signal }) => platformGetCustomColumn(teamName,customColumnId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && customColumnId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCustomColumn>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCustomColumnQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCustomColumn>>>
export type PlatformGetCustomColumnQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetCustomColumn<TData = Awaited<ReturnType<typeof platformGetCustomColumn>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    customColumnId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCustomColumn>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCustomColumnQueryOptions(teamName,customColumnId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a custom column
 */
export const platformUpdateCustomColumn = (
    teamName: string,
    customColumnId: string,
    platformCustomColumnCreateOrUpdate: PlatformCustomColumnCreateOrUpdate,
 ) => {
      
      
      return customFetch<PlatformCustomColumn>(
      {url: `/teams/${teamName}/custom-columns/${customColumnId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformCustomColumnCreateOrUpdate
    },
      );
    }
  


export const getPlatformUpdateCustomColumnMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}, TContext> => {

const mutationKey = ['platformUpdateCustomColumn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, {teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}> = (props) => {
          const {teamName,customColumnId,data} = props ?? {};

          return  platformUpdateCustomColumn(teamName,customColumnId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateCustomColumn>>>
    export type PlatformUpdateCustomColumnMutationBody = PlatformCustomColumnCreateOrUpdate
    export type PlatformUpdateCustomColumnMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateCustomColumn = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomColumn>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateCustomColumn>>,
        TError,
        {teamName: string;customColumnId: string;data: PlatformCustomColumnCreateOrUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateCustomColumnMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a custom column
 */
export const platformDeleteCustomColumn = (
    teamName: string,
    customColumnId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/custom-columns/${customColumnId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteCustomColumnMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, TError,{teamName: string;customColumnId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, TError,{teamName: string;customColumnId: string}, TContext> => {

const mutationKey = ['platformDeleteCustomColumn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, {teamName: string;customColumnId: string}> = (props) => {
          const {teamName,customColumnId} = props ?? {};

          return  platformDeleteCustomColumn(teamName,customColumnId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteCustomColumnMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteCustomColumn>>>
    
    export type PlatformDeleteCustomColumnMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteCustomColumn = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteCustomColumn>>, TError,{teamName: string;customColumnId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteCustomColumn>>,
        TError,
        {teamName: string;customColumnId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteCustomColumnMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Import data into a Custom Column
 */
export const platformPutCustomColumnData = (
    teamName: string,
    customColumnId: string,
    platformCustomColumnDataImport: PlatformCustomColumnDataImport,
 ) => {
      
      
      return customFetch<PlatformPutCustomColumnData202>(
      {url: `/teams/${teamName}/custom-columns/${customColumnId}/import`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformCustomColumnDataImport
    },
      );
    }
  


export const getPlatformPutCustomColumnDataMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnData>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnData>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}, TContext> => {

const mutationKey = ['platformPutCustomColumnData'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPutCustomColumnData>>, {teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}> = (props) => {
          const {teamName,customColumnId,data} = props ?? {};

          return  platformPutCustomColumnData(teamName,customColumnId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformPutCustomColumnDataMutationResult = NonNullable<Awaited<ReturnType<typeof platformPutCustomColumnData>>>
    export type PlatformPutCustomColumnDataMutationBody = PlatformCustomColumnDataImport
    export type PlatformPutCustomColumnDataMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse

    export const usePlatformPutCustomColumnData = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnData>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPutCustomColumnData>>,
        TError,
        {teamName: string;customColumnId: string;data: PlatformCustomColumnDataImport},
        TContext
      > => {

      const mutationOptions = getPlatformPutCustomColumnDataMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Edit values within a Custom Column
 */
export const platformPutCustomColumnValues = (
    teamName: string,
    customColumnId: string,
    platformCustomColumnDataValues: PlatformCustomColumnDataValues,
 ) => {
      
      
      return customFetch<PlatformPutCustomColumnValues200>(
      {url: `/teams/${teamName}/custom-columns/${customColumnId}/values`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformCustomColumnDataValues
    },
      );
    }
  


export const getPlatformPutCustomColumnValuesMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}, TContext> => {

const mutationKey = ['platformPutCustomColumnValues'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, {teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}> = (props) => {
          const {teamName,customColumnId,data} = props ?? {};

          return  platformPutCustomColumnValues(teamName,customColumnId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformPutCustomColumnValuesMutationResult = NonNullable<Awaited<ReturnType<typeof platformPutCustomColumnValues>>>
    export type PlatformPutCustomColumnValuesMutationBody = PlatformCustomColumnDataValues
    export type PlatformPutCustomColumnValuesMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse

    export const usePlatformPutCustomColumnValues = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPutCustomColumnValues>>, TError,{teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPutCustomColumnValues>>,
        TError,
        {teamName: string;customColumnId: string;data: PlatformCustomColumnDataValues},
        TContext
      > => {

      const mutationOptions = getPlatformPutCustomColumnValuesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Filters
 */
export const platformListFiltersTeam = (
    teamName: string,
    params?: PlatformListFiltersTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListFiltersTeam200>(
      {url: `/teams/${teamName}/filters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListFiltersTeamQueryKey = (teamName: string,
    params?: PlatformListFiltersTeamParams,) => {
    return [`/teams/${teamName}/filters`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListFiltersTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListFiltersTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFiltersTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListFiltersTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListFiltersTeam>>> = ({ signal }) => platformListFiltersTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListFiltersTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListFiltersTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListFiltersTeam>>>
export type PlatformListFiltersTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListFiltersTeam<TData = Awaited<ReturnType<typeof platformListFiltersTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFiltersTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListFiltersTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Filter Tags
 */
export const platformListFilterTagsTeam = (
    teamName: string,
    params?: PlatformListFilterTagsTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListFilterTagsTeam200>(
      {url: `/teams/${teamName}/filters/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListFilterTagsTeamQueryKey = (teamName: string,
    params?: PlatformListFilterTagsTeamParams,) => {
    return [`/teams/${teamName}/filters/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListFilterTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListFilterTagsTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListFilterTagsTeam>>> = ({ signal }) => platformListFilterTagsTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListFilterTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListFilterTagsTeam>>>
export type PlatformListFilterTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListFilterTagsTeam<TData = Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListFilterTagsTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListFilterTagsTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a table filter by ID
 */
export const platformGetFilterByIDTeam = (
    teamName: string,
    filterId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformFilter>(
      {url: `/teams/${teamName}/filters/${filterId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetFilterByIDTeamQueryKey = (teamName: string,
    filterId: string,) => {
    return [`/teams/${teamName}/filters/${filterId}`] as const;
    }

    
export const getPlatformGetFilterByIDTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    filterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetFilterByIDTeamQueryKey(teamName,filterId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>> = ({ signal }) => platformGetFilterByIDTeam(teamName,filterId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && filterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetFilterByIDTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>>
export type PlatformGetFilterByIDTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetFilterByIDTeam<TData = Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    filterId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetFilterByIDTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetFilterByIDTeamQueryOptions(teamName,filterId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a table filter
 */
export const platformUpdateFilterTeam = (
    teamName: string,
    filterId: string,
    platformFilterUpdate: PlatformFilterUpdate,
 ) => {
      
      
      return customFetch<PlatformFilter>(
      {url: `/teams/${teamName}/filters/${filterId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformFilterUpdate
    },
      );
    }
  


export const getPlatformUpdateFilterTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, TError,{teamName: string;filterId: string;data: PlatformFilterUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, TError,{teamName: string;filterId: string;data: PlatformFilterUpdate}, TContext> => {

const mutationKey = ['platformUpdateFilterTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, {teamName: string;filterId: string;data: PlatformFilterUpdate}> = (props) => {
          const {teamName,filterId,data} = props ?? {};

          return  platformUpdateFilterTeam(teamName,filterId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateFilterTeam>>>
    export type PlatformUpdateFilterTeamMutationBody = PlatformFilterUpdate
    export type PlatformUpdateFilterTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateFilterTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateFilterTeam>>, TError,{teamName: string;filterId: string;data: PlatformFilterUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateFilterTeam>>,
        TError,
        {teamName: string;filterId: string;data: PlatformFilterUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateFilterTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a table filter
 */
export const platformDeleteFilterTeam = (
    teamName: string,
    filterId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/filters/${filterId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteFilterTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, TError,{teamName: string;filterId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, TError,{teamName: string;filterId: string}, TContext> => {

const mutationKey = ['platformDeleteFilterTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, {teamName: string;filterId: string}> = (props) => {
          const {teamName,filterId} = props ?? {};

          return  platformDeleteFilterTeam(teamName,filterId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteFilterTeam>>>
    
    export type PlatformDeleteFilterTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteFilterTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteFilterTeam>>, TError,{teamName: string;filterId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteFilterTeam>>,
        TError,
        {teamName: string;filterId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteFilterTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get URLs to upload images for a given team
 */
export const platformCreateTeamImages = (
    teamName: string,
    platformCreateTeamImagesBody: PlatformCreateTeamImagesBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCreateTeamImages201>(
      {url: `/teams/${teamName}/images`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformCreateTeamImagesBody, signal
    },
      );
    }
  


export const getPlatformCreateTeamImagesMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamImages>>, TError,{teamName: string;data: PlatformCreateTeamImagesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamImages>>, TError,{teamName: string;data: PlatformCreateTeamImagesBody}, TContext> => {

const mutationKey = ['platformCreateTeamImages'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateTeamImages>>, {teamName: string;data: PlatformCreateTeamImagesBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateTeamImages(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateTeamImagesMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateTeamImages>>>
    export type PlatformCreateTeamImagesMutationBody = PlatformCreateTeamImagesBody
    export type PlatformCreateTeamImagesMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformCreateTeamImages = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateTeamImages>>, TError,{teamName: string;data: PlatformCreateTeamImagesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateTeamImages>>,
        TError,
        {teamName: string;data: PlatformCreateTeamImagesBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreateTeamImagesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List of open invitations to the team
 */
export const platformListTeamInvitations = (
    teamName: string,
    params?: PlatformListTeamInvitationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListTeamInvitations200>(
      {url: `/teams/${teamName}/invitations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListTeamInvitationsQueryKey = (teamName: string,
    params?: PlatformListTeamInvitationsParams,) => {
    return [`/teams/${teamName}/invitations`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListTeamInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListTeamInvitations>>, TError = PlatformForbiddenResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamInvitations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTeamInvitationsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTeamInvitations>>> = ({ signal }) => platformListTeamInvitations(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTeamInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTeamInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTeamInvitations>>>
export type PlatformListTeamInvitationsQueryError = PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformListTeamInvitations<TData = Awaited<ReturnType<typeof platformListTeamInvitations>>, TError = PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTeamInvitations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTeamInvitationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete an invitation to the team, preventing the user becoming a team member
 */
export const platformDeleteTeamInvitation = (
    teamName: string,
    platformDeleteTeamInvitationBody: PlatformDeleteTeamInvitationBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/invitations`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: platformDeleteTeamInvitationBody
    },
      );
    }
  


export const getPlatformDeleteTeamInvitationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, TError,{teamName: string;data: PlatformDeleteTeamInvitationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, TError,{teamName: string;data: PlatformDeleteTeamInvitationBody}, TContext> => {

const mutationKey = ['platformDeleteTeamInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, {teamName: string;data: PlatformDeleteTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformDeleteTeamInvitation(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>>
    export type PlatformDeleteTeamInvitationMutationBody = PlatformDeleteTeamInvitationBody
    export type PlatformDeleteTeamInvitationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteTeamInvitation = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamInvitation>>, TError,{teamName: string;data: PlatformDeleteTeamInvitationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeamInvitation>>,
        TError,
        {teamName: string;data: PlatformDeleteTeamInvitationBody},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteTeamInvitationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Accept an invitation to the team, creating a user membership
 */
export const platformAcceptTeamInvitation = (
    teamName: string,
    platformAcceptTeamInvitationBody: PlatformAcceptTeamInvitationBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformMembershipWithTeam>(
      {url: `/teams/${teamName}/invitations/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformAcceptTeamInvitationBody, signal
    },
      );
    }
  


export const getPlatformAcceptTeamInvitationMutationOptions = <TError = PlatformMembershipWithTeam | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, TError,{teamName: string;data: PlatformAcceptTeamInvitationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, TError,{teamName: string;data: PlatformAcceptTeamInvitationBody}, TContext> => {

const mutationKey = ['platformAcceptTeamInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, {teamName: string;data: PlatformAcceptTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformAcceptTeamInvitation(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAcceptTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>>
    export type PlatformAcceptTeamInvitationMutationBody = PlatformAcceptTeamInvitationBody
    export type PlatformAcceptTeamInvitationMutationError = PlatformMembershipWithTeam | PlatformForbiddenResponse | PlatformInternalErrorResponse

    export const usePlatformAcceptTeamInvitation = <TError = PlatformMembershipWithTeam | PlatformForbiddenResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAcceptTeamInvitation>>, TError,{teamName: string;data: PlatformAcceptTeamInvitationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAcceptTeamInvitation>>,
        TError,
        {teamName: string;data: PlatformAcceptTeamInvitationBody},
        TContext
      > => {

      const mutationOptions = getPlatformAcceptTeamInvitationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get memberships to the team.
 */
export const platformGetTeamMemberships = (
    teamName: string,
    params?: PlatformGetTeamMembershipsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetTeamMemberships200>(
      {url: `/teams/${teamName}/memberships`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetTeamMembershipsQueryKey = (teamName: string,
    params?: PlatformGetTeamMembershipsParams,) => {
    return [`/teams/${teamName}/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetTeamMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformGetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamMembershipsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeamMemberships>>> = ({ signal }) => platformGetTeamMemberships(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTeamMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeamMemberships>>>
export type PlatformGetTeamMembershipsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTeamMemberships<TData = Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformGetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamMemberships>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTeamMembershipsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Remove a user from the team
 */
export const platformRemoveTeamMembership = (
    teamName: string,
    platformRemoveTeamMembershipBody: PlatformRemoveTeamMembershipBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/memberships`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: platformRemoveTeamMembershipBody
    },
      );
    }
  


export const getPlatformRemoveTeamMembershipMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, TError,{teamName: string;data: PlatformRemoveTeamMembershipBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, TError,{teamName: string;data: PlatformRemoveTeamMembershipBody}, TContext> => {

const mutationKey = ['platformRemoveTeamMembership'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, {teamName: string;data: PlatformRemoveTeamMembershipBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformRemoveTeamMembership(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformRemoveTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof platformRemoveTeamMembership>>>
    export type PlatformRemoveTeamMembershipMutationBody = PlatformRemoveTeamMembershipBody
    export type PlatformRemoveTeamMembershipMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformRemoveTeamMembership = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformRemoveTeamMembership>>, TError,{teamName: string;data: PlatformRemoveTeamMembershipBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformRemoveTeamMembership>>,
        TError,
        {teamName: string;data: PlatformRemoveTeamMembershipBody},
        TContext
      > => {

      const mutationOptions = getPlatformRemoveTeamMembershipMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Remove a user from the team
 * @deprecated
 */
export const platformDeleteTeamMembership = (
    teamName: string,
    email: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/memberships/${email}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteTeamMembershipMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, TError,{teamName: string;email: string}, TContext> => {

const mutationKey = ['platformDeleteTeamMembership'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, {teamName: string;email: string}> = (props) => {
          const {teamName,email} = props ?? {};

          return  platformDeleteTeamMembership(teamName,email,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteTeamMembership>>>
    
    export type PlatformDeleteTeamMembershipMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    /**
 * @deprecated
 */
export const usePlatformDeleteTeamMembership = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteTeamMembership>>,
        TError,
        {teamName: string;email: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteTeamMembershipMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all notification destinations
 */
export const platformListAllNotificationDestinations = (
    teamName: string,
    params?: PlatformListAllNotificationDestinationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListAllNotificationDestinations200>(
      {url: `/teams/${teamName}/notifications/destinations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListAllNotificationDestinationsQueryKey = (teamName: string,
    params?: PlatformListAllNotificationDestinationsParams,) => {
    return [`/teams/${teamName}/notifications/destinations`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListAllNotificationDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllNotificationDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllNotificationDestinationsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>> = ({ signal }) => platformListAllNotificationDestinations(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllNotificationDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>>
export type PlatformListAllNotificationDestinationsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllNotificationDestinations<TData = Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllNotificationDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllNotificationDestinations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllNotificationDestinationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create notification destination
 */
export const platformCreateNotificationDestination = (
    teamName: string,
    platformNotificationDestinationCreate: PlatformNotificationDestinationCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformNotificationDestination>(
      {url: `/teams/${teamName}/notifications/destinations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformNotificationDestinationCreate, signal
    },
      );
    }
  


export const getPlatformCreateNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationCreate}, TContext> => {

const mutationKey = ['platformCreateNotificationDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, {teamName: string;data: PlatformNotificationDestinationCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateNotificationDestination(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateNotificationDestination>>>
    export type PlatformCreateNotificationDestinationMutationBody = PlatformNotificationDestinationCreate
    export type PlatformCreateNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateNotificationDestination>>,
        TError,
        {teamName: string;data: PlatformNotificationDestinationCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateNotificationDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Test an unsaved notification destination
 */
export const platformTestUnsavedNotificationDestination = (
    teamName: string,
    platformNotificationDestinationData: PlatformNotificationDestinationData,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformNotificationDestinationTestResponse>(
      {url: `/teams/${teamName}/notifications/destinations/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformNotificationDestinationData, signal
    },
      );
    }
  


export const getPlatformTestUnsavedNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationData}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationData}, TContext> => {

const mutationKey = ['platformTestUnsavedNotificationDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, {teamName: string;data: PlatformNotificationDestinationData}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformTestUnsavedNotificationDestination(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformTestUnsavedNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>>
    export type PlatformTestUnsavedNotificationDestinationMutationBody = PlatformNotificationDestinationData
    export type PlatformTestUnsavedNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTestUnsavedNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>, TError,{teamName: string;data: PlatformNotificationDestinationData}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTestUnsavedNotificationDestination>>,
        TError,
        {teamName: string;data: PlatformNotificationDestinationData},
        TContext
      > => {

      const mutationOptions = getPlatformTestUnsavedNotificationDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get notification destination
 */
export const platformGetNotificationDestination = (
    teamName: string,
    notificationDestinationId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformNotificationDestination>(
      {url: `/teams/${teamName}/notifications/destination/${notificationDestinationId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetNotificationDestinationQueryKey = (teamName: string,
    notificationDestinationId: string,) => {
    return [`/teams/${teamName}/notifications/destination/${notificationDestinationId}`] as const;
    }

    
export const getPlatformGetNotificationDestinationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    notificationDestinationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetNotificationDestinationQueryKey(teamName,notificationDestinationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetNotificationDestination>>> = ({ signal }) => platformGetNotificationDestination(teamName,notificationDestinationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && notificationDestinationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetNotificationDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetNotificationDestination>>>
export type PlatformGetNotificationDestinationQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetNotificationDestination<TData = Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    notificationDestinationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestination>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetNotificationDestinationQueryOptions(teamName,notificationDestinationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a notification destination
 */
export const platformUpdateNotificationDestination = (
    teamName: string,
    notificationDestinationId: string,
    platformNotificationDestinationUpdate: PlatformNotificationDestinationUpdate,
 ) => {
      
      
      return customFetch<PlatformNotificationDestination>(
      {url: `/teams/${teamName}/notifications/destination/${notificationDestinationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformNotificationDestinationUpdate
    },
      );
    }
  


export const getPlatformUpdateNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}, TContext> => {

const mutationKey = ['platformUpdateNotificationDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, {teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}> = (props) => {
          const {teamName,notificationDestinationId,data} = props ?? {};

          return  platformUpdateNotificationDestination(teamName,notificationDestinationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>>
    export type PlatformUpdateNotificationDestinationMutationBody = PlatformNotificationDestinationUpdate
    export type PlatformUpdateNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateNotificationDestination>>,
        TError,
        {teamName: string;notificationDestinationId: string;data: PlatformNotificationDestinationUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateNotificationDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a notification destination
 */
export const platformDeleteNotificationDestination = (
    teamName: string,
    notificationDestinationId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/notifications/destination/${notificationDestinationId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteNotificationDestinationMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext> => {

const mutationKey = ['platformDeleteNotificationDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, {teamName: string;notificationDestinationId: string}> = (props) => {
          const {teamName,notificationDestinationId} = props ?? {};

          return  platformDeleteNotificationDestination(teamName,notificationDestinationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>>
    
    export type PlatformDeleteNotificationDestinationMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteNotificationDestination = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteNotificationDestination>>,
        TError,
        {teamName: string;notificationDestinationId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteNotificationDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get notification destination alerts
 */
export const platformGetNotificationDestinationAlerts = (
    teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetNotificationDestinationAlerts200>(
      {url: `/teams/${teamName}/notifications/destination/${notificationDestinationId}/alerts`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetNotificationDestinationAlertsQueryKey = (teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams,) => {
    return [`/teams/${teamName}/notifications/destination/${notificationDestinationId}/alerts`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetNotificationDestinationAlertsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetNotificationDestinationAlertsQueryKey(teamName,notificationDestinationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>> = ({ signal }) => platformGetNotificationDestinationAlerts(teamName,notificationDestinationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && notificationDestinationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetNotificationDestinationAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>>
export type PlatformGetNotificationDestinationAlertsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetNotificationDestinationAlerts<TData = Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    notificationDestinationId: string,
    params?: PlatformGetNotificationDestinationAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetNotificationDestinationAlerts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetNotificationDestinationAlertsQueryOptions(teamName,notificationDestinationId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Test a notification destination
 */
export const platformTestNotificationDestination = (
    teamName: string,
    notificationDestinationId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformNotificationDestinationTestResponse>(
      {url: `/teams/${teamName}/notifications/destination/${notificationDestinationId}/test`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformTestNotificationDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformTestNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext> => {

const mutationKey = ['platformTestNotificationDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTestNotificationDestination>>, {teamName: string;notificationDestinationId: string}> = (props) => {
          const {teamName,notificationDestinationId} = props ?? {};

          return  platformTestNotificationDestination(teamName,notificationDestinationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformTestNotificationDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformTestNotificationDestination>>>
    
    export type PlatformTestNotificationDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTestNotificationDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTestNotificationDestination>>, TError,{teamName: string;notificationDestinationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTestNotificationDestination>>,
        TError,
        {teamName: string;notificationDestinationId: string},
        TContext
      > => {

      const mutationOptions = getPlatformTestNotificationDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Create an interactive onboarding for AWS
 */
export const platformCreateAWSOnboarding = (
    teamName: string,
    platformCreateAWSOnboardingBody: PlatformCreateAWSOnboardingBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformOnboardingAWSCreateResponse>(
      {url: `/teams/${teamName}/onboardings/aws/oidc`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformCreateAWSOnboardingBody, signal
    },
      );
    }
  


export const getPlatformCreateAWSOnboardingMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, TError,{teamName: string;data: PlatformCreateAWSOnboardingBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, TError,{teamName: string;data: PlatformCreateAWSOnboardingBody}, TContext> => {

const mutationKey = ['platformCreateAWSOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, {teamName: string;data: PlatformCreateAWSOnboardingBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateAWSOnboarding(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateAWSOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>>
    export type PlatformCreateAWSOnboardingMutationBody = PlatformCreateAWSOnboardingBody
    export type PlatformCreateAWSOnboardingMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse

    export const usePlatformCreateAWSOnboarding = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateAWSOnboarding>>, TError,{teamName: string;data: PlatformCreateAWSOnboardingBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateAWSOnboarding>>,
        TError,
        {teamName: string;data: PlatformCreateAWSOnboardingBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreateAWSOnboardingMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Query an interactive onboarding for AWS
 */
export const platformGetAWSOnboarding = (
    teamName: string,
    onboardingId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformOnboardingAWS>(
      {url: `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetAWSOnboardingQueryKey = (teamName: string,
    onboardingId: string,) => {
    return [`/teams/${teamName}/onboardings/aws/oidc/${onboardingId}`] as const;
    }

    
export const getPlatformGetAWSOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAWSOnboardingQueryKey(teamName,onboardingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAWSOnboarding>>> = ({ signal }) => platformGetAWSOnboarding(teamName,onboardingId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && onboardingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAWSOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAWSOnboarding>>>
export type PlatformGetAWSOnboardingQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAWSOnboarding<TData = Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSOnboarding>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAWSOnboardingQueryOptions(teamName,onboardingId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update onboarding state
 */
export const platformNotifyOnboarding = (
    teamName: string,
    onboardingId: string,
    platformOnboardingAWSNotification: PlatformOnboardingAWSNotification,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/notify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformOnboardingAWSNotification, signal
    },
      );
    }
  


export const getPlatformNotifyOnboardingMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformNotifyOnboarding>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformNotifyOnboarding>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}, TContext> => {

const mutationKey = ['platformNotifyOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformNotifyOnboarding>>, {teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}> = (props) => {
          const {teamName,onboardingId,data} = props ?? {};

          return  platformNotifyOnboarding(teamName,onboardingId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformNotifyOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof platformNotifyOnboarding>>>
    export type PlatformNotifyOnboardingMutationBody = PlatformOnboardingAWSNotification
    export type PlatformNotifyOnboardingMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse

    export const usePlatformNotifyOnboarding = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformNotifyOnboarding>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformNotifyOnboarding>>,
        TError,
        {teamName: string;onboardingId: string;data: PlatformOnboardingAWSNotification},
        TContext
      > => {

      const mutationOptions = getPlatformNotifyOnboardingMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Query AWS accounts under organization root
 */
export const platformGetAWSAccountsInRoot = (
    teamName: string,
    onboardingId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformOnboardingAWSAccounts>(
      {url: `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetAWSAccountsInRootQueryKey = (teamName: string,
    onboardingId: string,) => {
    return [`/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts`] as const;
    }

    
export const getPlatformGetAWSAccountsInRootQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAWSAccountsInRootQueryKey(teamName,onboardingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>> = ({ signal }) => platformGetAWSAccountsInRoot(teamName,onboardingId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && onboardingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAWSAccountsInRootQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>>
export type PlatformGetAWSAccountsInRootQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAWSAccountsInRoot<TData = Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    onboardingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInRoot>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAWSAccountsInRootQueryOptions(teamName,onboardingId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Query AWS accounts under a specifc Organizational Unit
 */
export const platformGetAWSAccountsInParent = (
    teamName: string,
    onboardingId: string,
    awsOrgunitId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformOnboardingAWSAccounts>(
      {url: `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts/${awsOrgunitId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetAWSAccountsInParentQueryKey = (teamName: string,
    onboardingId: string,
    awsOrgunitId: string,) => {
    return [`/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts/${awsOrgunitId}`] as const;
    }

    
export const getPlatformGetAWSAccountsInParentQueryOptions = <TData = Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    onboardingId: string,
    awsOrgunitId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetAWSAccountsInParentQueryKey(teamName,onboardingId,awsOrgunitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>> = ({ signal }) => platformGetAWSAccountsInParent(teamName,onboardingId,awsOrgunitId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && onboardingId && awsOrgunitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetAWSAccountsInParentQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>>
export type PlatformGetAWSAccountsInParentQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetAWSAccountsInParent<TData = Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    onboardingId: string,
    awsOrgunitId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetAWSAccountsInParent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetAWSAccountsInParentQueryOptions(teamName,onboardingId,awsOrgunitId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Provision onboarding configuration into the cloud account
 */
export const platformProvisionOnboardingConfiguration = (
    teamName: string,
    onboardingId: string,
    platformOnboardingAWSProvision: PlatformOnboardingAWSProvision,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/onboardings/aws/oidc/${onboardingId}/accounts/provision`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformOnboardingAWSProvision, signal
    },
      );
    }
  


export const getPlatformProvisionOnboardingConfigurationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}, TContext> => {

const mutationKey = ['platformProvisionOnboardingConfiguration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, {teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}> = (props) => {
          const {teamName,onboardingId,data} = props ?? {};

          return  platformProvisionOnboardingConfiguration(teamName,onboardingId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformProvisionOnboardingConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>>
    export type PlatformProvisionOnboardingConfigurationMutationBody = PlatformOnboardingAWSProvision
    export type PlatformProvisionOnboardingConfigurationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformProvisionOnboardingConfiguration = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>, TError,{teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformProvisionOnboardingConfiguration>>,
        TError,
        {teamName: string;onboardingId: string;data: PlatformOnboardingAWSProvision},
        TContext
      > => {

      const mutationOptions = getPlatformProvisionOnboardingConfigurationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all plugins for the team.
 */
export const platformListPluginsByTeam = (
    teamName: string,
    params?: PlatformListPluginsByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPluginsByTeam200>(
      {url: `/teams/${teamName}/plugins`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPluginsByTeamQueryKey = (teamName: string,
    params?: PlatformListPluginsByTeamParams,) => {
    return [`/teams/${teamName}/plugins`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPluginsByTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPluginsByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPluginsByTeam>>> = ({ signal }) => platformListPluginsByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPluginsByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPluginsByTeam>>>
export type PlatformListPluginsByTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListPluginsByTeam<TData = Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPluginsByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPluginsByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete plugins by team
 */
export const platformDeletePluginsByTeam = (
    teamName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/plugins`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeletePluginsByTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, TError,{teamName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['platformDeletePluginsByTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  platformDeletePluginsByTeam(teamName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePluginsByTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>>
    
    export type PlatformDeletePluginsByTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformDeletePluginsByTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePluginsByTeam>>, TError,{teamName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePluginsByTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeletePluginsByTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Download an asset for a given plugin version as the current team.
 */
export const platformDownloadPluginAssetByTeam = (
    teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformPluginAsset>(
      {url: `/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformDownloadPluginAssetByTeamQueryKey = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [`/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`] as const;
    }

    
export const getPlatformDownloadPluginAssetByTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformDownloadPluginAssetByTeamQueryKey(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>> = ({ signal }) => platformDownloadPluginAssetByTeam(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginTeam && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformDownloadPluginAssetByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>>
export type PlatformDownloadPluginAssetByTeamQueryError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse



export function usePlatformDownloadPluginAssetByTeam<TData = Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError = void | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse>(
 teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPluginAssetByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformDownloadPluginAssetByTeamQueryOptions(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Policies
 */
export const platformListPolicies = (
    teamName: string,
    params?: PlatformListPoliciesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPolicies200>(
      {url: `/teams/${teamName}/policies`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPoliciesQueryKey = (teamName: string,
    params?: PlatformListPoliciesParams,) => {
    return [`/teams/${teamName}/policies`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicies>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicies>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPoliciesQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicies>>> = ({ signal }) => platformListPolicies(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicies>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicies>>>
export type PlatformListPoliciesQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicies<TData = Awaited<ReturnType<typeof platformListPolicies>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicies>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPoliciesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Policy
 */
export const platformCreatePolicy = (
    teamName: string,
    platformCreateOrUpdatePolicy: PlatformCreateOrUpdatePolicy,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCreatePolicy201>(
      {url: `/teams/${teamName}/policies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformCreateOrUpdatePolicy, signal
    },
      );
    }
  


export const getPlatformCreatePolicyMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePolicy>>, TError,{teamName: string;data: PlatformCreateOrUpdatePolicy}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreatePolicy>>, TError,{teamName: string;data: PlatformCreateOrUpdatePolicy}, TContext> => {

const mutationKey = ['platformCreatePolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreatePolicy>>, {teamName: string;data: PlatformCreateOrUpdatePolicy}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreatePolicy(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreatePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreatePolicy>>>
    export type PlatformCreatePolicyMutationBody = PlatformCreateOrUpdatePolicy
    export type PlatformCreatePolicyMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse

    export const usePlatformCreatePolicy = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreatePolicy>>, TError,{teamName: string;data: PlatformCreateOrUpdatePolicy}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreatePolicy>>,
        TError,
        {teamName: string;data: PlatformCreateOrUpdatePolicy},
        TContext
      > => {

      const mutationOptions = getPlatformCreatePolicyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List All Frameworks
 */
export const platformListAllFrameworks = (
    teamName: string,
    params?: PlatformListAllFrameworksParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListAllFrameworks200>(
      {url: `/teams/${teamName}/policies/frameworks`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListAllFrameworksQueryKey = (teamName: string,
    params?: PlatformListAllFrameworksParams,) => {
    return [`/teams/${teamName}/policies/frameworks`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListAllFrameworksQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllFrameworks>>, TError = PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListAllFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllFrameworks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllFrameworksQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllFrameworks>>> = ({ signal }) => platformListAllFrameworks(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllFrameworks>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllFrameworksQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllFrameworks>>>
export type PlatformListAllFrameworksQueryError = PlatformNotFoundResponse



export function usePlatformListAllFrameworks<TData = Awaited<ReturnType<typeof platformListAllFrameworks>>, TError = PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListAllFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllFrameworks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllFrameworksQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Policy
 */
export const platformGetPolicy = (
    teamName: string,
    policyId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetPolicy200>(
      {url: `/teams/${teamName}/policies/${policyId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetPolicyQueryKey = (teamName: string,
    policyId: string,) => {
    return [`/teams/${teamName}/policies/${policyId}`] as const;
    }

    
export const getPlatformGetPolicyQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPolicy>>, TError = PlatformNotFoundResponse>(teamName: string,
    policyId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicy>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPolicyQueryKey(teamName,policyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPolicy>>> = ({ signal }) => platformGetPolicy(teamName,policyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicy>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPolicy>>>
export type PlatformGetPolicyQueryError = PlatformNotFoundResponse



export function usePlatformGetPolicy<TData = Awaited<ReturnType<typeof platformGetPolicy>>, TError = PlatformNotFoundResponse>(
 teamName: string,
    policyId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicy>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPolicyQueryOptions(teamName,policyId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Policy
 */
export const platformUpdatePolicy = (
    teamName: string,
    policyId: string,
    platformCreateOrUpdatePolicy: PlatformCreateOrUpdatePolicy,
 ) => {
      
      
      return customFetch<PlatformUpdatePolicy200>(
      {url: `/teams/${teamName}/policies/${policyId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformCreateOrUpdatePolicy
    },
      );
    }
  


export const getPlatformUpdatePolicyMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePolicy>>, TError,{teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePolicy>>, TError,{teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}, TContext> => {

const mutationKey = ['platformUpdatePolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdatePolicy>>, {teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}> = (props) => {
          const {teamName,policyId,data} = props ?? {};

          return  platformUpdatePolicy(teamName,policyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdatePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdatePolicy>>>
    export type PlatformUpdatePolicyMutationBody = PlatformCreateOrUpdatePolicy
    export type PlatformUpdatePolicyMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformUpdatePolicy = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdatePolicy>>, TError,{teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdatePolicy>>,
        TError,
        {teamName: string;policyId: string;data: PlatformCreateOrUpdatePolicy},
        TContext
      > => {

      const mutationOptions = getPlatformUpdatePolicyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete Policy
 */
export const platformDeletePolicy = (
    teamName: string,
    policyId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/policies/${policyId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeletePolicyMutationOptions = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePolicy>>, TError,{teamName: string;policyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeletePolicy>>, TError,{teamName: string;policyId: string}, TContext> => {

const mutationKey = ['platformDeletePolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeletePolicy>>, {teamName: string;policyId: string}> = (props) => {
          const {teamName,policyId} = props ?? {};

          return  platformDeletePolicy(teamName,policyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeletePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeletePolicy>>>
    
    export type PlatformDeletePolicyMutationError = PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformDeletePolicy = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeletePolicy>>, TError,{teamName: string;policyId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeletePolicy>>,
        TError,
        {teamName: string;policyId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeletePolicyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Policy Frameworks
 */
export const platformListPolicyFrameworks = (
    teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPolicyFrameworks200>(
      {url: `/teams/${teamName}/policies/${policyId}/frameworks`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPolicyFrameworksQueryKey = (teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams,) => {
    return [`/teams/${teamName}/policies/${policyId}/frameworks`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPolicyFrameworksQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPolicyFrameworksQueryKey(teamName,policyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicyFrameworks>>> = ({ signal }) => platformListPolicyFrameworks(teamName,policyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPolicyFrameworksQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicyFrameworks>>>
export type PlatformListPolicyFrameworksQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicyFrameworks<TData = Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    policyId: string,
    params?: PlatformListPolicyFrameworksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyFrameworks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPolicyFrameworksQueryOptions(teamName,policyId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Policy Rules
 */
export const platformListPolicyRules = (
    teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPolicyRules200>(
      {url: `/teams/${teamName}/policies/${policyId}/rules`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPolicyRulesQueryKey = (teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams,) => {
    return [`/teams/${teamName}/policies/${policyId}/rules`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPolicyRulesQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicyRules>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRules>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPolicyRulesQueryKey(teamName,policyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicyRules>>> = ({ signal }) => platformListPolicyRules(teamName,policyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRules>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPolicyRulesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicyRules>>>
export type PlatformListPolicyRulesQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicyRules<TData = Awaited<ReturnType<typeof platformListPolicyRules>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    policyId: string,
    params?: PlatformListPolicyRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRules>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPolicyRulesQueryOptions(teamName,policyId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Policy Rule Details
 */
export const platformListPolicyRuleDetails = (
    teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListPolicyRuleDetails200>(
      {url: `/teams/${teamName}/policies/${policyId}/rules/${ruleId}/details`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListPolicyRuleDetailsQueryKey = (teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams,) => {
    return [`/teams/${teamName}/policies/${policyId}/rules/${ruleId}/details`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListPolicyRuleDetailsQueryOptions = <TData = Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListPolicyRuleDetailsQueryKey(teamName,policyId,ruleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>> = ({ signal }) => platformListPolicyRuleDetails(teamName,policyId,ruleId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && policyId && ruleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListPolicyRuleDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>>
export type PlatformListPolicyRuleDetailsQueryError = PlatformBadRequestResponse | PlatformNotFoundResponse



export function usePlatformListPolicyRuleDetails<TData = Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError = PlatformBadRequestResponse | PlatformNotFoundResponse>(
 teamName: string,
    policyId: string,
    ruleId: string,
    params?: PlatformListPolicyRuleDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListPolicyRuleDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListPolicyRuleDetailsQueryOptions(teamName,policyId,ruleId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Toggle Policy status
 */
export const platformTogglePolicy = (
    teamName: string,
    policyId: string,
    params: PlatformTogglePolicyParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/policies/${policyId}/toggle`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getPlatformTogglePolicyMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTogglePolicy>>, TError,{teamName: string;policyId: string;params: PlatformTogglePolicyParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformTogglePolicy>>, TError,{teamName: string;policyId: string;params: PlatformTogglePolicyParams}, TContext> => {

const mutationKey = ['platformTogglePolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTogglePolicy>>, {teamName: string;policyId: string;params: PlatformTogglePolicyParams}> = (props) => {
          const {teamName,policyId,params} = props ?? {};

          return  platformTogglePolicy(teamName,policyId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformTogglePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof platformTogglePolicy>>>
    
    export type PlatformTogglePolicyMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformTogglePolicy = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTogglePolicy>>, TError,{teamName: string;policyId: string;params: PlatformTogglePolicyParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTogglePolicy>>,
        TError,
        {teamName: string;policyId: string;params: PlatformTogglePolicyParams},
        TContext
      > => {

      const mutationOptions = getPlatformTogglePolicyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get Policy Violations History for defined period.
 */
export const platformGetPolicyViolationsHistory = (
    teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetPolicyViolationsHistory200>(
      {url: `/teams/${teamName}/policies/${policyId}/violations-history`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetPolicyViolationsHistoryQueryKey = (teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams,) => {
    return [`/teams/${teamName}/policies/${policyId}/violations-history`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetPolicyViolationsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError = PlatformBadRequestResponse>(teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetPolicyViolationsHistoryQueryKey(teamName,policyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>> = ({ signal }) => platformGetPolicyViolationsHistory(teamName,policyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetPolicyViolationsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>>
export type PlatformGetPolicyViolationsHistoryQueryError = PlatformBadRequestResponse



export function usePlatformGetPolicyViolationsHistory<TData = Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError = PlatformBadRequestResponse>(
 teamName: string,
    policyId: string,
    params?: PlatformGetPolicyViolationsHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetPolicyViolationsHistory>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetPolicyViolationsHistoryQueryOptions(teamName,policyId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all queries
 */
export const platformListAllQueriesTeam = (
    teamName: string,
    params?: PlatformListAllQueriesTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListAllQueriesTeam200>(
      {url: `/teams/${teamName}/queries`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListAllQueriesTeamQueryKey = (teamName: string,
    params?: PlatformListAllQueriesTeamParams,) => {
    return [`/teams/${teamName}/queries`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListAllQueriesTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListAllQueriesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListAllQueriesTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAllQueriesTeam>>> = ({ signal }) => platformListAllQueriesTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListAllQueriesTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAllQueriesTeam>>>
export type PlatformListAllQueriesTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListAllQueriesTeam<TData = Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListAllQueriesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListAllQueriesTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListAllQueriesTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Run an ad-hoc SQL query against any table.
Further filtering can optionally be applied on top of the raw SQL results using the optional parameters. Filtering can be useful in situations where a saved query needs to be further filtered, grouped or paginated, such as in dashboards or reports.

 */
export const platformExecuteAdHocQueryTeam = (
    teamName: string,
    platformExecuteAdHocQueryTeamBody: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformExecuteAdHocQueryTeam200>(
      {url: `/teams/${teamName}/queries/execute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformExecuteAdHocQueryTeamBody,
        params, signal
    },
      );
    }
  

export const getPlatformExecuteAdHocQueryTeamQueryKey = (teamName: string,
    platformExecuteAdHocQueryTeamBody: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams,) => {
    return [`/teams/${teamName}/queries/execute`, ...(params ? [params]: []), platformExecuteAdHocQueryTeamBody] as const;
    }

    
export const getPlatformExecuteAdHocQueryTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    platformExecuteAdHocQueryTeamBody: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformExecuteAdHocQueryTeamQueryKey(teamName,platformExecuteAdHocQueryTeamBody,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>> = ({ signal }) => platformExecuteAdHocQueryTeam(teamName,platformExecuteAdHocQueryTeamBody,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformExecuteAdHocQueryTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>>
export type PlatformExecuteAdHocQueryTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformExecuteAdHocQueryTeam<TData = Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    platformExecuteAdHocQueryTeamBody: PlatformExecuteAdHocQueryTeamBody,
    params?: PlatformExecuteAdHocQueryTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformExecuteAdHocQueryTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformExecuteAdHocQueryTeamQueryOptions(teamName,platformExecuteAdHocQueryTeamBody,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Save a query to execute later
 */
export const platformSaveQueryTeam = (
    teamName: string,
    platformQueryCreate: PlatformQueryCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformQueryDetail>(
      {url: `/teams/${teamName}/queries/save`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformQueryCreate, signal
    },
      );
    }
  


export const getPlatformSaveQueryTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveQueryTeam>>, TError,{teamName: string;data: PlatformQueryCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformSaveQueryTeam>>, TError,{teamName: string;data: PlatformQueryCreate}, TContext> => {

const mutationKey = ['platformSaveQueryTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSaveQueryTeam>>, {teamName: string;data: PlatformQueryCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformSaveQueryTeam(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformSaveQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformSaveQueryTeam>>>
    export type PlatformSaveQueryTeamMutationBody = PlatformQueryCreate
    export type PlatformSaveQueryTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformSaveQueryTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSaveQueryTeam>>, TError,{teamName: string;data: PlatformQueryCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSaveQueryTeam>>,
        TError,
        {teamName: string;data: PlatformQueryCreate},
        TContext
      > => {

      const mutationOptions = getPlatformSaveQueryTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Query Tags
 */
export const platformListQueryTagsTeam = (
    teamName: string,
    params?: PlatformListQueryTagsTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListQueryTagsTeam200>(
      {url: `/teams/${teamName}/queries/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListQueryTagsTeamQueryKey = (teamName: string,
    params?: PlatformListQueryTagsTeamParams,) => {
    return [`/teams/${teamName}/queries/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListQueryTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListQueryTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListQueryTagsTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListQueryTagsTeam>>> = ({ signal }) => platformListQueryTagsTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListQueryTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListQueryTagsTeam>>>
export type PlatformListQueryTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListQueryTagsTeam<TData = Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListQueryTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListQueryTagsTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListQueryTagsTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a saved query
 */
export const platformGetSavedQueryTeam = (
    teamName: string,
    queryId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformQueryDetail>(
      {url: `/teams/${teamName}/queries/${queryId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSavedQueryTeamQueryKey = (teamName: string,
    queryId: string,) => {
    return [`/teams/${teamName}/queries/${queryId}`] as const;
    }

    
export const getPlatformGetSavedQueryTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSavedQueryTeamQueryKey(teamName,queryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>> = ({ signal }) => platformGetSavedQueryTeam(teamName,queryId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSavedQueryTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>>
export type PlatformGetSavedQueryTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSavedQueryTeam<TData = Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSavedQueryTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSavedQueryTeamQueryOptions(teamName,queryId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a saved query
 */
export const platformUpdateQueryTeam = (
    teamName: string,
    queryId: string,
    platformQueryUpdate: PlatformQueryUpdate,
 ) => {
      
      
      return customFetch<PlatformQueryDetail>(
      {url: `/teams/${teamName}/queries/${queryId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformQueryUpdate
    },
      );
    }
  


export const getPlatformUpdateQueryTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, TError,{teamName: string;queryId: string;data: PlatformQueryUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, TError,{teamName: string;queryId: string;data: PlatformQueryUpdate}, TContext> => {

const mutationKey = ['platformUpdateQueryTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, {teamName: string;queryId: string;data: PlatformQueryUpdate}> = (props) => {
          const {teamName,queryId,data} = props ?? {};

          return  platformUpdateQueryTeam(teamName,queryId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateQueryTeam>>>
    export type PlatformUpdateQueryTeamMutationBody = PlatformQueryUpdate
    export type PlatformUpdateQueryTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateQueryTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateQueryTeam>>, TError,{teamName: string;queryId: string;data: PlatformQueryUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateQueryTeam>>,
        TError,
        {teamName: string;queryId: string;data: PlatformQueryUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateQueryTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a saved query
 */
export const platformDeleteSavedQueryTeam = (
    teamName: string,
    queryId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/queries/${queryId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteSavedQueryTeamMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, TError,{teamName: string;queryId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, TError,{teamName: string;queryId: string}, TContext> => {

const mutationKey = ['platformDeleteSavedQueryTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, {teamName: string;queryId: string}> = (props) => {
          const {teamName,queryId} = props ?? {};

          return  platformDeleteSavedQueryTeam(teamName,queryId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSavedQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>>
    
    export type PlatformDeleteSavedQueryTeamMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSavedQueryTeam = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>, TError,{teamName: string;queryId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSavedQueryTeam>>,
        TError,
        {teamName: string;queryId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteSavedQueryTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete alert from saved query
 */
export const platformDeleteAlert = (
    teamName: string,
    queryId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/queries/${queryId}/alert`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteAlertMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteAlert>>, TError,{teamName: string;queryId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteAlert>>, TError,{teamName: string;queryId: string}, TContext> => {

const mutationKey = ['platformDeleteAlert'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteAlert>>, {teamName: string;queryId: string}> = (props) => {
          const {teamName,queryId} = props ?? {};

          return  platformDeleteAlert(teamName,queryId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteAlertMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteAlert>>>
    
    export type PlatformDeleteAlertMutationError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteAlert = <TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteAlert>>, TError,{teamName: string;queryId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteAlert>>,
        TError,
        {teamName: string;queryId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteAlertMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Execute a saved query
 */
export const platformExecuteSavedQueryTeam = (
    teamName: string,
    queryId: string,
    params?: PlatformExecuteSavedQueryTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformExecuteSavedQueryTeam200>(
      {url: `/teams/${teamName}/queries/${queryId}/execute`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getPlatformExecuteSavedQueryTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, TError,{teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, TError,{teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}, TContext> => {

const mutationKey = ['platformExecuteSavedQueryTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, {teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}> = (props) => {
          const {teamName,queryId,params} = props ?? {};

          return  platformExecuteSavedQueryTeam(teamName,queryId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformExecuteSavedQueryTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>>
    
    export type PlatformExecuteSavedQueryTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformExecuteSavedQueryTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>, TError,{teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformExecuteSavedQueryTeam>>,
        TError,
        {teamName: string;queryId: string;params?: PlatformExecuteSavedQueryTeamParams},
        TContext
      > => {

      const mutationOptions = getPlatformExecuteSavedQueryTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Query Filters
 */
export const platformQueryListFiltersTeam = (
    teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformQueryListFiltersTeam200>(
      {url: `/teams/${teamName}/queries/${queryId}/filters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformQueryListFiltersTeamQueryKey = (teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams,) => {
    return [`/teams/${teamName}/queries/${queryId}/filters`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformQueryListFiltersTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformQueryListFiltersTeamQueryKey(teamName,queryId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>> = ({ signal }) => platformQueryListFiltersTeam(teamName,queryId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformQueryListFiltersTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>>
export type PlatformQueryListFiltersTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformQueryListFiltersTeam<TData = Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    queryId: string,
    params?: PlatformQueryListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFiltersTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformQueryListFiltersTeamQueryOptions(teamName,queryId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Save Query Filter
 */
export const platformQuerySaveFilterTeam = (
    teamName: string,
    queryId: string,
    platformFilterCreate: PlatformFilterCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformFilter>(
      {url: `/teams/${teamName}/queries/${queryId}/filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformFilterCreate, signal
    },
      );
    }
  


export const getPlatformQuerySaveFilterTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, TError,{teamName: string;queryId: string;data: PlatformFilterCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, TError,{teamName: string;queryId: string;data: PlatformFilterCreate}, TContext> => {

const mutationKey = ['platformQuerySaveFilterTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, {teamName: string;queryId: string;data: PlatformFilterCreate}> = (props) => {
          const {teamName,queryId,data} = props ?? {};

          return  platformQuerySaveFilterTeam(teamName,queryId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformQuerySaveFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>>
    export type PlatformQuerySaveFilterTeamMutationBody = PlatformFilterCreate
    export type PlatformQuerySaveFilterTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformQuerySaveFilterTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>, TError,{teamName: string;queryId: string;data: PlatformFilterCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformQuerySaveFilterTeam>>,
        TError,
        {teamName: string;queryId: string;data: PlatformFilterCreate},
        TContext
      > => {

      const mutationOptions = getPlatformQuerySaveFilterTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Filter Tags For A Saved Query
 */
export const platformQueryListFilterTagsTeam = (
    teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformQueryListFilterTagsTeam200>(
      {url: `/teams/${teamName}/queries/${queryId}/filters/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformQueryListFilterTagsTeamQueryKey = (teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams,) => {
    return [`/teams/${teamName}/queries/${queryId}/filters/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformQueryListFilterTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformQueryListFilterTagsTeamQueryKey(teamName,queryId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>> = ({ signal }) => platformQueryListFilterTagsTeam(teamName,queryId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformQueryListFilterTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>>
export type PlatformQueryListFilterTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformQueryListFilterTagsTeam<TData = Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    queryId: string,
    params?: PlatformQueryListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformQueryListFilterTagsTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformQueryListFilterTagsTeamQueryOptions(teamName,queryId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List reports
 */
export const platformListReports = (
    teamName: string,
    params?: PlatformListReportsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListReports200>(
      {url: `/teams/${teamName}/reports`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListReportsQueryKey = (teamName: string,
    params?: PlatformListReportsParams,) => {
    return [`/teams/${teamName}/reports`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListReportsQueryOptions = <TData = Awaited<ReturnType<typeof platformListReports>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReports>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListReportsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListReports>>> = ({ signal }) => platformListReports(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListReports>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListReportsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListReports>>>
export type PlatformListReportsQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformListReports<TData = Awaited<ReturnType<typeof platformListReports>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReports>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListReportsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Report
 */
export const platformCreateReport = (
    teamName: string,
    platformReportCreateOrUpdate: PlatformReportCreateOrUpdate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCreateReport201>(
      {url: `/teams/${teamName}/reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformReportCreateOrUpdate, signal
    },
      );
    }
  


export const getPlatformCreateReportMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReport>>, TError,{teamName: string;data: PlatformReportCreateOrUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateReport>>, TError,{teamName: string;data: PlatformReportCreateOrUpdate}, TContext> => {

const mutationKey = ['platformCreateReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateReport>>, {teamName: string;data: PlatformReportCreateOrUpdate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateReport(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateReport>>>
    export type PlatformCreateReportMutationBody = PlatformReportCreateOrUpdate
    export type PlatformCreateReportMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse

    export const usePlatformCreateReport = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReport>>, TError,{teamName: string;data: PlatformReportCreateOrUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateReport>>,
        TError,
        {teamName: string;data: PlatformReportCreateOrUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateReportMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get Report
 */
export const platformGetReport = (
    teamName: string,
    reportId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetReport200>(
      {url: `/teams/${teamName}/reports/${reportId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetReportQueryKey = (teamName: string,
    reportId: string,) => {
    return [`/teams/${teamName}/reports/${reportId}`] as const;
    }

    
export const getPlatformGetReportQueryOptions = <TData = Awaited<ReturnType<typeof platformGetReport>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    reportId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetReportQueryKey(teamName,reportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetReport>>> = ({ signal }) => platformGetReport(teamName,reportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && reportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetReport>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetReportQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetReport>>>
export type PlatformGetReportQueryError = PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformGetReport<TData = Awaited<ReturnType<typeof platformGetReport>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    reportId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetReportQueryOptions(teamName,reportId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Report
 */
export const platformUpdateReport = (
    teamName: string,
    reportId: string,
    platformReportCreateOrUpdate: PlatformReportCreateOrUpdate,
 ) => {
      
      
      return customFetch<PlatformUpdateReport200>(
      {url: `/teams/${teamName}/reports/${reportId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformReportCreateOrUpdate
    },
      );
    }
  


export const getPlatformUpdateReportMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReport>>, TError,{teamName: string;reportId: string;data: PlatformReportCreateOrUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReport>>, TError,{teamName: string;reportId: string;data: PlatformReportCreateOrUpdate}, TContext> => {

const mutationKey = ['platformUpdateReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateReport>>, {teamName: string;reportId: string;data: PlatformReportCreateOrUpdate}> = (props) => {
          const {teamName,reportId,data} = props ?? {};

          return  platformUpdateReport(teamName,reportId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateReportMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateReport>>>
    export type PlatformUpdateReportMutationBody = PlatformReportCreateOrUpdate
    export type PlatformUpdateReportMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformUpdateReport = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReport>>, TError,{teamName: string;reportId: string;data: PlatformReportCreateOrUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateReport>>,
        TError,
        {teamName: string;reportId: string;data: PlatformReportCreateOrUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateReportMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete Report
 */
export const platformDeleteReport = (
    teamName: string,
    reportId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/reports/${reportId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteReportMutationOptions = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReport>>, TError,{teamName: string;reportId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReport>>, TError,{teamName: string;reportId: string}, TContext> => {

const mutationKey = ['platformDeleteReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteReport>>, {teamName: string;reportId: string}> = (props) => {
          const {teamName,reportId} = props ?? {};

          return  platformDeleteReport(teamName,reportId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteReportMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteReport>>>
    
    export type PlatformDeleteReportMutationError = PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformDeleteReport = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReport>>, TError,{teamName: string;reportId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteReport>>,
        TError,
        {teamName: string;reportId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteReportMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List report templates
 */
export const platformListReportTemplates = (
    teamName: string,
    params?: PlatformListReportTemplatesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListReportTemplates200>(
      {url: `/teams/${teamName}/reports/templates`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListReportTemplatesQueryKey = (teamName: string,
    params?: PlatformListReportTemplatesParams,) => {
    return [`/teams/${teamName}/reports/templates`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListReportTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof platformListReportTemplates>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    params?: PlatformListReportTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReportTemplates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListReportTemplatesQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListReportTemplates>>> = ({ signal }) => platformListReportTemplates(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListReportTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListReportTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListReportTemplates>>>
export type PlatformListReportTemplatesQueryError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformListReportTemplates<TData = Awaited<ReturnType<typeof platformListReportTemplates>>, TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    params?: PlatformListReportTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListReportTemplates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListReportTemplatesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Report Template
 */
export const platformCreateReportTemplate = (
    teamName: string,
    platformReportTemplateCreateOrUpdate: PlatformReportTemplateCreateOrUpdate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCreateReportTemplate201>(
      {url: `/teams/${teamName}/reports/templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformReportTemplateCreateOrUpdate, signal
    },
      );
    }
  


export const getPlatformCreateReportTemplateMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReportTemplate>>, TError,{teamName: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateReportTemplate>>, TError,{teamName: string;data: PlatformReportTemplateCreateOrUpdate}, TContext> => {

const mutationKey = ['platformCreateReportTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateReportTemplate>>, {teamName: string;data: PlatformReportTemplateCreateOrUpdate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateReportTemplate(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateReportTemplate>>>
    export type PlatformCreateReportTemplateMutationBody = PlatformReportTemplateCreateOrUpdate
    export type PlatformCreateReportTemplateMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse

    export const usePlatformCreateReportTemplate = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateReportTemplate>>, TError,{teamName: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateReportTemplate>>,
        TError,
        {teamName: string;data: PlatformReportTemplateCreateOrUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateReportTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get Report Template
 */
export const platformGetReportTemplate = (
    teamName: string,
    templateId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetReportTemplate200>(
      {url: `/teams/${teamName}/reports/templates/${templateId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetReportTemplateQueryKey = (teamName: string,
    templateId: string,) => {
    return [`/teams/${teamName}/reports/templates/${templateId}`] as const;
    }

    
export const getPlatformGetReportTemplateQueryOptions = <TData = Awaited<ReturnType<typeof platformGetReportTemplate>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(teamName: string,
    templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReportTemplate>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetReportTemplateQueryKey(teamName,templateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetReportTemplate>>> = ({ signal }) => platformGetReportTemplate(teamName,templateId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && templateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetReportTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetReportTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetReportTemplate>>>
export type PlatformGetReportTemplateQueryError = PlatformForbiddenResponse | PlatformNotFoundResponse



export function usePlatformGetReportTemplate<TData = Awaited<ReturnType<typeof platformGetReportTemplate>>, TError = PlatformForbiddenResponse | PlatformNotFoundResponse>(
 teamName: string,
    templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetReportTemplate>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetReportTemplateQueryOptions(teamName,templateId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Report Template
 */
export const platformUpdateReportTemplate = (
    teamName: string,
    templateId: string,
    platformReportTemplateCreateOrUpdate: PlatformReportTemplateCreateOrUpdate,
 ) => {
      
      
      return customFetch<PlatformUpdateReportTemplate200>(
      {url: `/teams/${teamName}/reports/templates/${templateId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: platformReportTemplateCreateOrUpdate
    },
      );
    }
  


export const getPlatformUpdateReportTemplateMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, TError,{teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, TError,{teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}, TContext> => {

const mutationKey = ['platformUpdateReportTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, {teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}> = (props) => {
          const {teamName,templateId,data} = props ?? {};

          return  platformUpdateReportTemplate(teamName,templateId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateReportTemplate>>>
    export type PlatformUpdateReportTemplateMutationBody = PlatformReportTemplateCreateOrUpdate
    export type PlatformUpdateReportTemplateMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformUpdateReportTemplate = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateReportTemplate>>, TError,{teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateReportTemplate>>,
        TError,
        {teamName: string;templateId: string;data: PlatformReportTemplateCreateOrUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateReportTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete Report Template
 */
export const platformDeleteReportTemplate = (
    teamName: string,
    templateId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/reports/templates/${templateId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteReportTemplateMutationOptions = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, TError,{teamName: string;templateId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, TError,{teamName: string;templateId: string}, TContext> => {

const mutationKey = ['platformDeleteReportTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, {teamName: string;templateId: string}> = (props) => {
          const {teamName,templateId} = props ?? {};

          return  platformDeleteReportTemplate(teamName,templateId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteReportTemplate>>>
    
    export type PlatformDeleteReportTemplateMutationError = PlatformForbiddenResponse | PlatformNotFoundResponse

    export const usePlatformDeleteReportTemplate = <TError = PlatformForbiddenResponse | PlatformNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteReportTemplate>>, TError,{teamName: string;templateId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteReportTemplate>>,
        TError,
        {teamName: string;templateId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteReportTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Create a test destination connection.
 */
export const platformCreateSyncDestinationTestConnection = (
    teamName: string,
    platformSyncDestinationTestConnectionCreate: PlatformSyncDestinationTestConnectionCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncDestinationTestConnection>(
      {url: `/teams/${teamName}/sync-destination-test-connections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncDestinationTestConnectionCreate, signal
    },
      );
    }
  


export const getPlatformCreateSyncDestinationTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformSyncDestinationTestConnectionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformSyncDestinationTestConnectionCreate}, TContext> => {

const mutationKey = ['platformCreateSyncDestinationTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, {teamName: string;data: PlatformSyncDestinationTestConnectionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateSyncDestinationTestConnection(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncDestinationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>>
    export type PlatformCreateSyncDestinationTestConnectionMutationBody = PlatformSyncDestinationTestConnectionCreate
    export type PlatformCreateSyncDestinationTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncDestinationTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>, TError,{teamName: string;data: PlatformSyncDestinationTestConnectionCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncDestinationTestConnection>>,
        TError,
        {teamName: string;data: PlatformSyncDestinationTestConnectionCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateSyncDestinationTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a sync destination test connection.
 */
export const platformGetSyncDestinationTestConnection = (
    teamName: string,
    syncDestinationTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncDestinationTestConnection>(
      {url: `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncDestinationTestConnectionQueryKey = (teamName: string,
    syncDestinationTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`] as const;
    }

    
export const getPlatformGetSyncDestinationTestConnectionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationTestConnectionQueryKey(teamName,syncDestinationTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>> = ({ signal }) => platformGetSyncDestinationTestConnection(teamName,syncDestinationTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationTestConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>>
export type PlatformGetSyncDestinationTestConnectionQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncDestinationTestConnection<TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnection>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationTestConnectionQueryOptions(teamName,syncDestinationTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a sync destination test connection.
 */
export const platformUpdateSyncTestConnectionForSyncDestination = (
    teamName: string,
    syncDestinationTestConnectionId: string,
    platformUpdateSyncTestConnectionForSyncDestinationBody: PlatformUpdateSyncTestConnectionForSyncDestinationBody,
 ) => {
      
      
      return customFetch<PlatformSyncDestinationTestConnection>(
      {url: `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateSyncTestConnectionForSyncDestinationBody
    },
      );
    }
  


export const getPlatformUpdateSyncTestConnectionForSyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}, TContext> => {

const mutationKey = ['platformUpdateSyncTestConnectionForSyncDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, {teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}> = (props) => {
          const {teamName,syncDestinationTestConnectionId,data} = props ?? {};

          return  platformUpdateSyncTestConnectionForSyncDestination(teamName,syncDestinationTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncTestConnectionForSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>>
    export type PlatformUpdateSyncTestConnectionForSyncDestinationMutationBody = PlatformUpdateSyncTestConnectionForSyncDestinationBody
    export type PlatformUpdateSyncTestConnectionForSyncDestinationMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncTestConnectionForSyncDestination = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncDestination>>,
        TError,
        {teamName: string;syncDestinationTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncDestinationBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncTestConnectionForSyncDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get logs for a sync destination test connection.
 */
export const platformGetSyncDestinationTestConnectionLogs = (
    teamName: string,
    syncDestinationTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetSyncDestinationTestConnectionLogs200One | string | void>(
      {url: `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncDestinationTestConnectionLogsQueryKey = (teamName: string,
    syncDestinationTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/logs`] as const;
    }

    
export const getPlatformGetSyncDestinationTestConnectionLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationTestConnectionLogsQueryKey(teamName,syncDestinationTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>> = ({ signal }) => platformGetSyncDestinationTestConnectionLogs(teamName,syncDestinationTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationTestConnectionLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>>
export type PlatformGetSyncDestinationTestConnectionLogsQueryError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncDestinationTestConnectionLogs<TData = Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestinationTestConnectionLogs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationTestConnectionLogsQueryOptions(teamName,syncDestinationTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Promote a sync destination test connection to a sync destination.
 */
export const platformPromoteSyncDestinationTestConnection = (
    teamName: string,
    syncDestinationTestConnectionId: string,
    platformPromoteSyncDestinationTestConnection: PlatformPromoteSyncDestinationTestConnection,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncDestination>(
      {url: `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/promote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformPromoteSyncDestinationTestConnection, signal
    },
      );
    }
  


export const getPlatformPromoteSyncDestinationTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}, TContext> => {

const mutationKey = ['platformPromoteSyncDestinationTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, {teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}> = (props) => {
          const {teamName,syncDestinationTestConnectionId,data} = props ?? {};

          return  platformPromoteSyncDestinationTestConnection(teamName,syncDestinationTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformPromoteSyncDestinationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>>
    export type PlatformPromoteSyncDestinationTestConnectionMutationBody = PlatformPromoteSyncDestinationTestConnection
    export type PlatformPromoteSyncDestinationTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformPromoteSyncDestinationTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPromoteSyncDestinationTestConnection>>,
        TError,
        {teamName: string;syncDestinationTestConnectionId: string;data: PlatformPromoteSyncDestinationTestConnection},
        TContext
      > => {

      const mutationOptions = getPlatformPromoteSyncDestinationTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all sync destination definitions.
 */
export const platformListSyncDestinations = (
    teamName: string,
    params?: PlatformListSyncDestinationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncDestinations200>(
      {url: `/teams/${teamName}/sync-destinations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncDestinationsQueryKey = (teamName: string,
    params?: PlatformListSyncDestinationsParams,) => {
    return [`/teams/${teamName}/sync-destinations`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncDestinations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncDestinationsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncDestinations>>> = ({ signal }) => platformListSyncDestinations(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncDestinations>>>
export type PlatformListSyncDestinationsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncDestinations<TData = Awaited<ReturnType<typeof platformListSyncDestinations>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncDestinationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a single sync destination definition.
 */
export const platformGetSyncDestination = (
    teamName: string,
    syncDestinationName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncDestination>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncDestinationQueryKey = (teamName: string,
    syncDestinationName: string,) => {
    return [`/teams/${teamName}/sync-destinations/${syncDestinationName}`] as const;
    }

    
export const getPlatformGetSyncDestinationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestination>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncDestinationQueryKey(teamName,syncDestinationName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncDestination>>> = ({ signal }) => platformGetSyncDestination(teamName,syncDestinationName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncDestination>>>
export type PlatformGetSyncDestinationQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncDestination<TData = Awaited<ReturnType<typeof platformGetSyncDestination>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncDestination>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncDestinationQueryOptions(teamName,syncDestinationName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a Sync Destination definition.
 */
export const platformUpdateSyncDestination = (
    teamName: string,
    syncDestinationName: string,
    platformSyncDestinationUpdate: PlatformSyncDestinationUpdate,
 ) => {
      
      
      return customFetch<PlatformSyncDestination>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncDestinationUpdate
    },
      );
    }
  


export const getPlatformUpdateSyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}, TContext> => {

const mutationKey = ['platformUpdateSyncDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, {teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}> = (props) => {
          const {teamName,syncDestinationName,data} = props ?? {};

          return  platformUpdateSyncDestination(teamName,syncDestinationName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncDestination>>>
    export type PlatformUpdateSyncDestinationMutationBody = PlatformSyncDestinationUpdate
    export type PlatformUpdateSyncDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string;data: PlatformSyncDestinationUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a Sync Destination definition. Any syncs relying on this destination must be deleted first.
 */
export const platformDeleteSyncDestination = (
    teamName: string,
    syncDestinationName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteSyncDestinationMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext> => {

const mutationKey = ['platformDeleteSyncDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, {teamName: string;syncDestinationName: string}> = (props) => {
          const {teamName,syncDestinationName} = props ?? {};

          return  platformDeleteSyncDestination(teamName,syncDestinationName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSyncDestination>>>
    
    export type PlatformDeleteSyncDestinationMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSyncDestination = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteSyncDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Run migrations on all syncs which use this Sync Destination.
 */
export const platformMigrateSyncDestination = (
    teamName: string,
    syncDestinationName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}/migrate`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformMigrateSyncDestinationMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext> => {

const mutationKey = ['platformMigrateSyncDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, {teamName: string;syncDestinationName: string}> = (props) => {
          const {teamName,syncDestinationName} = props ?? {};

          return  platformMigrateSyncDestination(teamName,syncDestinationName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformMigrateSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof platformMigrateSyncDestination>>>
    
    export type PlatformMigrateSyncDestinationMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformMigrateSyncDestination = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformMigrateSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string},
        TContext
      > => {

      const mutationOptions = getPlatformMigrateSyncDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all Syncs for a given sync destination.
 */
export const platformListSyncDestinationSyncs = (
    teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncDestinationSyncs200>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}/syncs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncDestinationSyncsQueryKey = (teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams,) => {
    return [`/teams/${teamName}/sync-destinations/${syncDestinationName}/syncs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncDestinationSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncDestinationSyncsQueryKey(teamName,syncDestinationName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>> = ({ signal }) => platformListSyncDestinationSyncs(teamName,syncDestinationName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncDestinationSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>>
export type PlatformListSyncDestinationSyncsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncDestinationSyncs<TData = Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationName: string,
    params?: PlatformListSyncDestinationSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncDestinationSyncs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncDestinationSyncsQueryOptions(teamName,syncDestinationName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get test connection details for sync destination.
 */
export const platformGetTestConnectionForSyncDestination = (
    teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncTestConnection>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}/test-connections/${syncTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetTestConnectionForSyncDestinationQueryKey = (teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-destinations/${syncDestinationName}/test-connections/${syncTestConnectionId}`] as const;
    }

    
export const getPlatformGetTestConnectionForSyncDestinationQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionForSyncDestinationQueryKey(teamName,syncDestinationName,syncTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>> = ({ signal }) => platformGetTestConnectionForSyncDestination(teamName,syncDestinationName,syncTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName && syncTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionForSyncDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>>
export type PlatformGetTestConnectionForSyncDestinationQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionForSyncDestination<TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncDestination>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionForSyncDestinationQueryOptions(teamName,syncDestinationName,syncTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a test source connection.
 */
export const platformCreateSyncSourceTestConnection = (
    teamName: string,
    platformSyncSourceTestConnectionCreate: PlatformSyncSourceTestConnectionCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncSourceTestConnection>(
      {url: `/teams/${teamName}/sync-source-test-connections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncSourceTestConnectionCreate, signal
    },
      );
    }
  


export const getPlatformCreateSyncSourceTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, TError,{teamName: string;data: PlatformSyncSourceTestConnectionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, TError,{teamName: string;data: PlatformSyncSourceTestConnectionCreate}, TContext> => {

const mutationKey = ['platformCreateSyncSourceTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, {teamName: string;data: PlatformSyncSourceTestConnectionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateSyncSourceTestConnection(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncSourceTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>>
    export type PlatformCreateSyncSourceTestConnectionMutationBody = PlatformSyncSourceTestConnectionCreate
    export type PlatformCreateSyncSourceTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncSourceTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>, TError,{teamName: string;data: PlatformSyncSourceTestConnectionCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncSourceTestConnection>>,
        TError,
        {teamName: string;data: PlatformSyncSourceTestConnectionCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateSyncSourceTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a sync source test connection.
 */
export const platformGetSyncSourceTestConnection = (
    teamName: string,
    syncSourceTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncSourceTestConnection>(
      {url: `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncSourceTestConnectionQueryKey = (teamName: string,
    syncSourceTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`] as const;
    }

    
export const getPlatformGetSyncSourceTestConnectionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceTestConnectionQueryKey(teamName,syncSourceTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>> = ({ signal }) => platformGetSyncSourceTestConnection(teamName,syncSourceTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceTestConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>>
export type PlatformGetSyncSourceTestConnectionQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncSourceTestConnection<TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnection>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceTestConnectionQueryOptions(teamName,syncSourceTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a sync source test connection.
 */
export const platformUpdateSyncTestConnectionForSyncSource = (
    teamName: string,
    syncSourceTestConnectionId: string,
    platformUpdateSyncTestConnectionForSyncSourceBody: PlatformUpdateSyncTestConnectionForSyncSourceBody,
 ) => {
      
      
      return customFetch<PlatformSyncSourceTestConnection>(
      {url: `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateSyncTestConnectionForSyncSourceBody
    },
      );
    }
  


export const getPlatformUpdateSyncTestConnectionForSyncSourceMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}, TContext> => {

const mutationKey = ['platformUpdateSyncTestConnectionForSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, {teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}> = (props) => {
          const {teamName,syncSourceTestConnectionId,data} = props ?? {};

          return  platformUpdateSyncTestConnectionForSyncSource(teamName,syncSourceTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncTestConnectionForSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>>
    export type PlatformUpdateSyncTestConnectionForSyncSourceMutationBody = PlatformUpdateSyncTestConnectionForSyncSourceBody
    export type PlatformUpdateSyncTestConnectionForSyncSourceMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncTestConnectionForSyncSource = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncSource>>,
        TError,
        {teamName: string;syncSourceTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncSourceBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncTestConnectionForSyncSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get logs for a sync source test connection.
 */
export const platformGetSyncSourceTestConnectionLogs = (
    teamName: string,
    syncSourceTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetSyncSourceTestConnectionLogs200One | string | void>(
      {url: `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncSourceTestConnectionLogsQueryKey = (teamName: string,
    syncSourceTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/logs`] as const;
    }

    
export const getPlatformGetSyncSourceTestConnectionLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceTestConnectionLogsQueryKey(teamName,syncSourceTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>> = ({ signal }) => platformGetSyncSourceTestConnectionLogs(teamName,syncSourceTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceTestConnectionLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>>
export type PlatformGetSyncSourceTestConnectionLogsQueryError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncSourceTestConnectionLogs<TData = Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSourceTestConnectionLogs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceTestConnectionLogsQueryOptions(teamName,syncSourceTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Promote a sync source test connection to a sync source.
 */
export const platformPromoteSyncSourceTestConnection = (
    teamName: string,
    syncSourceTestConnectionId: string,
    platformPromoteSyncSourceTestConnection: PlatformPromoteSyncSourceTestConnection,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncSource>(
      {url: `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/promote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformPromoteSyncSourceTestConnection, signal
    },
      );
    }
  


export const getPlatformPromoteSyncSourceTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}, TContext> => {

const mutationKey = ['platformPromoteSyncSourceTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, {teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}> = (props) => {
          const {teamName,syncSourceTestConnectionId,data} = props ?? {};

          return  platformPromoteSyncSourceTestConnection(teamName,syncSourceTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformPromoteSyncSourceTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>>
    export type PlatformPromoteSyncSourceTestConnectionMutationBody = PlatformPromoteSyncSourceTestConnection
    export type PlatformPromoteSyncSourceTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformPromoteSyncSourceTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPromoteSyncSourceTestConnection>>,
        TError,
        {teamName: string;syncSourceTestConnectionId: string;data: PlatformPromoteSyncSourceTestConnection},
        TContext
      > => {

      const mutationOptions = getPlatformPromoteSyncSourceTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all sync source definitions.
 */
export const platformListSyncSources = (
    teamName: string,
    params?: PlatformListSyncSourcesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncSources200>(
      {url: `/teams/${teamName}/sync-sources`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncSourcesQueryKey = (teamName: string,
    params?: PlatformListSyncSourcesParams,) => {
    return [`/teams/${teamName}/sync-sources`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncSourcesQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncSources>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncSourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSources>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncSourcesQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncSources>>> = ({ signal }) => platformListSyncSources(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSources>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncSources>>>
export type PlatformListSyncSourcesQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncSources<TData = Awaited<ReturnType<typeof platformListSyncSources>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncSourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSources>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncSourcesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a single sync source definition.
 */
export const platformGetSyncSource = (
    teamName: string,
    syncSourceName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncSource>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncSourceQueryKey = (teamName: string,
    syncSourceName: string,) => {
    return [`/teams/${teamName}/sync-sources/${syncSourceName}`] as const;
    }

    
export const getPlatformGetSyncSourceQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncSource>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSource>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncSourceQueryKey(teamName,syncSourceName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncSource>>> = ({ signal }) => platformGetSyncSource(teamName,syncSourceName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSource>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncSourceQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncSource>>>
export type PlatformGetSyncSourceQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncSource<TData = Awaited<ReturnType<typeof platformGetSyncSource>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncSource>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncSourceQueryOptions(teamName,syncSourceName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a Sync Source definition.
 */
export const platformUpdateSyncSource = (
    teamName: string,
    syncSourceName: string,
    platformSyncSourceUpdate: PlatformSyncSourceUpdate,
 ) => {
      
      
      return customFetch<PlatformSyncSource>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncSourceUpdate
    },
      );
    }
  


export const getPlatformUpdateSyncSourceMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}, TContext> => {

const mutationKey = ['platformUpdateSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncSource>>, {teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}> = (props) => {
          const {teamName,syncSourceName,data} = props ?? {};

          return  platformUpdateSyncSource(teamName,syncSourceName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncSource>>>
    export type PlatformUpdateSyncSourceMutationBody = PlatformSyncSourceUpdate
    export type PlatformUpdateSyncSourceMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncSource = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string;data: PlatformSyncSourceUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a Sync Source definition. Any syncs relying on this source must be deleted first.
 */
export const platformDeleteSyncSource = (
    teamName: string,
    syncSourceName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteSyncSourceMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext> => {

const mutationKey = ['platformDeleteSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSyncSource>>, {teamName: string;syncSourceName: string}> = (props) => {
          const {teamName,syncSourceName} = props ?? {};

          return  platformDeleteSyncSource(teamName,syncSourceName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSyncSource>>>
    
    export type PlatformDeleteSyncSourceMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSyncSource = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteSyncSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Run migrations on all syncs which use this Sync Source.
 */
export const platformMigrateSyncSource = (
    teamName: string,
    syncSourceName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}/migrate`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformMigrateSyncSourceMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext> => {

const mutationKey = ['platformMigrateSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformMigrateSyncSource>>, {teamName: string;syncSourceName: string}> = (props) => {
          const {teamName,syncSourceName} = props ?? {};

          return  platformMigrateSyncSource(teamName,syncSourceName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformMigrateSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof platformMigrateSyncSource>>>
    
    export type PlatformMigrateSyncSourceMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformMigrateSyncSource = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformMigrateSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformMigrateSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string},
        TContext
      > => {

      const mutationOptions = getPlatformMigrateSyncSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all Syncs for a given sync source.
 */
export const platformListSyncSourceSyncs = (
    teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncSourceSyncs200>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}/syncs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncSourceSyncsQueryKey = (teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams,) => {
    return [`/teams/${teamName}/sync-sources/${syncSourceName}/syncs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncSourceSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncSourceSyncsQueryKey(teamName,syncSourceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>> = ({ signal }) => platformListSyncSourceSyncs(teamName,syncSourceName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncSourceSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>>
export type PlatformListSyncSourceSyncsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncSourceSyncs<TData = Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceName: string,
    params?: PlatformListSyncSourceSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncSourceSyncs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncSourceSyncsQueryOptions(teamName,syncSourceName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get test connection details for sync source.
 */
export const platformGetTestConnectionForSyncSource = (
    teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncTestConnection>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}/test-connections/${syncTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetTestConnectionForSyncSourceQueryKey = (teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-sources/${syncSourceName}/test-connections/${syncTestConnectionId}`] as const;
    }

    
export const getPlatformGetTestConnectionForSyncSourceQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionForSyncSourceQueryKey(teamName,syncSourceName,syncTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>> = ({ signal }) => platformGetTestConnectionForSyncSource(teamName,syncSourceName,syncTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName && syncTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionForSyncSourceQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>>
export type PlatformGetTestConnectionForSyncSourceQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionForSyncSource<TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncSource>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionForSyncSourceQueryOptions(teamName,syncSourceName,syncTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a test transformer connection.
 */
export const platformCreateSyncTransformerTestConnection = (
    teamName: string,
    platformSyncTransformerTestConnectionCreate: PlatformSyncTransformerTestConnectionCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncTransformerTestConnection>(
      {url: `/teams/${teamName}/sync-transformer-test-connections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncTransformerTestConnectionCreate, signal
    },
      );
    }
  


export const getPlatformCreateSyncTransformerTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncTransformerTestConnection>>, TError,{teamName: string;data: PlatformSyncTransformerTestConnectionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncTransformerTestConnection>>, TError,{teamName: string;data: PlatformSyncTransformerTestConnectionCreate}, TContext> => {

const mutationKey = ['platformCreateSyncTransformerTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncTransformerTestConnection>>, {teamName: string;data: PlatformSyncTransformerTestConnectionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateSyncTransformerTestConnection(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncTransformerTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncTransformerTestConnection>>>
    export type PlatformCreateSyncTransformerTestConnectionMutationBody = PlatformSyncTransformerTestConnectionCreate
    export type PlatformCreateSyncTransformerTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncTransformerTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncTransformerTestConnection>>, TError,{teamName: string;data: PlatformSyncTransformerTestConnectionCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncTransformerTestConnection>>,
        TError,
        {teamName: string;data: PlatformSyncTransformerTestConnectionCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateSyncTransformerTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a sync transformer test connection.
 */
export const platformGetSyncTransformerTestConnection = (
    teamName: string,
    syncTransformerTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncTransformerTestConnection>(
      {url: `/teams/${teamName}/sync-transformer-test-connections/${syncTransformerTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncTransformerTestConnectionQueryKey = (teamName: string,
    syncTransformerTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-transformer-test-connections/${syncTransformerTestConnectionId}`] as const;
    }

    
export const getPlatformGetSyncTransformerTestConnectionQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncTransformerTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnection>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncTransformerTestConnectionQueryKey(teamName,syncTransformerTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnection>>> = ({ signal }) => platformGetSyncTransformerTestConnection(teamName,syncTransformerTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncTransformerTestConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnection>>>
export type PlatformGetSyncTransformerTestConnectionQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncTransformerTestConnection<TData = Awaited<ReturnType<typeof platformGetSyncTransformerTestConnection>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnection>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncTransformerTestConnectionQueryOptions(teamName,syncTransformerTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a sync transformer test connection.
 */
export const platformUpdateSyncTestConnectionForSyncTransformer = (
    teamName: string,
    syncTransformerTestConnectionId: string,
    platformUpdateSyncTestConnectionForSyncTransformerBody: PlatformUpdateSyncTestConnectionForSyncTransformerBody,
 ) => {
      
      
      return customFetch<PlatformSyncTransformerTestConnection>(
      {url: `/teams/${teamName}/sync-transformer-test-connections/${syncTransformerTestConnectionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateSyncTestConnectionForSyncTransformerBody
    },
      );
    }
  


export const getPlatformUpdateSyncTestConnectionForSyncTransformerMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncTransformer>>, TError,{teamName: string;syncTransformerTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncTransformerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncTransformer>>, TError,{teamName: string;syncTransformerTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncTransformerBody}, TContext> => {

const mutationKey = ['platformUpdateSyncTestConnectionForSyncTransformer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncTransformer>>, {teamName: string;syncTransformerTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncTransformerBody}> = (props) => {
          const {teamName,syncTransformerTestConnectionId,data} = props ?? {};

          return  platformUpdateSyncTestConnectionForSyncTransformer(teamName,syncTransformerTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncTestConnectionForSyncTransformerMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncTransformer>>>
    export type PlatformUpdateSyncTestConnectionForSyncTransformerMutationBody = PlatformUpdateSyncTestConnectionForSyncTransformerBody
    export type PlatformUpdateSyncTestConnectionForSyncTransformerMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncTestConnectionForSyncTransformer = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncTransformer>>, TError,{teamName: string;syncTransformerTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncTransformerBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncTestConnectionForSyncTransformer>>,
        TError,
        {teamName: string;syncTransformerTestConnectionId: string;data: PlatformUpdateSyncTestConnectionForSyncTransformerBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncTestConnectionForSyncTransformerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get logs for a sync transformer test connection.
 */
export const platformGetSyncTransformerTestConnectionLogs = (
    teamName: string,
    syncTransformerTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetSyncTransformerTestConnectionLogs200One | string | void>(
      {url: `/teams/${teamName}/sync-transformer-test-connections/${syncTransformerTestConnectionId}/logs`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncTransformerTestConnectionLogsQueryKey = (teamName: string,
    syncTransformerTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-transformer-test-connections/${syncTransformerTestConnectionId}/logs`] as const;
    }

    
export const getPlatformGetSyncTransformerTestConnectionLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncTransformerTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnectionLogs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncTransformerTestConnectionLogsQueryKey(teamName,syncTransformerTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnectionLogs>>> = ({ signal }) => platformGetSyncTransformerTestConnectionLogs(teamName,syncTransformerTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnectionLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncTransformerTestConnectionLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnectionLogs>>>
export type PlatformGetSyncTransformerTestConnectionLogsQueryError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncTransformerTestConnectionLogs<TData = Awaited<ReturnType<typeof platformGetSyncTransformerTestConnectionLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformerTestConnectionLogs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncTransformerTestConnectionLogsQueryOptions(teamName,syncTransformerTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Promote a sync transformer test connection to a sync transformer.
 */
export const platformPromoteSyncTransformerTestConnection = (
    teamName: string,
    syncTransformerTestConnectionId: string,
    platformPromoteSyncTransformerTestConnection: PlatformPromoteSyncTransformerTestConnection,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncTransformer>(
      {url: `/teams/${teamName}/sync-transformer-test-connections/${syncTransformerTestConnectionId}/promote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformPromoteSyncTransformerTestConnection, signal
    },
      );
    }
  


export const getPlatformPromoteSyncTransformerTestConnectionMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncTransformerTestConnection>>, TError,{teamName: string;syncTransformerTestConnectionId: string;data: PlatformPromoteSyncTransformerTestConnection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncTransformerTestConnection>>, TError,{teamName: string;syncTransformerTestConnectionId: string;data: PlatformPromoteSyncTransformerTestConnection}, TContext> => {

const mutationKey = ['platformPromoteSyncTransformerTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformPromoteSyncTransformerTestConnection>>, {teamName: string;syncTransformerTestConnectionId: string;data: PlatformPromoteSyncTransformerTestConnection}> = (props) => {
          const {teamName,syncTransformerTestConnectionId,data} = props ?? {};

          return  platformPromoteSyncTransformerTestConnection(teamName,syncTransformerTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformPromoteSyncTransformerTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof platformPromoteSyncTransformerTestConnection>>>
    export type PlatformPromoteSyncTransformerTestConnectionMutationBody = PlatformPromoteSyncTransformerTestConnection
    export type PlatformPromoteSyncTransformerTestConnectionMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformPromoteSyncTransformerTestConnection = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformPromoteSyncTransformerTestConnection>>, TError,{teamName: string;syncTransformerTestConnectionId: string;data: PlatformPromoteSyncTransformerTestConnection}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformPromoteSyncTransformerTestConnection>>,
        TError,
        {teamName: string;syncTransformerTestConnectionId: string;data: PlatformPromoteSyncTransformerTestConnection},
        TContext
      > => {

      const mutationOptions = getPlatformPromoteSyncTransformerTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all sync transformer definitions.
 */
export const platformListSyncTransformers = (
    teamName: string,
    params?: PlatformListSyncTransformersParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncTransformers200>(
      {url: `/teams/${teamName}/sync-transformers`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncTransformersQueryKey = (teamName: string,
    params?: PlatformListSyncTransformersParams,) => {
    return [`/teams/${teamName}/sync-transformers`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncTransformersQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncTransformers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncTransformersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncTransformersQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncTransformers>>> = ({ signal }) => platformListSyncTransformers(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformers>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncTransformersQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncTransformers>>>
export type PlatformListSyncTransformersQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncTransformers<TData = Awaited<ReturnType<typeof platformListSyncTransformers>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncTransformersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncTransformersQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a single sync transformer definition.
 */
export const platformGetSyncTransformer = (
    teamName: string,
    syncTransformerName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncTransformer>(
      {url: `/teams/${teamName}/sync-transformers/${syncTransformerName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncTransformerQueryKey = (teamName: string,
    syncTransformerName: string,) => {
    return [`/teams/${teamName}/sync-transformers/${syncTransformerName}`] as const;
    }

    
export const getPlatformGetSyncTransformerQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncTransformerQueryKey(teamName,syncTransformerName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncTransformer>>> = ({ signal }) => platformGetSyncTransformer(teamName,syncTransformerName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncTransformerQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncTransformer>>>
export type PlatformGetSyncTransformerQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncTransformer<TData = Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncTransformer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncTransformerQueryOptions(teamName,syncTransformerName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a Sync Transformer definition.
 */
export const platformUpdateSyncTransformer = (
    teamName: string,
    syncTransformerName: string,
    platformSyncTransformerUpdate: PlatformSyncTransformerUpdate,
 ) => {
      
      
      return customFetch<PlatformSyncTransformer>(
      {url: `/teams/${teamName}/sync-transformers/${syncTransformerName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncTransformerUpdate
    },
      );
    }
  


export const getPlatformUpdateSyncTransformerMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, TError,{teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, TError,{teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}, TContext> => {

const mutationKey = ['platformUpdateSyncTransformer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, {teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}> = (props) => {
          const {teamName,syncTransformerName,data} = props ?? {};

          return  platformUpdateSyncTransformer(teamName,syncTransformerName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncTransformerMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>>
    export type PlatformUpdateSyncTransformerMutationBody = PlatformSyncTransformerUpdate
    export type PlatformUpdateSyncTransformerMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncTransformer = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncTransformer>>, TError,{teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncTransformer>>,
        TError,
        {teamName: string;syncTransformerName: string;data: PlatformSyncTransformerUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncTransformerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a Sync Transformer definition. Any syncs relying on this transformer must be deleted first.
 */
export const platformDeleteSyncTransformer = (
    teamName: string,
    syncTransformerName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/sync-transformers/${syncTransformerName}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteSyncTransformerMutationOptions = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, TError,{teamName: string;syncTransformerName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, TError,{teamName: string;syncTransformerName: string}, TContext> => {

const mutationKey = ['platformDeleteSyncTransformer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, {teamName: string;syncTransformerName: string}> = (props) => {
          const {teamName,syncTransformerName} = props ?? {};

          return  platformDeleteSyncTransformer(teamName,syncTransformerName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncTransformerMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>>
    
    export type PlatformDeleteSyncTransformerMutationError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSyncTransformer = <TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSyncTransformer>>, TError,{teamName: string;syncTransformerName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSyncTransformer>>,
        TError,
        {teamName: string;syncTransformerName: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteSyncTransformerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all Syncs for a given sync transformer.
 */
export const platformListSyncTransformerSyncs = (
    teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncTransformerSyncs200>(
      {url: `/teams/${teamName}/sync-transformers/${syncTransformerName}/syncs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncTransformerSyncsQueryKey = (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams,) => {
    return [`/teams/${teamName}/sync-transformers/${syncTransformerName}/syncs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncTransformerSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncTransformerSyncsQueryKey(teamName,syncTransformerName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>> = ({ signal }) => platformListSyncTransformerSyncs(teamName,syncTransformerName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncTransformerSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>>
export type PlatformListSyncTransformerSyncsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncTransformerSyncs<TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncTransformerSyncsQueryOptions(teamName,syncTransformerName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all Sync Destinations for a given sync transformer.
 */
export const platformListSyncTransformerSyncDestinations = (
    teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncTransformerSyncDestinations200>(
      {url: `/teams/${teamName}/sync-transformers/${syncTransformerName}/sync-destinations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncTransformerSyncDestinationsQueryKey = (teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams,) => {
    return [`/teams/${teamName}/sync-transformers/${syncTransformerName}/sync-destinations`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncTransformerSyncDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncTransformerSyncDestinationsQueryKey(teamName,syncTransformerName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>> = ({ signal }) => platformListSyncTransformerSyncDestinations(teamName,syncTransformerName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncTransformerSyncDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>>
export type PlatformListSyncTransformerSyncDestinationsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncTransformerSyncDestinations<TData = Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerName: string,
    params?: PlatformListSyncTransformerSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncTransformerSyncDestinations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncTransformerSyncDestinationsQueryOptions(teamName,syncTransformerName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get test connection details for sync transformer.
 */
export const platformGetTestConnectionForSyncTransformer = (
    teamName: string,
    syncTransformerName: string,
    syncTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncTestConnection>(
      {url: `/teams/${teamName}/sync-transformers/${syncTransformerName}/test-connections/${syncTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetTestConnectionForSyncTransformerQueryKey = (teamName: string,
    syncTransformerName: string,
    syncTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-transformers/${syncTransformerName}/test-connections/${syncTestConnectionId}`] as const;
    }

    
export const getPlatformGetTestConnectionForSyncTransformerQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncTransformer>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTransformerName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncTransformer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionForSyncTransformerQueryKey(teamName,syncTransformerName,syncTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionForSyncTransformer>>> = ({ signal }) => platformGetTestConnectionForSyncTransformer(teamName,syncTransformerName,syncTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTransformerName && syncTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncTransformer>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionForSyncTransformerQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionForSyncTransformer>>>
export type PlatformGetTestConnectionForSyncTransformerQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionForSyncTransformer<TData = Awaited<ReturnType<typeof platformGetTestConnectionForSyncTransformer>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTransformerName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionForSyncTransformer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionForSyncTransformerQueryOptions(teamName,syncTransformerName,syncTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all version upgrades for syncs
 */
export const platformListSyncUpgrades = (
    teamName: string,
    params?: PlatformListSyncUpgradesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncUpgrades200>(
      {url: `/teams/${teamName}/sync-upgrades`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncUpgradesQueryKey = (teamName: string,
    params?: PlatformListSyncUpgradesParams,) => {
    return [`/teams/${teamName}/sync-upgrades`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncUpgradesQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncUpgradesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncUpgradesQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncUpgrades>>> = ({ signal }) => platformListSyncUpgrades(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncUpgradesQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncUpgrades>>>
export type PlatformListSyncUpgradesQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncUpgrades<TData = Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncUpgradesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncUpgrades>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncUpgradesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all Syncs.
 */
export const platformListSyncs = (
    teamName: string,
    params?: PlatformListSyncsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncs200>(
      {url: `/teams/${teamName}/syncs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncsQueryKey = (teamName: string,
    params?: PlatformListSyncsParams,) => {
    return [`/teams/${teamName}/syncs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncs>>> = ({ signal }) => platformListSyncs(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncs>>>
export type PlatformListSyncsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncs<TData = Awaited<ReturnType<typeof platformListSyncs>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new Sync definition. Sync runs can be scheduled automatically, or triggered manually after sync is created.
 */
export const platformCreateSync = (
    teamName: string,
    platformSyncCreate: PlatformSyncCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSync>(
      {url: `/teams/${teamName}/syncs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncCreate, signal
    },
      );
    }
  


export const getPlatformCreateSyncMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSync>>, TError,{teamName: string;data: PlatformSyncCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSync>>, TError,{teamName: string;data: PlatformSyncCreate}, TContext> => {

const mutationKey = ['platformCreateSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSync>>, {teamName: string;data: PlatformSyncCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateSync(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSync>>>
    export type PlatformCreateSyncMutationBody = PlatformSyncCreate
    export type PlatformCreateSyncMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSync = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSync>>, TError,{teamName: string;data: PlatformSyncCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSync>>,
        TError,
        {teamName: string;data: PlatformSyncCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateSyncMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a Sync
 */
export const platformGetSync = (
    teamName: string,
    syncName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSync>(
      {url: `/teams/${teamName}/syncs/${syncName}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncQueryKey = (teamName: string,
    syncName: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}`] as const;
    }

    
export const getPlatformGetSyncQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSync>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSync>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncQueryKey(teamName,syncName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSync>>> = ({ signal }) => platformGetSync(teamName,syncName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSync>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSync>>>
export type PlatformGetSyncQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSync<TData = Awaited<ReturnType<typeof platformGetSync>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSync>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncQueryOptions(teamName,syncName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a Sync
 */
export const platformUpdateSync = (
    teamName: string,
    syncName: string,
    platformSyncUpdate: PlatformSyncUpdate,
 ) => {
      
      
      return customFetch<PlatformSync>(
      {url: `/teams/${teamName}/syncs/${syncName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformSyncUpdate
    },
      );
    }
  


export const getPlatformUpdateSyncMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSync>>, TError,{teamName: string;syncName: string;data: PlatformSyncUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSync>>, TError,{teamName: string;syncName: string;data: PlatformSyncUpdate}, TContext> => {

const mutationKey = ['platformUpdateSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSync>>, {teamName: string;syncName: string;data: PlatformSyncUpdate}> = (props) => {
          const {teamName,syncName,data} = props ?? {};

          return  platformUpdateSync(teamName,syncName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSync>>>
    export type PlatformUpdateSyncMutationBody = PlatformSyncUpdate
    export type PlatformUpdateSyncMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSync = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSync>>, TError,{teamName: string;syncName: string;data: PlatformSyncUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSync>>,
        TError,
        {teamName: string;syncName: string;data: PlatformSyncUpdate},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete Sync. This will delete Sync configuration and all associated sync runs, but will not delete the associated source and destination(s). These will need to be deleted separately.
 */
export const platformDeleteSync = (
    teamName: string,
    syncName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/syncs/${syncName}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteSyncMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSync>>, TError,{teamName: string;syncName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSync>>, TError,{teamName: string;syncName: string}, TContext> => {

const mutationKey = ['platformDeleteSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteSync>>, {teamName: string;syncName: string}> = (props) => {
          const {teamName,syncName} = props ?? {};

          return  platformDeleteSync(teamName,syncName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteSyncMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteSync>>>
    
    export type PlatformDeleteSyncMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteSync = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteSync>>, TError,{teamName: string;syncName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteSync>>,
        TError,
        {teamName: string;syncName: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteSyncMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all Sync Runs.
 */
export const platformListSyncRuns = (
    teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListSyncRuns200>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListSyncRunsQueryKey = (teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListSyncRunsQueryOptions = <TData = Awaited<ReturnType<typeof platformListSyncRuns>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncRuns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListSyncRunsQueryKey(teamName,syncName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListSyncRuns>>> = ({ signal }) => platformListSyncRuns(teamName,syncName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListSyncRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListSyncRunsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListSyncRuns>>>
export type PlatformListSyncRunsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListSyncRuns<TData = Awaited<ReturnType<typeof platformListSyncRuns>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    params?: PlatformListSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListSyncRuns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListSyncRunsQueryOptions(teamName,syncName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new SyncRun. This will trigger a manual job run.
 */
export const platformCreateSyncRun = (
    teamName: string,
    syncName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncRun>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformCreateSyncRunMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRun>>, TError,{teamName: string;syncName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRun>>, TError,{teamName: string;syncName: string}, TContext> => {

const mutationKey = ['platformCreateSyncRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncRun>>, {teamName: string;syncName: string}> = (props) => {
          const {teamName,syncName} = props ?? {};

          return  platformCreateSyncRun(teamName,syncName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncRunMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncRun>>>
    
    export type PlatformCreateSyncRunMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncRun = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRun>>, TError,{teamName: string;syncName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncRun>>,
        TError,
        {teamName: string;syncName: string},
        TContext
      > => {

      const mutationOptions = getPlatformCreateSyncRunMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a Sync Run.
 */
export const platformGetSyncRun = (
    teamName: string,
    syncName: string,
    syncRunId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncRunDetails>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncRunQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`] as const;
    }

    
export const getPlatformGetSyncRunQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRun>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRun>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunQueryKey(teamName,syncName,syncRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRun>>> = ({ signal }) => platformGetSyncRun(teamName,syncName,syncRunId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRun>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRun>>>
export type PlatformGetSyncRunQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRun<TData = Awaited<ReturnType<typeof platformGetSyncRun>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRun>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunQueryOptions(teamName,syncName,syncRunId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a SyncRun
 */
export const platformUpdateSyncRun = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    platformUpdateSyncRunBody: PlatformUpdateSyncRunBody,
 ) => {
      
      
      return customFetch<PlatformSyncRun>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateSyncRunBody
    },
      );
    }
  


export const getPlatformUpdateSyncRunMutationOptions = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}, TContext> => {

const mutationKey = ['platformUpdateSyncRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateSyncRun>>, {teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}> = (props) => {
          const {teamName,syncName,syncRunId,data} = props ?? {};

          return  platformUpdateSyncRun(teamName,syncName,syncRunId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateSyncRunMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateSyncRun>>>
    export type PlatformUpdateSyncRunMutationBody = PlatformUpdateSyncRunBody
    export type PlatformUpdateSyncRunMutationError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateSyncRun = <TError = PlatformBadRequestResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateSyncRun>>,
        TError,
        {teamName: string;syncName: string;syncRunId: string;data: PlatformUpdateSyncRunBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateSyncRunMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get logs for a sync run.
 */
export const platformGetSyncRunLogs = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetSyncRunLogs200One | string | void>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetSyncRunLogsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetSyncRunLogsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunLogsQueryKey(teamName,syncName,syncRunId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunLogs>>> = ({ signal }) => platformGetSyncRunLogs(teamName,syncName,syncRunId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunLogsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunLogs>>>
export type PlatformGetSyncRunLogsQueryError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunLogs<TData = Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError = void | PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunLogs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunLogsQueryOptions(teamName,syncName,syncRunId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new sync run progress update.
 */
export const platformCreateSyncRunProgress = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    platformCreateSyncRunProgressBody: PlatformCreateSyncRunProgressBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/progress`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformCreateSyncRunProgressBody, signal
    },
      );
    }
  


export const getPlatformCreateSyncRunProgressMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}, TContext> => {

const mutationKey = ['platformCreateSyncRunProgress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, {teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}> = (props) => {
          const {teamName,syncName,syncRunId,data} = props ?? {};

          return  platformCreateSyncRunProgress(teamName,syncName,syncRunId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateSyncRunProgressMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>>
    export type PlatformCreateSyncRunProgressMutationBody = PlatformCreateSyncRunProgressBody
    export type PlatformCreateSyncRunProgressMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateSyncRunProgress = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateSyncRunProgress>>,
        TError,
        {teamName: string;syncName: string;syncRunId: string;data: PlatformCreateSyncRunProgressBody},
        TContext
      > => {

      const mutationOptions = getPlatformCreateSyncRunProgressMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get statistics on a Sync Run
 */
export const platformGetSyncRunStats = (
    teamName: string,
    syncName: string,
    syncRunId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformSyncRunStats>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/stats`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncRunStatsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/stats`] as const;
    }

    
export const getPlatformGetSyncRunStatsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunStatsQueryKey(teamName,syncName,syncRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunStats>>> = ({ signal }) => platformGetSyncRunStats(teamName,syncName,syncRunId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunStatsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunStats>>>
export type PlatformGetSyncRunStatsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunStats<TData = Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunStats>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunStatsQueryOptions(teamName,syncName,syncRunId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get table details on a Sync Run
 */
export const platformGetSyncRunTables = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetSyncRunTables200>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/tables`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetSyncRunTablesQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/tables`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetSyncRunTablesQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunTablesQueryKey(teamName,syncName,syncRunId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunTables>>> = ({ signal }) => platformGetSyncRunTables(teamName,syncName,syncRunId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunTablesQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunTables>>>
export type PlatformGetSyncRunTablesQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunTables<TData = Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    params?: PlatformGetSyncRunTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunTables>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunTablesQueryOptions(teamName,syncName,syncRunId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector credentials for a sync run.
 */
export const platformGetSyncRunConnectorCredentials = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetSyncRunConnectorCredentials200>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/credentials`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncRunConnectorCredentialsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/credentials`] as const;
    }

    
export const getPlatformGetSyncRunConnectorCredentialsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunConnectorCredentialsQueryKey(teamName,syncName,syncRunId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>> = ({ signal }) => platformGetSyncRunConnectorCredentials(teamName,syncName,syncRunId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunConnectorCredentialsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>>
export type PlatformGetSyncRunConnectorCredentialsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunConnectorCredentials<TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorCredentials>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunConnectorCredentialsQueryOptions(teamName,syncName,syncRunId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector identity for a sync run.
 */
export const platformGetSyncRunConnectorIdentity = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetSyncRunConnectorIdentity200>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/identity`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetSyncRunConnectorIdentityQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/identity`] as const;
    }

    
export const getPlatformGetSyncRunConnectorIdentityQueryOptions = <TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetSyncRunConnectorIdentityQueryKey(teamName,syncName,syncRunId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>> = ({ signal }) => platformGetSyncRunConnectorIdentity(teamName,syncName,syncRunId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetSyncRunConnectorIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>>
export type PlatformGetSyncRunConnectorIdentityQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetSyncRunConnectorIdentity<TData = Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetSyncRunConnectorIdentity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetSyncRunConnectorIdentityQueryOptions(teamName,syncName,syncRunId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector credentials for a test connection
 */
export const platformGetTestConnectionConnectorCredentials = (
    teamName: string,
    syncTestConnectionId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetTestConnectionConnectorCredentials200>(
      {url: `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/credentials`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetTestConnectionConnectorCredentialsQueryKey = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/credentials`] as const;
    }

    
export const getPlatformGetTestConnectionConnectorCredentialsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionConnectorCredentialsQueryKey(teamName,syncTestConnectionId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>> = ({ signal }) => platformGetTestConnectionConnectorCredentials(teamName,syncTestConnectionId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTestConnectionId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionConnectorCredentialsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>>
export type PlatformGetTestConnectionConnectorCredentialsQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionConnectorCredentials<TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorCredentials>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionConnectorCredentialsQueryOptions(teamName,syncTestConnectionId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector identity for a test connection.
 */
export const platformGetTestConnectionConnectorIdentity = (
    teamName: string,
    syncTestConnectionId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetTestConnectionConnectorIdentity200>(
      {url: `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/identity`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetTestConnectionConnectorIdentityQueryKey = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/identity`] as const;
    }

    
export const getPlatformGetTestConnectionConnectorIdentityQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTestConnectionConnectorIdentityQueryKey(teamName,syncTestConnectionId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>> = ({ signal }) => platformGetTestConnectionConnectorIdentity(teamName,syncTestConnectionId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTestConnectionId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTestConnectionConnectorIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>>
export type PlatformGetTestConnectionConnectorIdentityQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetTestConnectionConnectorIdentity<TData = Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTestConnectionConnectorIdentity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTestConnectionConnectorIdentityQueryOptions(teamName,syncTestConnectionId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Tables
 */
export const platformListTablesTeam = (
    teamName: string,
    params?: PlatformListTablesTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListTablesTeam200>(
      {url: `/teams/${teamName}/tables`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListTablesTeamQueryKey = (teamName: string,
    params?: PlatformListTablesTeamParams,) => {
    return [`/teams/${teamName}/tables`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListTablesTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListTablesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListTablesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTablesTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListTablesTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListTablesTeam>>> = ({ signal }) => platformListTablesTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListTablesTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListTablesTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListTablesTeam>>>
export type PlatformListTablesTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformListTablesTeam<TData = Awaited<ReturnType<typeof platformListTablesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListTablesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListTablesTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListTablesTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Table Rows
 */
export const platformTableListRowsTeam = (
    teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListRowsTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/data`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListRowsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams,) => {
    return [`/teams/${teamName}/tables/${tableName}/data`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListRowsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListRowsTeamQueryKey(teamName,tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListRowsTeam>>> = ({ signal }) => platformTableListRowsTeam(teamName,tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListRowsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListRowsTeam>>>
export type PlatformTableListRowsTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListRowsTeam<TData = Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListRowsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRowsTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListRowsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table row
 */
export const platformTableRowByIdTeam = (
    teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableRowByIdTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/data/${tableRowId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableRowByIdTeamQueryKey = (teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams,) => {
    return [`/teams/${teamName}/tables/${tableName}/data/${tableRowId}`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableRowByIdTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableRowByIdTeamQueryKey(teamName,tableName,tableRowId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableRowByIdTeam>>> = ({ signal }) => platformTableRowByIdTeam(teamName,tableName,tableRowId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName && tableRowId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableRowByIdTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableRowByIdTeam>>>
export type PlatformTableRowByIdTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableRowByIdTeam<TData = Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    tableRowId: string,
    params?: PlatformTableRowByIdTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableRowByIdTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableRowByIdTeamQueryOptions(teamName,tableName,tableRowId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Schema
 */
export const platformTableSchemaTeam = (
    teamName: string,
    tableName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableSchemaTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/schema`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformTableSchemaTeamQueryKey = (teamName: string,
    tableName: string,) => {
    return [`/teams/${teamName}/tables/${tableName}/schema`] as const;
    }

    
export const getPlatformTableSchemaTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableSchemaTeamQueryKey(teamName,tableName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableSchemaTeam>>> = ({ signal }) => platformTableSchemaTeam(teamName,tableName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableSchemaTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableSchemaTeam>>>
export type PlatformTableSchemaTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableSchemaTeam<TData = Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableSchemaTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableSchemaTeamQueryOptions(teamName,tableName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Schemas
 */
export const platformBatchTableSchemasTeam = (
    teamName: string,
    params: PlatformBatchTableSchemasTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformBatchTableSchemasTeam200>(
      {url: `/teams/${teamName}/tables/schemas`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformBatchTableSchemasTeamQueryKey = (teamName: string,
    params: PlatformBatchTableSchemasTeamParams,) => {
    return [`/teams/${teamName}/tables/schemas`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformBatchTableSchemasTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params: PlatformBatchTableSchemasTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformBatchTableSchemasTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>> = ({ signal }) => platformBatchTableSchemasTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformBatchTableSchemasTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>>
export type PlatformBatchTableSchemasTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformBatchTableSchemasTeam<TData = Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params: PlatformBatchTableSchemasTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformBatchTableSchemasTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformBatchTableSchemasTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Columns
 */
export const platformTableListColumnsTeam = (
    teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListColumnsTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/columns`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListColumnsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams,) => {
    return [`/teams/${teamName}/tables/${tableName}/columns`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListColumnsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListColumnsTeamQueryKey(teamName,tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListColumnsTeam>>> = ({ signal }) => platformTableListColumnsTeam(teamName,tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListColumnsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListColumnsTeam>>>
export type PlatformTableListColumnsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListColumnsTeam<TData = Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListColumnsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListColumnsTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListColumnsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Table Column Values
 */
export const platformTableColumnListValuesTeam = (
    teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableColumnListValuesTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/columns/${columnName}/values`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableColumnListValuesTeamQueryKey = (teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams,) => {
    return [`/teams/${teamName}/tables/${tableName}/columns/${columnName}/values`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableColumnListValuesTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableColumnListValuesTeamQueryKey(teamName,tableName,columnName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>> = ({ signal }) => platformTableColumnListValuesTeam(teamName,tableName,columnName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName && columnName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableColumnListValuesTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>>
export type PlatformTableColumnListValuesTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableColumnListValuesTeam<TData = Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    columnName: string,
    params?: PlatformTableColumnListValuesTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableColumnListValuesTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableColumnListValuesTeamQueryOptions(teamName,tableName,columnName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Table Filters
 */
export const platformTableListFiltersTeam = (
    teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListFiltersTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/filters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListFiltersTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams,) => {
    return [`/teams/${teamName}/tables/${tableName}/filters`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListFiltersTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListFiltersTeamQueryKey(teamName,tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListFiltersTeam>>> = ({ signal }) => platformTableListFiltersTeam(teamName,tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListFiltersTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListFiltersTeam>>>
export type PlatformTableListFiltersTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListFiltersTeam<TData = Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListFiltersTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFiltersTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListFiltersTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Save Table Filter
 */
export const platformTableSaveFilterTeam = (
    teamName: string,
    tableName: string,
    platformFilterCreate: PlatformFilterCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformFilter>(
      {url: `/teams/${teamName}/tables/${tableName}/filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformFilterCreate, signal
    },
      );
    }
  


export const getPlatformTableSaveFilterTeamMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, TError,{teamName: string;tableName: string;data: PlatformFilterCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, TError,{teamName: string;tableName: string;data: PlatformFilterCreate}, TContext> => {

const mutationKey = ['platformTableSaveFilterTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, {teamName: string;tableName: string;data: PlatformFilterCreate}> = (props) => {
          const {teamName,tableName,data} = props ?? {};

          return  platformTableSaveFilterTeam(teamName,tableName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformTableSaveFilterTeamMutationResult = NonNullable<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>>
    export type PlatformTableSaveFilterTeamMutationBody = PlatformFilterCreate
    export type PlatformTableSaveFilterTeamMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformTableSaveFilterTeam = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformTableSaveFilterTeam>>, TError,{teamName: string;tableName: string;data: PlatformFilterCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformTableSaveFilterTeam>>,
        TError,
        {teamName: string;tableName: string;data: PlatformFilterCreate},
        TContext
      > => {

      const mutationOptions = getPlatformTableSaveFilterTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List Filter Tags For A Table
 */
export const platformTableListFilterTagsTeam = (
    teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListFilterTagsTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/filters/tags`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListFilterTagsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams,) => {
    return [`/teams/${teamName}/tables/${tableName}/filters/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListFilterTagsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListFilterTagsTeamQueryKey(teamName,tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>> = ({ signal }) => platformTableListFilterTagsTeam(teamName,tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListFilterTagsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>>
export type PlatformTableListFilterTagsTeamQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformTableListFilterTagsTeam<TData = Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListFilterTagsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListFilterTagsTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListFilterTagsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List Table Relations
 */
export const platformTableListRelationsTeam = (
    teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformTableListRelationsTeam200>(
      {url: `/teams/${teamName}/tables/${tableName}/relations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformTableListRelationsTeamQueryKey = (teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams,) => {
    return [`/teams/${teamName}/tables/${tableName}/relations`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformTableListRelationsTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformTableListRelationsTeamQueryKey(teamName,tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTableListRelationsTeam>>> = ({ signal }) => platformTableListRelationsTeam(teamName,tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformTableListRelationsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformTableListRelationsTeam>>>
export type PlatformTableListRelationsTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformTableListRelationsTeam<TData = Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    tableName: string,
    params?: PlatformTableListRelationsTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformTableListRelationsTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformTableListRelationsTeamQueryOptions(teamName,tableName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a summary of usage for the specified time range.
 */
export const platformGetTeamUsageSummary = (
    teamName: string,
    params?: PlatformGetTeamUsageSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformUsageSummary>(
      {url: `/teams/${teamName}/usage-summary`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetTeamUsageSummaryQueryKey = (teamName: string,
    params?: PlatformGetTeamUsageSummaryParams,) => {
    return [`/teams/${teamName}/usage-summary`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformGetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetTeamUsageSummaryQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>> = ({ signal }) => platformGetTeamUsageSummary(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>>
export type PlatformGetTeamUsageSummaryQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetTeamUsageSummary<TData = Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformGetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetTeamUsageSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetTeamUsageSummaryQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a grouped summary of usage for the specified time range.
 */
export const platformGetGroupedTeamUsageSummary = (
    teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformUsageSummary>(
      {url: `/teams/${teamName}/usage-summary/${groupBy}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetGroupedTeamUsageSummaryQueryKey = (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams,) => {
    return [`/teams/${teamName}/usage-summary/${groupBy}`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetGroupedTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetGroupedTeamUsageSummaryQueryKey(teamName,groupBy,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>> = ({ signal }) => platformGetGroupedTeamUsageSummary(teamName,groupBy,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && groupBy), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetGroupedTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>>
export type PlatformGetGroupedTeamUsageSummaryQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse



export function usePlatformGetGroupedTeamUsageSummary<TData = Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse>(
 teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: PlatformGetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetGroupedTeamUsageSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetGroupedTeamUsageSummaryQueryOptions(teamName,groupBy,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all users in the current team.
 */
export const platformListUsersByTeam = (
    teamName: string,
    params?: PlatformListUsersByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListUsersByTeam200>(
      {url: `/teams/${teamName}/users`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListUsersByTeamQueryKey = (teamName: string,
    params?: PlatformListUsersByTeamParams,) => {
    return [`/teams/${teamName}/users`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListUsersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof platformListUsersByTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListUsersByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListUsersByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListUsersByTeam>>> = ({ signal }) => platformListUsersByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListUsersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListUsersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof platformListUsersByTeam>>>
export type PlatformListUsersByTeamQueryError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListUsersByTeam<TData = Awaited<ReturnType<typeof platformListUsersByTeam>>, TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListUsersByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListUsersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all User Snapshots.
 */
export const platformListUserSnapshots = (
    teamName: string,
    params?: PlatformListUserSnapshotsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListUserSnapshots200>(
      {url: `/teams/${teamName}/user-snapshots`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListUserSnapshotsQueryKey = (teamName: string,
    params?: PlatformListUserSnapshotsParams,) => {
    return [`/teams/${teamName}/user-snapshots`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListUserSnapshotsQueryOptions = <TData = Awaited<ReturnType<typeof platformListUserSnapshots>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    params?: PlatformListUserSnapshotsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListUserSnapshots>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListUserSnapshotsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListUserSnapshots>>> = ({ signal }) => platformListUserSnapshots(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListUserSnapshots>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListUserSnapshotsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListUserSnapshots>>>
export type PlatformListUserSnapshotsQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListUserSnapshots<TData = Awaited<ReturnType<typeof platformListUserSnapshots>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    params?: PlatformListUserSnapshotsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListUserSnapshots>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListUserSnapshotsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new User Snapshot. This will trigger a Snapshot Job run.
 */
export const platformCreateUserSnapshot = (
    teamName: string,
    platformUserSnapshotCreate: PlatformUserSnapshotCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformUserSnapshot>(
      {url: `/teams/${teamName}/user-snapshots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformUserSnapshotCreate, signal
    },
      );
    }
  


export const getPlatformCreateUserSnapshotMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserSnapshot>>, TError,{teamName: string;data: PlatformUserSnapshotCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserSnapshot>>, TError,{teamName: string;data: PlatformUserSnapshotCreate}, TContext> => {

const mutationKey = ['platformCreateUserSnapshot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateUserSnapshot>>, {teamName: string;data: PlatformUserSnapshotCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  platformCreateUserSnapshot(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateUserSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateUserSnapshot>>>
    export type PlatformCreateUserSnapshotMutationBody = PlatformUserSnapshotCreate
    export type PlatformCreateUserSnapshotMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformCreateUserSnapshot = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserSnapshot>>, TError,{teamName: string;data: PlatformUserSnapshotCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateUserSnapshot>>,
        TError,
        {teamName: string;data: PlatformUserSnapshotCreate},
        TContext
      > => {

      const mutationOptions = getPlatformCreateUserSnapshotMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a User Snapshot.
 */
export const platformGetUserSnapshot = (
    teamName: string,
    userSnapshotId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformUserSnapshot>(
      {url: `/teams/${teamName}/user-snapshots/${userSnapshotId}`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetUserSnapshotQueryKey = (teamName: string,
    userSnapshotId: string,) => {
    return [`/teams/${teamName}/user-snapshots/${userSnapshotId}`] as const;
    }

    
export const getPlatformGetUserSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof platformGetUserSnapshot>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(teamName: string,
    userSnapshotId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetUserSnapshot>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetUserSnapshotQueryKey(teamName,userSnapshotId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetUserSnapshot>>> = ({ signal }) => platformGetUserSnapshot(teamName,userSnapshotId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && userSnapshotId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetUserSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetUserSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetUserSnapshot>>>
export type PlatformGetUserSnapshotQueryError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformGetUserSnapshot<TData = Awaited<ReturnType<typeof platformGetUserSnapshot>>, TError = PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 teamName: string,
    userSnapshotId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetUserSnapshot>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetUserSnapshotQueryOptions(teamName,userSnapshotId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a User Snapshot.
 */
export const platformUpdateUserSnapshot = (
    teamName: string,
    userSnapshotId: string,
    platformUpdateUserSnapshotBody: PlatformUpdateUserSnapshotBody,
 ) => {
      
      
      return customFetch<PlatformUserSnapshot>(
      {url: `/teams/${teamName}/user-snapshots/${userSnapshotId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateUserSnapshotBody
    },
      );
    }
  


export const getPlatformUpdateUserSnapshotMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateUserSnapshot>>, TError,{teamName: string;userSnapshotId: string;data: PlatformUpdateUserSnapshotBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateUserSnapshot>>, TError,{teamName: string;userSnapshotId: string;data: PlatformUpdateUserSnapshotBody}, TContext> => {

const mutationKey = ['platformUpdateUserSnapshot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateUserSnapshot>>, {teamName: string;userSnapshotId: string;data: PlatformUpdateUserSnapshotBody}> = (props) => {
          const {teamName,userSnapshotId,data} = props ?? {};

          return  platformUpdateUserSnapshot(teamName,userSnapshotId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateUserSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateUserSnapshot>>>
    export type PlatformUpdateUserSnapshotMutationBody = PlatformUpdateUserSnapshotBody
    export type PlatformUpdateUserSnapshotMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateUserSnapshot = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateUserSnapshot>>, TError,{teamName: string;userSnapshotId: string;data: PlatformUpdateUserSnapshotBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateUserSnapshot>>,
        TError,
        {teamName: string;userSnapshotId: string;data: PlatformUpdateUserSnapshotBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateUserSnapshotMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a URL to upload image that will be publicly accessible
 */
export const platformUploadImage = (
    platformUploadImageBody: PlatformUploadImageBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformImageURL>(
      {url: `/upload/image`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformUploadImageBody, signal
    },
      );
    }
  


export const getPlatformUploadImageMutationOptions = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadImage>>, TError,{data: PlatformUploadImageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUploadImage>>, TError,{data: PlatformUploadImageBody}, TContext> => {

const mutationKey = ['platformUploadImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUploadImage>>, {data: PlatformUploadImageBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUploadImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof platformUploadImage>>>
    export type PlatformUploadImageMutationBody = PlatformUploadImageBody
    export type PlatformUploadImageMutationError = PlatformBadRequestResponse | PlatformInternalErrorResponse

    export const usePlatformUploadImage = <TError = PlatformBadRequestResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUploadImage>>, TError,{data: PlatformUploadImageBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUploadImage>>,
        TError,
        {data: PlatformUploadImageBody},
        TContext
      > => {

      const mutationOptions = getPlatformUploadImageMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get the current authenticated user from the OAuth token

 */
export const platformGetCurrentUser = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetCurrentUser200>(
      {url: `/user`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetCurrentUserQueryKey = () => {
    return [`/user`] as const;
    }

    
export const getPlatformGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCurrentUser>>, TError = PlatformGetCurrentUser401 | PlatformForbiddenResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUser>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCurrentUser>>> = ({ signal }) => platformGetCurrentUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUser>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCurrentUser>>>
export type PlatformGetCurrentUserQueryError = PlatformGetCurrentUser401 | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformGetCurrentUser<TData = Awaited<ReturnType<typeof platformGetCurrentUser>>, TError = PlatformGetCurrentUser401 | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUser>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update attributes for the current authenticated user from the OAuth token
 */
export const platformUpdateCurrentUser = (
    platformUpdateCurrentUserBody: PlatformUpdateCurrentUserBody,
 ) => {
      
      
      return customFetch<PlatformUser>(
      {url: `/user`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateCurrentUserBody
    },
      );
    }
  


export const getPlatformUpdateCurrentUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, TError,{data: PlatformUpdateCurrentUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, TError,{data: PlatformUpdateCurrentUserBody}, TContext> => {

const mutationKey = ['platformUpdateCurrentUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, {data: PlatformUpdateCurrentUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUpdateCurrentUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateCurrentUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateCurrentUser>>>
    export type PlatformUpdateCurrentUserMutationBody = PlatformUpdateCurrentUserBody
    export type PlatformUpdateCurrentUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateCurrentUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCurrentUser>>, TError,{data: PlatformUpdateCurrentUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateCurrentUser>>,
        TError,
        {data: PlatformUpdateCurrentUserBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateCurrentUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Send an anonymous event
 */
export const platformSendAnonymousEvent = (
    platformSendAnonymousEventBody: PlatformSendAnonymousEventBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/anon-event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformSendAnonymousEventBody, signal
    },
      );
    }
  


export const getPlatformSendAnonymousEventMutationOptions = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, TError,{data: PlatformSendAnonymousEventBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, TError,{data: PlatformSendAnonymousEventBody}, TContext> => {

const mutationKey = ['platformSendAnonymousEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, {data: PlatformSendAnonymousEventBody}> = (props) => {
          const {data} = props ?? {};

          return  platformSendAnonymousEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformSendAnonymousEventMutationResult = NonNullable<Awaited<ReturnType<typeof platformSendAnonymousEvent>>>
    export type PlatformSendAnonymousEventMutationBody = PlatformSendAnonymousEventBody
    export type PlatformSendAnonymousEventMutationError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformSendAnonymousEvent = <TError = PlatformBadRequestResponse | PlatformNotFoundResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendAnonymousEvent>>, TError,{data: PlatformSendAnonymousEventBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSendAnonymousEvent>>,
        TError,
        {data: PlatformSendAnonymousEventBody},
        TContext
      > => {

      const mutationOptions = getPlatformSendAnonymousEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Authenticate a user with password
 */
export const platformAuthenticateLocalUser = (
    platformAuthenticateLocalUserBody: PlatformAuthenticateLocalUserBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformAuthenticateLocalUser200>(
      {url: `/user/authenticate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformAuthenticateLocalUserBody, signal
    },
      );
    }
  


export const getPlatformAuthenticateLocalUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, TError,{data: PlatformAuthenticateLocalUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, TError,{data: PlatformAuthenticateLocalUserBody}, TContext> => {

const mutationKey = ['platformAuthenticateLocalUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, {data: PlatformAuthenticateLocalUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformAuthenticateLocalUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAuthenticateLocalUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>>
    export type PlatformAuthenticateLocalUserMutationBody = PlatformAuthenticateLocalUserBody
    export type PlatformAuthenticateLocalUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse

    export const usePlatformAuthenticateLocalUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformTooManyRequestsResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAuthenticateLocalUser>>, TError,{data: PlatformAuthenticateLocalUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformAuthenticateLocalUser>>,
        TError,
        {data: PlatformAuthenticateLocalUserBody},
        TContext
      > => {

      const mutationOptions = getPlatformAuthenticateLocalUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Change user password
 */
export const platformChangeLocalUserPassword = (
    platformChangeLocalUserPasswordBody: PlatformChangeLocalUserPasswordBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformChangeLocalUserPasswordBody, signal
    },
      );
    }
  


export const getPlatformChangeLocalUserPasswordMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, TError,{data: PlatformChangeLocalUserPasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, TError,{data: PlatformChangeLocalUserPasswordBody}, TContext> => {

const mutationKey = ['platformChangeLocalUserPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, {data: PlatformChangeLocalUserPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  platformChangeLocalUserPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformChangeLocalUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>>
    export type PlatformChangeLocalUserPasswordMutationBody = PlatformChangeLocalUserPasswordBody
    export type PlatformChangeLocalUserPasswordMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformChangeLocalUserPassword = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformChangeLocalUserPassword>>, TError,{data: PlatformChangeLocalUserPasswordBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformChangeLocalUserPassword>>,
        TError,
        {data: PlatformChangeLocalUserPasswordBody},
        TContext
      > => {

      const mutationOptions = getPlatformChangeLocalUserPasswordMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Update customer details
 */
export const platformUpdateCustomer = (
    platformUpdateCustomerBody: PlatformUpdateCustomerBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/user/customer`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: platformUpdateCustomerBody
    },
      );
    }
  


export const getPlatformUpdateCustomerMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomer>>, TError,{data: PlatformUpdateCustomerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomer>>, TError,{data: PlatformUpdateCustomerBody}, TContext> => {

const mutationKey = ['platformUpdateCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformUpdateCustomer>>, {data: PlatformUpdateCustomerBody}> = (props) => {
          const {data} = props ?? {};

          return  platformUpdateCustomer(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformUpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof platformUpdateCustomer>>>
    export type PlatformUpdateCustomerMutationBody = PlatformUpdateCustomerBody
    export type PlatformUpdateCustomerMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformUpdateCustomer = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformUpdateCustomer>>, TError,{data: PlatformUpdateCustomerBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformUpdateCustomer>>,
        TError,
        {data: PlatformUpdateCustomerBody},
        TContext
      > => {

      const mutationOptions = getPlatformUpdateCustomerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Send a user event
 */
export const platformSendUserEvent = (
    platformSendUserEventBody: PlatformSendUserEventBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformSendUserEventBody, signal
    },
      );
    }
  


export const getPlatformSendUserEventMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendUserEvent>>, TError,{data: PlatformSendUserEventBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformSendUserEvent>>, TError,{data: PlatformSendUserEventBody}, TContext> => {

const mutationKey = ['platformSendUserEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformSendUserEvent>>, {data: PlatformSendUserEventBody}> = (props) => {
          const {data} = props ?? {};

          return  platformSendUserEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformSendUserEventMutationResult = NonNullable<Awaited<ReturnType<typeof platformSendUserEvent>>>
    export type PlatformSendUserEventMutationBody = PlatformSendUserEventBody
    export type PlatformSendUserEventMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse

    export const usePlatformSendUserEvent = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformNotFoundResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformSendUserEvent>>, TError,{data: PlatformSendUserEventBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformSendUserEvent>>,
        TError,
        {data: PlatformSendUserEventBody},
        TContext
      > => {

      const mutationOptions = getPlatformSendUserEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List of the current user's unaccepted invitations
 */
export const platformListCurrentUserInvitations = (
    params?: PlatformListCurrentUserInvitationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformListCurrentUserInvitations200>(
      {url: `/user/invitations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformListCurrentUserInvitationsQueryKey = (params?: PlatformListCurrentUserInvitationsParams,) => {
    return [`/user/invitations`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformListCurrentUserInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError = PlatformNotFoundResponse | PlatformInternalErrorResponse>(params?: PlatformListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformListCurrentUserInvitationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>> = ({ signal }) => platformListCurrentUserInvitations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformListCurrentUserInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>>
export type PlatformListCurrentUserInvitationsQueryError = PlatformNotFoundResponse | PlatformInternalErrorResponse



export function usePlatformListCurrentUserInvitations<TData = Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError = PlatformNotFoundResponse | PlatformInternalErrorResponse>(
 params?: PlatformListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformListCurrentUserInvitations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformListCurrentUserInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the current authenticated local user
 */
export const platformGetCurrentLocalUser = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformLocalUserWithTeams>(
      {url: `/user/local`, method: 'GET', signal
    },
      );
    }
  

export const getPlatformGetCurrentLocalUserQueryKey = () => {
    return [`/user/local`] as const;
    }

    
export const getPlatformGetCurrentLocalUserQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCurrentLocalUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>> = ({ signal }) => platformGetCurrentLocalUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCurrentLocalUserQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>>
export type PlatformGetCurrentLocalUserQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformGetCurrentLocalUser<TData = Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentLocalUser>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCurrentLocalUserQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Start a session using ID token
 */
export const platformLoginUser = (
    platformLoginUserBody: PlatformLoginUserBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformLoginUserBody, signal
    },
      );
    }
  


export const getPlatformLoginUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLoginUser>>, TError,{data: PlatformLoginUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformLoginUser>>, TError,{data: PlatformLoginUserBody}, TContext> => {

const mutationKey = ['platformLoginUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformLoginUser>>, {data: PlatformLoginUserBody}> = (props) => {
          const {data} = props ?? {};

          return  platformLoginUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformLoginUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformLoginUser>>>
    export type PlatformLoginUserMutationBody = PlatformLoginUserBody
    export type PlatformLoginUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformLoginUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLoginUser>>, TError,{data: PlatformLoginUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformLoginUser>>,
        TError,
        {data: PlatformLoginUserBody},
        TContext
      > => {

      const mutationOptions = getPlatformLoginUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Logout a session
 */
export const platformLogoutUser = (
    
 ) => {
      
      
      return customFetch<void>(
      {url: `/user/login`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformLogoutUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLogoutUser>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformLogoutUser>>, TError,void, TContext> => {

const mutationKey = ['platformLogoutUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformLogoutUser>>, void> = () => {
          

          return  platformLogoutUser()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformLogoutUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformLogoutUser>>>
    
    export type PlatformLogoutUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse

    export const usePlatformLogoutUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformLogoutUser>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformLogoutUser>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPlatformLogoutUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get memberships that the user has accepted.
 */
export const platformGetCurrentUserMemberships = (
    params?: PlatformGetCurrentUserMembershipsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformGetCurrentUserMemberships200>(
      {url: `/user/memberships`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformGetCurrentUserMembershipsQueryKey = (params?: PlatformGetCurrentUserMembershipsParams,) => {
    return [`/user/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformGetCurrentUserMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(params?: PlatformGetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformGetCurrentUserMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>> = ({ signal }) => platformGetCurrentUserMemberships(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformGetCurrentUserMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>>
export type PlatformGetCurrentUserMembershipsQueryError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse



export function usePlatformGetCurrentUserMemberships<TData = Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError = PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformInternalErrorResponse>(
 params?: PlatformGetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformGetCurrentUserMemberships>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformGetCurrentUserMembershipsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Reset user password with token
 */
export const platformResetLocalUserPassword = (
    platformResetLocalUserPasswordBody: PlatformResetLocalUserPasswordBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/reset-password-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: platformResetLocalUserPasswordBody, signal
    },
      );
    }
  


export const getPlatformResetLocalUserPasswordMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, TError,{data: PlatformResetLocalUserPasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, TError,{data: PlatformResetLocalUserPasswordBody}, TContext> => {

const mutationKey = ['platformResetLocalUserPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, {data: PlatformResetLocalUserPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  platformResetLocalUserPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformResetLocalUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof platformResetLocalUserPassword>>>
    export type PlatformResetLocalUserPasswordMutationBody = PlatformResetLocalUserPasswordBody
    export type PlatformResetLocalUserPasswordMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformResetLocalUserPassword = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformMethodNotAllowedResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformResetLocalUserPassword>>, TError,{data: PlatformResetLocalUserPasswordBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformResetLocalUserPassword>>,
        TError,
        {data: PlatformResetLocalUserPasswordBody},
        TContext
      > => {

      const mutationOptions = getPlatformResetLocalUserPasswordMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Start a CLI session and create a custom token
 */
export const platformCreateUserToken = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformCreateUserToken201>(
      {url: `/user/token`, method: 'POST', signal
    },
      );
    }
  


export const getPlatformCreateUserTokenMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserToken>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserToken>>, TError,void, TContext> => {

const mutationKey = ['platformCreateUserToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformCreateUserToken>>, void> = () => {
          

          return  platformCreateUserToken()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformCreateUserTokenMutationResult = NonNullable<Awaited<ReturnType<typeof platformCreateUserToken>>>
    
    export type PlatformCreateUserTokenMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse

    export const usePlatformCreateUserToken = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformCreateUserToken>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformCreateUserToken>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPlatformCreateUserTokenMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete user
 */
export const platformDeleteUser = (
    userId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/users/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getPlatformDeleteUserMutationOptions = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteUser>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformDeleteUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['platformDeleteUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformDeleteUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  platformDeleteUser(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof platformDeleteUser>>>
    
    export type PlatformDeleteUserMutationError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse

    export const usePlatformDeleteUser = <TError = PlatformBadRequestResponse | PlatformRequiresAuthenticationResponse | PlatformForbiddenResponse | PlatformNotFoundResponse | PlatformUnprocessableEntityResponse | PlatformInternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformDeleteUser>>, TError,{userId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformDeleteUser>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPlatformDeleteUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Performs authentication and authorization for our image registry.
 */
export const platformAuthRegistryRequest = (
    params?: PlatformAuthRegistryRequestParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformRegistryAuthToken>(
      {url: `/registry/auth`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPlatformAuthRegistryRequestQueryKey = (params?: PlatformAuthRegistryRequestParams,) => {
    return [`/registry/auth`, ...(params ? [params]: [])] as const;
    }

    
export const getPlatformAuthRegistryRequestQueryOptions = <TData = Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError = PlatformDockerErrorResponse>(params?: PlatformAuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformAuthRegistryRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAuthRegistryRequest>>> = ({ signal }) => platformAuthRegistryRequest(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformAuthRegistryRequestQueryResult = NonNullable<Awaited<ReturnType<typeof platformAuthRegistryRequest>>>
export type PlatformAuthRegistryRequestQueryError = PlatformDockerErrorResponse



export function usePlatformAuthRegistryRequest<TData = Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError = PlatformDockerErrorResponse>(
 params?: PlatformAuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformAuthRegistryRequest>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformAuthRegistryRequestQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}


export const getPlatformListAuditLogsResponseMock = (overrideResponse: Partial< PlatformListAuditLogs200 > = {}): PlatformListAuditLogs200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), user: {created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, user_ip_address: faker.string.alpha(20), team_name: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha(20), null]), undefined]), event_type: faker.string.alpha(20), entity_display_name: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha(20), null]), undefined]), event_details: faker.helpers.arrayElement([{}, undefined]), is_success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetAuditLogResponseMock = (overrideResponse: Partial< PlatformAuditLogEvent > = {}): PlatformAuditLogEvent => ({id: faker.string.uuid(), user: {created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, user_ip_address: faker.string.alpha(20), team_name: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha(20), null]), undefined]), event_type: faker.string.alpha(20), entity_display_name: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha(20), null]), undefined]), event_details: faker.helpers.arrayElement([{}, undefined]), is_success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformListFiltersResponseMock = (overrideResponse: Partial< PlatformListFilters200 > = {}): PlatformListFilters200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListFilterTagsResponseMock = (overrideResponse: Partial< PlatformListFilterTags200 > = {}): PlatformListFilterTags200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetFilterByIDResponseMock = (overrideResponse: Partial< PlatformFilter > = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformUpdateFilterResponseMock = (overrideResponse: Partial< PlatformFilter > = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformGetOpenAPIJSONResponseMock = (): PlatformGetOpenAPIJSON200 => ({})

export const getPlatformAssetViewGetStatusResponseMock = (overrideResponse: Partial< PlatformAssetViewGetStatus200 > = {}): PlatformAssetViewGetStatus200 => ({is_running: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformAssetViewListLogsResponseMock = (overrideResponse: Partial< PlatformAssetViewListLogs200 > = {}): PlatformAssetViewListLogs200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), type: faker.helpers.arrayElement(Object.values(PlatformAssetViewRunType)), triggered_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), error_message: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, finished_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformManageGetSAMLResponseMock = (overrideResponse: Partial< PlatformSAMLConfig > = {}): PlatformSAMLConfig => ({platform_base_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_sso_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_entity_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), platform_metadata_download_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_certificate_download_url: faker.internet.url(), metadata_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), metadata_xml: faker.helpers.arrayElement([faker.internet.url(), undefined]), logout_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), role_group_key: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), role_mappings: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.helpers.arrayElements(Object.values(PlatformRole))
      }, undefined]), default_roles: faker.helpers.arrayElement([faker.helpers.arrayElements(Object.values(PlatformRole)), undefined]), disable_access_if_no_role_group: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), enabled: faker.datatype.boolean(), can_enable: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformManageUpdateSAMLResponseMock = (overrideResponse: Partial< PlatformSAMLConfig > = {}): PlatformSAMLConfig => ({platform_base_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_sso_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_entity_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), platform_metadata_download_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), platform_certificate_download_url: faker.internet.url(), metadata_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), metadata_xml: faker.helpers.arrayElement([faker.internet.url(), undefined]), logout_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), role_group_key: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), role_mappings: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.helpers.arrayElements(Object.values(PlatformRole))
      }, undefined]), default_roles: faker.helpers.arrayElement([faker.helpers.arrayElements(Object.values(PlatformRole)), undefined]), disable_access_if_no_role_group: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), enabled: faker.datatype.boolean(), can_enable: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformManageGetPlatformRegistryResponseMock = (overrideResponse: Partial< PlatformManageGetPlatformRegistry200 > = {}): PlatformManageGetPlatformRegistry200 => ({installation_id: faker.string.alpha(20), activation_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), team_name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), api_key_last_four: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_activated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), next_activation_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), offline_license_registered_to: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), offline_license_expires_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), ...overrideResponse})

export const getPlatformManageRegisterPlatformResponseMock = (overrideResponse: Partial< PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205 > = {}): PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205 => (faker.helpers.arrayElement([{team_name: faker.string.alpha(20), ...overrideResponse}, {error: faker.string.alpha(20), button_text: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), button_url: faker.helpers.arrayElement([faker.internet.url(), undefined]), ...overrideResponse}]))

export const getPlatformManageRegisterPlatformWithOfflineLicenseResponseMock = (overrideResponse: Partial< PlatformManageRegisterPlatformWithOfflineLicense200 > = {}): PlatformManageRegisterPlatformWithOfflineLicense200 => ({registered_to: faker.string.alpha(20), expires_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformManageListAllTeamsResponseMock = (overrideResponse: Partial< PlatformManageListAllTeams200 > = {}): PlatformManageListAllTeams200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformManageGetTeamResponseMock = (overrideResponse: Partial< PlatformTeam > = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformManageListTeamMembersResponseMock = (overrideResponse: Partial< PlatformManageListTeamMembers200 > = {}): PlatformManageListTeamMembers200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), user: {created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListLocalUsersResponseMock = (overrideResponse: Partial< PlatformListLocalUsers200 > = {}): PlatformListLocalUsers200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformAddLocalUserResponseMock = (): PlatformLocalUser => ({...{created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})

export const getPlatformGetLocalUserResponseMock = (): PlatformLocalUserWithTeams => ({...{...{created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},},...{teams: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`}))},})

export const getPlatformUpdateLocalUserResponseMock = (): PlatformLocalUser => ({...{created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})

export const getPlatformCreateLocalUserResetTokenResponseMock = (overrideResponse: Partial< PlatformCreateLocalUserResetToken200 > = {}): PlatformCreateLocalUserResetToken200 => ({reset_token: faker.string.alpha(20), ...overrideResponse})

export const getPlatformGetPlatformInfoResponseMock = (overrideResponse: Partial< PlatformGetPlatformInfo200 > = {}): PlatformGetPlatformInfo200 => ({public_ips: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), ...overrideResponse})

export const getPlatformListPlatformVersionsResponseMock = (overrideResponse: Partial< PlatformListPlatformVersions200 > = {}): PlatformListPlatformVersions200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListPluginsResponseMock = (overrideResponse: Partial< PlatformListPlugins200 > = {}): PlatformListPlugins200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, homepage: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), logo: faker.string.alpha(20), display_name: faker.string.alpha(20), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), short_description: faker.string.alpha(20), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp(`^\d+(?:\.\d{1,10})?$`), free_rows_per_month: faker.number.int({min: undefined, max: undefined}), minimum_cloud_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},...{latest_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), pinned_version: faker.helpers.arrayElement([{name: faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), range: faker.helpers.fromRegExp(`^[^~]?v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), initialized: faker.datatype.boolean(), mirroring: faker.datatype.boolean()}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreatePluginResponseMock = (overrideResponse: Partial< PlatformPlugin > = {}): PlatformPlugin => ({team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, homepage: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), logo: faker.string.alpha(20), display_name: faker.string.alpha(20), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), short_description: faker.string.alpha(20), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp(`^\d+(?:\.\d{1,10})?$`), free_rows_per_month: faker.number.int({min: undefined, max: undefined}), minimum_cloud_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformGetPluginResponseMock = (): PlatformListPlugin => ({...{team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, homepage: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), logo: faker.string.alpha(20), display_name: faker.string.alpha(20), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), short_description: faker.string.alpha(20), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp(`^\d+(?:\.\d{1,10})?$`), free_rows_per_month: faker.number.int({min: undefined, max: undefined}), minimum_cloud_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},...{latest_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), pinned_version: faker.helpers.arrayElement([{name: faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), range: faker.helpers.fromRegExp(`^[^~]?v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), initialized: faker.datatype.boolean(), mirroring: faker.datatype.boolean()}, undefined])},})

export const getPlatformUpdatePluginResponseMock = (overrideResponse: Partial< PlatformPlugin > = {}): PlatformPlugin => ({team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, homepage: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), logo: faker.string.alpha(20), display_name: faker.string.alpha(20), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), short_description: faker.string.alpha(20), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp(`^\d+(?:\.\d{1,10})?$`), free_rows_per_month: faker.number.int({min: undefined, max: undefined}), minimum_cloud_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformListPluginVersionsResponseMock = (overrideResponse: Partial< PlatformListPluginVersions200 > = {}): PlatformListPluginVersions200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, published_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), message: faker.string.alpha(20), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), checksums: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetPluginVersionResponseMock = (): PlatformPluginVersionDetails => ({...{...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, published_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), message: faker.string.alpha(20), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), checksums: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},...{spec_json_schema: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), connector_required: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), connector_types: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined])},},...{example_config: faker.string.alpha(20), ui_base_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})

export const getPlatformCreatePluginVersionResponseMock = (): PlatformPluginVersion => ({...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, published_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), message: faker.string.alpha(20), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), checksums: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},...{spec_json_schema: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), connector_required: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), connector_types: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined])},})

export const getPlatformUpdatePluginVersionResponseMock = (): PlatformPluginVersion => ({...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, published_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), message: faker.string.alpha(20), draft: faker.datatype.boolean(), retracted: faker.datatype.boolean(), protocols: faker.helpers.arrayElements([3] as const), supported_targets: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), checksums: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), package_type: faker.helpers.arrayElement(Object.values(PlatformPluginPackageType))},...{spec_json_schema: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), connector_required: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), connector_types: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined])},})

export const getPlatformDownloadPluginAssetResponseMock = (overrideResponse: Partial< PlatformPluginAsset > = {}): PlatformPluginAsset => ({checksum: faker.string.alpha(20), location: faker.internet.url(), ...overrideResponse})

export const getPlatformUploadPluginAssetResponseMock = (overrideResponse: Partial< PlatformReleaseURL > = {}): PlatformReleaseURL => ({url: faker.string.alpha(20), ...overrideResponse})

export const getPlatformListPluginVersionDocsResponseMock = (overrideResponse: Partial< PlatformListPluginVersionDocs200 > = {}): PlatformListPluginVersionDocs200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.helpers.fromRegExp(`^[\w,\s-]+$`), content: faker.string.alpha(20)})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreatePluginVersionDocsResponseMock = (overrideResponse: Partial< PlatformCreatePluginVersionDocs201 > = {}): PlatformCreatePluginVersionDocs201 => ({names: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[\w,\s-]+$`))), undefined]), ...overrideResponse})

export const getPlatformReplacePluginVersionDocsResponseMock = (overrideResponse: Partial< PlatformReplacePluginVersionDocs201 > = {}): PlatformReplacePluginVersionDocs201 => ({names: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[\w,\s-]+$`))), undefined]), ...overrideResponse})

export const getPlatformListPluginVersionTablesResponseMock = (overrideResponse: Partial< PlatformListPluginVersionTables200 > = {}): PlatformListPluginVersionTables200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({description: faker.string.alpha(20), is_incremental: faker.datatype.boolean(), name: faker.helpers.fromRegExp(`^[a-z](_?[a-z0-9]+)+$`), parent: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), relations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), title: faker.string.alpha(20), is_paid: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreatePluginVersionTablesResponseMock = (overrideResponse: Partial< PlatformCreatePluginVersionTables201 > = {}): PlatformCreatePluginVersionTables201 => ({names: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[a-z](_?[a-z0-9]+)+$`))), undefined]), ...overrideResponse})

export const getPlatformGetPluginVersionTableResponseMock = (overrideResponse: Partial< PlatformPluginTableDetails > = {}): PlatformPluginTableDetails => ({columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({description: faker.string.alpha(20), incremental_key: faker.datatype.boolean(), name: faker.string.alpha(20), not_null: faker.datatype.boolean(), primary_key: faker.datatype.boolean(), type: faker.string.alpha(20), type_schema: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), unique: faker.datatype.boolean()})), description: faker.string.alpha(20), is_incremental: faker.datatype.boolean(), name: faker.string.alpha(20), parent: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), relations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), title: faker.string.alpha(20), is_paid: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), permissions_needed: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), ...overrideResponse})

export const getPlatformUploadPluginUIAssetsResponseMock = (overrideResponse: Partial< PlatformUploadPluginUIAssets201 > = {}): PlatformUploadPluginUIAssets201 => ({ui_id: faker.string.alpha(20), assets: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), upload_url: faker.string.alpha(20)})), ...overrideResponse})

export const getPlatformListTablesResponseMock = (overrideResponse: Partial< PlatformListTables200 > = {}): PlatformListTables200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), total_rows: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableListRowsResponseMock = (overrideResponse: Partial< PlatformTableListRows200 > = {}): PlatformTableListRows200 => ({data: {query: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20)})), rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableRowByIdResponseMock = (overrideResponse: Partial< PlatformTableRowById200 > = {}): PlatformTableRowById200 => ({data: {}, matches: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({key: faker.string.alpha(20), value: faker.string.alpha(20), start_index: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), end_index: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])})), ...overrideResponse})

export const getPlatformTableSchemaResponseMock = (overrideResponse: Partial< PlatformTableSchema200 > = {}): PlatformTableSchema200 => ({schema: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20), default_kind: faker.string.alpha(20), default_expression: faker.string.alpha(20), comment: faker.string.alpha(20), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), default_columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), ...overrideResponse})

export const getPlatformBatchTableSchemasResponseMock = (overrideResponse: Partial< PlatformBatchTableSchemas200 > = {}): PlatformBatchTableSchemas200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({table_name: faker.string.alpha(20), schema: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20), default_kind: faker.string.alpha(20), default_expression: faker.string.alpha(20), comment: faker.string.alpha(20), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), default_columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20)))})), ...overrideResponse})

export const getPlatformTableListColumnsResponseMock = (overrideResponse: Partial< PlatformTableListColumns200 > = {}): PlatformTableListColumns200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableColumnListValuesResponseMock = (overrideResponse: Partial< PlatformTableColumnListValues200 > = {}): PlatformTableColumnListValues200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({value: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableListFiltersResponseMock = (overrideResponse: Partial< PlatformTableListFilters200 > = {}): PlatformTableListFilters200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableSaveFilterResponseMock = (overrideResponse: Partial< PlatformFilter > = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformTableListFilterTagsResponseMock = (overrideResponse: Partial< PlatformTableListFilterTags200 > = {}): PlatformTableListFilterTags200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableListRelationsResponseMock = (overrideResponse: Partial< PlatformTableListRelations200 > = {}): PlatformTableListRelations200 => ({data: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({table_name: faker.string.alpha(20), label: faker.string.alpha(20), query: faker.string.alpha(20)})), ...overrideResponse})

export const getPlatformListTeamsResponseMock = (overrideResponse: Partial< PlatformListTeams200 > = {}): PlatformListTeams200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateTeamResponseMock = (overrideResponse: Partial< PlatformTeam > = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformGetTeamByNameResponseMock = (overrideResponse: Partial< PlatformTeam > = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformUpdateTeamResponseMock = (overrideResponse: Partial< PlatformTeam > = {}): PlatformTeam => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean(), ...overrideResponse})

export const getPlatformListAllAlertsResponseMock = (overrideResponse: Partial< PlatformListAllAlerts200 > = {}): PlatformListAllAlerts200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha(20), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int({min: undefined, max: undefined}), last_evaluated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), triggered_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, notification_destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`}))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTestUnsavedAlertResponseMock = (overrideResponse: Partial< PlatformTestUnsavedAlert200 > = {}): PlatformTestUnsavedAlert200 => ({results: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({destination_id: faker.string.alpha(20), error: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), response: {is_success: faker.datatype.boolean(), http_status_code: faker.number.int({min: undefined, max: undefined}), http_status: faker.string.alpha(20), http_body: faker.string.alpha(20), http_headers: {
        [faker.string.alphanumeric(5)]: faker.string.alpha(20)
      }}})), ...overrideResponse})

export const getPlatformListTeamAPIKeysResponseMock = (overrideResponse: Partial< PlatformListTeamAPIKeys200 > = {}): PlatformListTeamAPIKeys200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.helpers.fromRegExp(`^(?:[a-zA-Z0-9][a-zA-Z0-9- ]*)?[a-zA-Z0-9]$`), created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), id: faker.string.uuid(), key: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), expires_at: `${faker.date.past().toISOString().split('.')[0]}Z`, last_access_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), expired: faker.datatype.boolean(), roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({team: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), undefined]), role: faker.helpers.arrayElement(Object.values(PlatformAPIKeyRole))}))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, allowed_roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({team: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), undefined]), role: faker.helpers.arrayElement(Object.values(PlatformAPIKeyRole))})), ...overrideResponse})

export const getPlatformCreateTeamAPIKeyResponseMock = (overrideResponse: Partial< PlatformAPIKey > = {}): PlatformAPIKey => ({name: faker.helpers.fromRegExp(`^(?:[a-zA-Z0-9][a-zA-Z0-9- ]*)?[a-zA-Z0-9]$`), created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), id: faker.string.uuid(), key: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), expires_at: `${faker.date.past().toISOString().split('.')[0]}Z`, last_access_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), expired: faker.datatype.boolean(), roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({team: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), undefined]), role: faker.helpers.arrayElement(Object.values(PlatformAPIKeyRole))})), ...overrideResponse})

export const getPlatformListConnectorsResponseMock = (overrideResponse: Partial< PlatformListConnectors200 > = {}): PlatformListConnectors200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), type: faker.string.alpha(20), name: faker.string.alpha(20), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateConnectorResponseMock = (overrideResponse: Partial< PlatformConnector > = {}): PlatformConnector => ({id: faker.string.uuid(), type: faker.string.alpha(20), name: faker.string.alpha(20), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformGetConnectorResponseMock = (overrideResponse: Partial< PlatformConnector > = {}): PlatformConnector => ({id: faker.string.uuid(), type: faker.string.alpha(20), name: faker.string.alpha(20), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformUpdateConnectorResponseMock = (overrideResponse: Partial< PlatformConnector > = {}): PlatformConnector => ({id: faker.string.uuid(), type: faker.string.alpha(20), name: faker.string.alpha(20), status: faker.helpers.arrayElement(Object.values(PlatformConnectorStatus)), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformGetConnectorAuthStatusAWSResponseMock = (overrideResponse: Partial< PlatformGetConnectorAuthStatusAWS200 > = {}): PlatformGetConnectorAuthStatusAWS200 => ({role_arn: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), external_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformAuthenticateConnectorAWSResponseMock = (overrideResponse: Partial< PlatformConnectorAuthResponseAWS > = {}): PlatformConnectorAuthResponseAWS => ({redirect_url: faker.string.alpha(20), role_template_url: faker.string.alpha(20), suggested_external_id: faker.string.alpha(20), suggested_policy_arns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), ...overrideResponse})

export const getPlatformGetConnectorAuthStatusGCPResponseMock = (overrideResponse: Partial< PlatformGetConnectorAuthStatusGCP200 > = {}): PlatformGetConnectorAuthStatusGCP200 => ({service_account: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformAuthenticateConnectorGCPResponseMock = (overrideResponse: Partial< PlatformConnectorAuthResponseGCP > = {}): PlatformConnectorAuthResponseGCP => ({service_account: faker.string.alpha(20), ...overrideResponse})

export const getPlatformAuthenticateConnectorOAuthResponseMock = (overrideResponse: Partial< PlatformConnectorAuthResponseOAuth > = {}): PlatformConnectorAuthResponseOAuth => ({redirect_url: faker.string.alpha(20), ...overrideResponse})

export const getPlatformAuthenticateConnectorFinishOAuthResponseMock = (overrideResponse: Partial< PlatformConnectorAuthResponseOAuth | void > = {}): PlatformConnectorAuthResponseOAuth | void => ({redirect_url: faker.string.alpha(20), ...overrideResponse})

export const getPlatformListAllCustomColumnsResponseMock = (overrideResponse: Partial< PlatformListAllCustomColumns200 > = {}): PlatformListAllCustomColumns200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table_name: faker.string.alpha(20), column_name: faker.string.alpha(20), label: faker.string.alpha(20), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`)})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformSaveCustomColumnResponseMock = (overrideResponse: Partial< PlatformCustomColumn > = {}): PlatformCustomColumn => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table_name: faker.string.alpha(20), column_name: faker.string.alpha(20), label: faker.string.alpha(20), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), ...overrideResponse})

export const getPlatformGetCustomColumnResponseMock = (overrideResponse: Partial< PlatformCustomColumn > = {}): PlatformCustomColumn => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table_name: faker.string.alpha(20), column_name: faker.string.alpha(20), label: faker.string.alpha(20), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), ...overrideResponse})

export const getPlatformUpdateCustomColumnResponseMock = (overrideResponse: Partial< PlatformCustomColumn > = {}): PlatformCustomColumn => ({id: faker.string.uuid(), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table_name: faker.string.alpha(20), column_name: faker.string.alpha(20), label: faker.string.alpha(20), column_type: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformCustomColumnColumnType)), undefined]), value_type: faker.helpers.arrayElement(Object.values(PlatformCustomColumnValueType)), value_expr: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by: {id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), ...overrideResponse})

export const getPlatformPutCustomColumnDataResponseMock = (overrideResponse: Partial< PlatformPutCustomColumnData202 > = {}): PlatformPutCustomColumnData202 => ({data: {created_at: `${faker.date.past().toISOString().split('.')[0]}Z`}, ...overrideResponse})

export const getPlatformPutCustomColumnValuesResponseMock = (): PlatformPutCustomColumnValues200 => ({})

export const getPlatformListFiltersTeamResponseMock = (overrideResponse: Partial< PlatformListFiltersTeam200 > = {}): PlatformListFiltersTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListFilterTagsTeamResponseMock = (overrideResponse: Partial< PlatformListFilterTagsTeam200 > = {}): PlatformListFilterTagsTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetFilterByIDTeamResponseMock = (overrideResponse: Partial< PlatformFilter > = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformUpdateFilterTeamResponseMock = (overrideResponse: Partial< PlatformFilter > = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformCreateTeamImagesResponseMock = (overrideResponse: Partial< PlatformCreateTeamImages201 > = {}): PlatformCreateTeamImages201 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), checksum: faker.string.alpha(20), url: faker.string.alpha(20), upload_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), required_headers: {
        [faker.string.alphanumeric(5)]: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20)))
      }})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListTeamInvitationsResponseMock = (overrideResponse: Partial< PlatformListTeamInvitations200 > = {}): PlatformListTeamInvitations200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), email: faker.internet.email(), role: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformAcceptTeamInvitationResponseMock = (overrideResponse: Partial< PlatformMembershipWithTeam > = {}): PlatformMembershipWithTeam => ({roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), team: {created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean()}, ...overrideResponse})

export const getPlatformGetTeamMembershipsResponseMock = (overrideResponse: Partial< PlatformGetTeamMemberships200 > = {}): PlatformGetTeamMemberships200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), user: {created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListAllNotificationDestinationsResponseMock = (overrideResponse: Partial< PlatformListAllNotificationDestinations200 > = {}): PlatformListAllNotificationDestinations200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateNotificationDestinationResponseMock = (overrideResponse: Partial< PlatformNotificationDestination > = {}): PlatformNotificationDestination => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), http_headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha(20)
      }, undefined]), http_body: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformTestUnsavedNotificationDestinationResponseMock = (overrideResponse: Partial< PlatformNotificationDestinationTestResponse > = {}): PlatformNotificationDestinationTestResponse => ({is_success: faker.datatype.boolean(), http_status_code: faker.number.int({min: undefined, max: undefined}), http_status: faker.string.alpha(20), http_body: faker.string.alpha(20), http_headers: {
        [faker.string.alphanumeric(5)]: faker.string.alpha(20)
      }, ...overrideResponse})

export const getPlatformGetNotificationDestinationResponseMock = (overrideResponse: Partial< PlatformNotificationDestination > = {}): PlatformNotificationDestination => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), http_headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha(20)
      }, undefined]), http_body: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformUpdateNotificationDestinationResponseMock = (overrideResponse: Partial< PlatformNotificationDestination > = {}): PlatformNotificationDestination => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), http_headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha(20)
      }, undefined]), http_body: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformGetNotificationDestinationAlertsResponseMock = (overrideResponse: Partial< PlatformGetNotificationDestinationAlerts200 > = {}): PlatformGetNotificationDestinationAlerts200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha(20), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int({min: undefined, max: undefined}), last_evaluated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), triggered_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, notification_destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`}))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTestNotificationDestinationResponseMock = (overrideResponse: Partial< PlatformNotificationDestinationTestResponse > = {}): PlatformNotificationDestinationTestResponse => ({is_success: faker.datatype.boolean(), http_status_code: faker.number.int({min: undefined, max: undefined}), http_status: faker.string.alpha(20), http_body: faker.string.alpha(20), http_headers: {
        [faker.string.alphanumeric(5)]: faker.string.alpha(20)
      }, ...overrideResponse})

export const getPlatformCreateAWSOnboardingResponseMock = (overrideResponse: Partial< PlatformOnboardingAWSCreateResponse > = {}): PlatformOnboardingAWSCreateResponse => ({id: faker.string.uuid(), region: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), stack_name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), issuer_url: faker.string.alpha(20), audience: faker.string.alpha(20), subject: faker.string.alpha(20), notify_path: faker.string.alpha(20), template_url: faker.string.alpha(20), notify_token: faker.string.alpha(20), ...overrideResponse})

export const getPlatformGetAWSOnboardingResponseMock = (overrideResponse: Partial< PlatformOnboardingAWS > = {}): PlatformOnboardingAWS => ({id: faker.string.uuid(), stage: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, issuer_url: faker.string.alpha(20), audience: faker.string.alpha(20), subject: faker.string.alpha(20), management_role_arn: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), sync_role_name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), organizational_units: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), ...overrideResponse})

export const getPlatformGetAWSAccountsInRootResponseMock = (overrideResponse: Partial< PlatformOnboardingAWSAccounts > = {}): PlatformOnboardingAWSAccounts => ({id: faker.string.alpha(20), arn: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), children: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha(20), arn: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), children: faker.helpers.arrayElement([[], undefined])})), undefined]), ...overrideResponse})

export const getPlatformGetAWSAccountsInParentResponseMock = (overrideResponse: Partial< PlatformOnboardingAWSAccounts > = {}): PlatformOnboardingAWSAccounts => ({id: faker.string.alpha(20), arn: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), children: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha(20), arn: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), type: faker.helpers.arrayElement(['OU','account','root'] as const), name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), children: faker.helpers.arrayElement([[], undefined])})), undefined]), ...overrideResponse})

export const getPlatformListPluginsByTeamResponseMock = (overrideResponse: Partial< PlatformListPluginsByTeam200 > = {}): PlatformListPluginsByTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), category: faker.helpers.arrayElement(Object.values(PlatformPluginCategory)), price_category: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginPriceCategory)), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, homepage: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), logo: faker.string.alpha(20), display_name: faker.string.alpha(20), official: faker.datatype.boolean(), release_stage: faker.helpers.arrayElement(Object.values(PlatformPluginReleaseStage)), repository: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), short_description: faker.string.alpha(20), tier: faker.helpers.arrayElement(Object.values(PlatformPluginTier)), public: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), usd_per_row: faker.helpers.fromRegExp(`^\d+(?:\.\d{1,10})?$`), free_rows_per_month: faker.number.int({min: undefined, max: undefined}), minimum_cloud_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformDownloadPluginAssetByTeamResponseMock = (overrideResponse: Partial< PlatformPluginAsset > = {}): PlatformPluginAsset => ({checksum: faker.string.alpha(20), location: faker.internet.url(), ...overrideResponse})

export const getPlatformListPoliciesResponseMock = (overrideResponse: Partial< PlatformListPolicies200 > = {}): PlatformListPolicies200 => ({policies: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), description: faker.string.alpha(20), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreatePolicyResponseMock = (overrideResponse: Partial< PlatformCreatePolicy201 > = {}): PlatformCreatePolicy201 => ({data: {id: faker.string.uuid(), name: faker.string.alpha(20), description: faker.string.alpha(20), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformListAllFrameworksResponseMock = (overrideResponse: Partial< PlatformListAllFrameworks200 > = {}): PlatformListAllFrameworks200 => ({frameworks: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), label: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetPolicyResponseMock = (overrideResponse: Partial< PlatformGetPolicy200 > = {}): PlatformGetPolicy200 => ({data: {id: faker.string.uuid(), name: faker.string.alpha(20), description: faker.string.alpha(20), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformUpdatePolicyResponseMock = (overrideResponse: Partial< PlatformUpdatePolicy200 > = {}): PlatformUpdatePolicy200 => ({data: {id: faker.string.uuid(), name: faker.string.alpha(20), description: faker.string.alpha(20), status: faker.helpers.arrayElement(['paused','active'] as const), framework_ids: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.uuid())), filter_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), evaluated_resources: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), rule_violations: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_by2: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformListPolicyFrameworksResponseMock = (overrideResponse: Partial< PlatformListPolicyFrameworks200 > = {}): PlatformListPolicyFrameworks200 => ({frameworks: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), label: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListPolicyRulesResponseMock = (overrideResponse: Partial< PlatformListPolicyRules200 > = {}): PlatformListPolicyRules200 => ({rules: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), framework_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), framework_name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), risk: faker.helpers.arrayElement([faker.helpers.arrayElement(['critical','high','medium','low'] as const), undefined]), category: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), violations: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), remediation: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), learn_more_link: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListPolicyRuleDetailsResponseMock = (overrideResponse: Partial< PlatformListPolicyRuleDetails200 > = {}): PlatformListPolicyRuleDetails200 => ({details: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), account: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), cloud: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), region: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetPolicyViolationsHistoryResponseMock = (overrideResponse: Partial< PlatformGetPolicyViolationsHistory200 > = {}): PlatformGetPolicyViolationsHistory200 => ({details: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), rule_violations: faker.number.int({min: undefined, max: undefined}), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), ...overrideResponse})

export const getPlatformListAllQueriesTeamResponseMock = (overrideResponse: Partial< PlatformListAllQueriesTeam200 > = {}): PlatformListAllQueriesTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), query: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha(20), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int({min: undefined, max: undefined}), last_evaluated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), triggered_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, num_destinations: faker.number.int({min: undefined, max: undefined})}, undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformExecuteAdHocQueryTeamResponseMock = (overrideResponse: Partial< PlatformExecuteAdHocQueryTeam200 > = {}): PlatformExecuteAdHocQueryTeam200 => ({data: {query: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20)})), rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformSaveQueryTeamResponseMock = (overrideResponse: Partial< PlatformQueryDetail > = {}): PlatformQueryDetail => ({id: faker.string.uuid(), name: faker.string.alpha(20), query: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha(20), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int({min: undefined, max: undefined}), last_evaluated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), triggered_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, notification_destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`}))}, undefined]), ...overrideResponse})

export const getPlatformListQueryTagsTeamResponseMock = (overrideResponse: Partial< PlatformListQueryTagsTeam200 > = {}): PlatformListQueryTagsTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetSavedQueryTeamResponseMock = (overrideResponse: Partial< PlatformQueryDetail > = {}): PlatformQueryDetail => ({id: faker.string.uuid(), name: faker.string.alpha(20), query: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha(20), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int({min: undefined, max: undefined}), last_evaluated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), triggered_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, notification_destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`}))}, undefined]), ...overrideResponse})

export const getPlatformUpdateQueryTeamResponseMock = (overrideResponse: Partial< PlatformQueryDetail > = {}): PlatformQueryDetail => ({id: faker.string.uuid(), name: faker.string.alpha(20), query: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, alert_configured: faker.datatype.boolean(), alert: faker.helpers.arrayElement([{id: faker.string.uuid(), query_id: faker.string.uuid(), enabled: faker.datatype.boolean(), message: faker.string.alpha(20), severity: faker.helpers.arrayElement(Object.values(PlatformAlertSeverity)), state: faker.helpers.arrayElement(Object.values(PlatformAlertState)), total_violations: faker.number.int({min: undefined, max: undefined}), last_evaluated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), triggered_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, notification_destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), enabled: faker.datatype.boolean(), url: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`}))}, undefined]), ...overrideResponse})

export const getPlatformExecuteSavedQueryTeamResponseMock = (overrideResponse: Partial< PlatformExecuteSavedQueryTeam200 > = {}): PlatformExecuteSavedQueryTeam200 => ({data: {query: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20)})), rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformQueryListFiltersTeamResponseMock = (overrideResponse: Partial< PlatformQueryListFiltersTeam200 > = {}): PlatformQueryListFiltersTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformQuerySaveFilterTeamResponseMock = (overrideResponse: Partial< PlatformFilter > = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformQueryListFilterTagsTeamResponseMock = (overrideResponse: Partial< PlatformQueryListFilterTagsTeam200 > = {}): PlatformQueryListFilterTagsTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListReportsResponseMock = (overrideResponse: Partial< PlatformListReports200 > = {}): PlatformListReports200 => ({reports: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateReportResponseMock = (overrideResponse: Partial< PlatformCreateReport201 > = {}): PlatformCreateReport201 => ({data: {id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformGetReportResponseMock = (overrideResponse: Partial< PlatformGetReport200 > = {}): PlatformGetReport200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformUpdateReportResponseMock = (overrideResponse: Partial< PlatformUpdateReport200 > = {}): PlatformUpdateReport200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), private: faker.datatype.boolean(), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformListReportTemplatesResponseMock = (overrideResponse: Partial< PlatformListReportTemplates200 > = {}): PlatformListReportTemplates200 => ({templates: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateReportTemplateResponseMock = (overrideResponse: Partial< PlatformCreateReportTemplate201 > = {}): PlatformCreateReportTemplate201 => ({data: {id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformGetReportTemplateResponseMock = (overrideResponse: Partial< PlatformGetReportTemplate200 > = {}): PlatformGetReportTemplate200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformUpdateReportTemplateResponseMock = (overrideResponse: Partial< PlatformUpdateReportTemplate200 > = {}): PlatformUpdateReportTemplate200 => ({data: {id: faker.string.uuid(), title: faker.string.alpha(20), description: faker.string.alpha(20), content: faker.string.alpha(20), visible: faker.datatype.boolean(), created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, ...overrideResponse})

export const getPlatformCreateSyncDestinationTestConnectionResponseMock = (overrideResponse: Partial< PlatformSyncDestinationTestConnection > = {}): PlatformSyncDestinationTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformGetSyncDestinationTestConnectionResponseMock = (overrideResponse: Partial< PlatformSyncDestinationTestConnection > = {}): PlatformSyncDestinationTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformUpdateSyncTestConnectionForSyncDestinationResponseMock = (overrideResponse: Partial< PlatformSyncDestinationTestConnection > = {}): PlatformSyncDestinationTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformGetSyncDestinationTestConnectionLogsResponseMock = (overrideResponse: Partial< PlatformGetSyncDestinationTestConnectionLogs200One | string | void > = {}): PlatformGetSyncDestinationTestConnectionLogs200One | string | void => (faker.helpers.arrayElement([{location: faker.internet.url(), ...overrideResponse}, faker.word.sample()]))

export const getPlatformPromoteSyncDestinationTestConnectionResponseMock = (): PlatformSyncDestination => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), write_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), undefined]), migrate_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`))), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})

export const getPlatformListSyncDestinationsResponseMock = (overrideResponse: Partial< PlatformListSyncDestinations200 > = {}): PlatformListSyncDestinations200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), write_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), undefined]), migrate_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`))), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetSyncDestinationResponseMock = (): PlatformSyncDestination => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), write_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), undefined]), migrate_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`))), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})

export const getPlatformUpdateSyncDestinationResponseMock = (): PlatformSyncDestination => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), write_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), undefined]), migrate_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`))), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})

export const getPlatformListSyncDestinationSyncsResponseMock = (overrideResponse: Partial< PlatformListSyncDestinationSyncs200 > = {}): PlatformListSyncDestinationSyncs200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), source: faker.string.alpha(20), destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha(20), cpu: faker.string.alpha(20), memory: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), total_rows: faker.number.int({min: undefined, max: undefined}), warnings: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined})}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetTestConnectionForSyncDestinationResponseMock = (overrideResponse: Partial< PlatformSyncTestConnection > = {}): PlatformSyncTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), plugin_kind: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginKind)), undefined]), ...overrideResponse})

export const getPlatformCreateSyncSourceTestConnectionResponseMock = (overrideResponse: Partial< PlatformSyncSourceTestConnection > = {}): PlatformSyncSourceTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), ...overrideResponse})

export const getPlatformGetSyncSourceTestConnectionResponseMock = (overrideResponse: Partial< PlatformSyncSourceTestConnection > = {}): PlatformSyncSourceTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), ...overrideResponse})

export const getPlatformUpdateSyncTestConnectionForSyncSourceResponseMock = (overrideResponse: Partial< PlatformSyncSourceTestConnection > = {}): PlatformSyncSourceTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), ...overrideResponse})

export const getPlatformGetSyncSourceTestConnectionLogsResponseMock = (overrideResponse: Partial< PlatformGetSyncSourceTestConnectionLogs200One | string | void > = {}): PlatformGetSyncSourceTestConnectionLogs200One | string | void => (faker.helpers.arrayElement([{location: faker.internet.url(), ...overrideResponse}, faker.word.sample()]))

export const getPlatformPromoteSyncSourceTestConnectionResponseMock = (): PlatformSyncSource => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), tables: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})

export const getPlatformListSyncSourcesResponseMock = (overrideResponse: Partial< PlatformListSyncSources200 > = {}): PlatformListSyncSources200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), tables: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetSyncSourceResponseMock = (): PlatformSyncSource => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), tables: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})

export const getPlatformUpdateSyncSourceResponseMock = (): PlatformSyncSource => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), tables: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), skip_tables: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), onboarding_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})

export const getPlatformListSyncSourceSyncsResponseMock = (overrideResponse: Partial< PlatformListSyncSourceSyncs200 > = {}): PlatformListSyncSourceSyncs200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), source: faker.string.alpha(20), destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha(20), cpu: faker.string.alpha(20), memory: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), total_rows: faker.number.int({min: undefined, max: undefined}), warnings: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined})}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetTestConnectionForSyncSourceResponseMock = (overrideResponse: Partial< PlatformSyncTestConnection > = {}): PlatformSyncTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), plugin_kind: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginKind)), undefined]), ...overrideResponse})

export const getPlatformCreateSyncTransformerTestConnectionResponseMock = (overrideResponse: Partial< PlatformSyncTransformerTestConnection > = {}): PlatformSyncTransformerTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), ...overrideResponse})

export const getPlatformGetSyncTransformerTestConnectionResponseMock = (overrideResponse: Partial< PlatformSyncTransformerTestConnection > = {}): PlatformSyncTransformerTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), ...overrideResponse})

export const getPlatformUpdateSyncTestConnectionForSyncTransformerResponseMock = (overrideResponse: Partial< PlatformSyncTransformerTestConnection > = {}): PlatformSyncTransformerTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), ...overrideResponse})

export const getPlatformGetSyncTransformerTestConnectionLogsResponseMock = (overrideResponse: Partial< PlatformGetSyncTransformerTestConnectionLogs200One | string | void > = {}): PlatformGetSyncTransformerTestConnectionLogs200One | string | void => (faker.helpers.arrayElement([{location: faker.internet.url(), ...overrideResponse}, faker.word.sample()]))

export const getPlatformPromoteSyncTransformerTestConnectionResponseMock = (): PlatformSyncTransformer => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean()},})

export const getPlatformListSyncTransformersResponseMock = (overrideResponse: Partial< PlatformListSyncTransformers200 > = {}): PlatformListSyncTransformers200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean()},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetSyncTransformerResponseMock = (): PlatformSyncTransformer => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean()},})

export const getPlatformUpdateSyncTransformerResponseMock = (): PlatformSyncTransformer => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean()},})

export const getPlatformListSyncTransformerSyncsResponseMock = (overrideResponse: Partial< PlatformListSyncTransformerSyncs200 > = {}): PlatformListSyncTransformerSyncs200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), source: faker.string.alpha(20), destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha(20), cpu: faker.string.alpha(20), memory: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListSyncTransformerSyncDestinationsResponseMock = (overrideResponse: Partial< PlatformListSyncTransformerSyncDestinations200 > = {}): PlatformListSyncTransformerSyncDestinations200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), undefined]), path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), version: faker.string.alpha(20), write_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationWriteMode)), undefined]), migrate_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncDestinationMigrateMode)), undefined]), sync_group_id: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), send_sync_summary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), spec: faker.helpers.arrayElement([{}, undefined]), env: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), last_update_source: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncLastUpdateSource)), undefined]), connector_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), transformers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`))), undefined])},...{created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, env: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20)})), draft: faker.datatype.boolean(), previous_version: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetTestConnectionForSyncTransformerResponseMock = (overrideResponse: Partial< PlatformSyncTestConnection > = {}): PlatformSyncTestConnection => ({id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncTestConnectionStatus)), failure_reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), failure_code: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), plugin_path: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^cloudquery/[^/]+`), undefined]), plugin_version: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^v[0-9]+\.[0-9]+\.[0-9]+(-[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?(\+[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*)?$`), undefined]), plugin_kind: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformPluginKind)), undefined]), ...overrideResponse})

export const getPlatformListSyncUpgradesResponseMock = (overrideResponse: Partial< PlatformListSyncUpgrades200 > = {}): PlatformListSyncUpgrades200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({path: faker.helpers.fromRegExp(`^cloudquery/[^/]+`), kind: faker.helpers.arrayElement(Object.values(PlatformPluginKind)), prev_version: faker.string.alpha(20), new_version: faker.string.alpha(20), platform_version: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, sync_source_destination_names: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), sync_source_destination_display_names: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20)))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListSyncsResponseMock = (overrideResponse: Partial< PlatformListSyncs200 > = {}): PlatformListSyncs200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), source: faker.string.alpha(20), destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha(20), cpu: faker.string.alpha(20), memory: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined])},...{last_run: faker.helpers.arrayElement([{id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), migration: faker.datatype.boolean(), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), total_rows: faker.number.int({min: undefined, max: undefined}), warnings: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined})}, undefined])},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateSyncResponseMock = (overrideResponse: Partial< PlatformSync > = {}): PlatformSync => ({name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), source: faker.string.alpha(20), destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha(20), cpu: faker.string.alpha(20), memory: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformGetSyncResponseMock = (overrideResponse: Partial< PlatformSync > = {}): PlatformSync => ({name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), source: faker.string.alpha(20), destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha(20), cpu: faker.string.alpha(20), memory: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformUpdateSyncResponseMock = (overrideResponse: Partial< PlatformSync > = {}): PlatformSync => ({name: faker.helpers.fromRegExp(`^[a-zA-Z0-9_-]+$`), display_name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}\p{N}_][a-zA-Z\p{L}\p{N}_ \-'\(\)\[\]]*$`), source: faker.string.alpha(20), destinations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), disabled: faker.datatype.boolean(), schedule: faker.string.alpha(20), cpu: faker.string.alpha(20), memory: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`, created_by: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), ...overrideResponse})

export const getPlatformListSyncRunsResponseMock = (overrideResponse: Partial< PlatformListSyncRuns200 > = {}): PlatformListSyncRuns200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({sync_name: faker.string.alpha(20), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), total_rows: faker.number.int({min: undefined, max: undefined}), warnings: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined}), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateSyncRunResponseMock = (overrideResponse: Partial< PlatformSyncRun > = {}): PlatformSyncRun => ({sync_name: faker.string.alpha(20), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), total_rows: faker.number.int({min: undefined, max: undefined}), warnings: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined}), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ...overrideResponse})

export const getPlatformGetSyncRunResponseMock = (): PlatformSyncRunDetails => ({...{sync_name: faker.string.alpha(20), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), total_rows: faker.number.int({min: undefined, max: undefined}), warnings: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined}), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},...{cpu_seconds: faker.helpers.arrayElement([faker.number.float(), undefined]), memory_byte_seconds: faker.helpers.arrayElement([faker.number.float(), undefined]), network_egress_bytes: faker.helpers.arrayElement([faker.number.float(), undefined])},})

export const getPlatformUpdateSyncRunResponseMock = (overrideResponse: Partial< PlatformSyncRun > = {}): PlatformSyncRun => ({sync_name: faker.string.alpha(20), id: faker.string.uuid(), status: faker.helpers.arrayElement(Object.values(PlatformSyncRunStatus)), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformSyncRunStatusReason)), undefined]), workers: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({phase: faker.helpers.arrayElement(Object.values(PlatformSyncRunWorkerPhase)), reason: faker.helpers.arrayElement([faker.string.alpha(20), undefined])})), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), total_rows: faker.number.int({min: undefined, max: undefined}), warnings: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined}), migration: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]), ...overrideResponse})

export const getPlatformGetSyncRunLogsResponseMock = (overrideResponse: Partial< PlatformGetSyncRunLogs200One | string | void > = {}): PlatformGetSyncRunLogs200One | string | void => (faker.helpers.arrayElement([{location: faker.internet.url(), ...overrideResponse}, faker.word.sample()]))

export const getPlatformGetSyncRunStatsResponseMock = (overrideResponse: Partial< PlatformSyncRunStats > = {}): PlatformSyncRunStats => ({completed_tables: faker.number.int({min: undefined, max: undefined}), started_at: `${faker.date.past().toISOString().split('.')[0]}Z`, last_completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), resources: faker.number.int({min: undefined, max: undefined}), errors: faker.number.int({min: undefined, max: undefined}), panics: faker.number.int({min: undefined, max: undefined}), ...overrideResponse})

export const getPlatformGetSyncRunTablesResponseMock = (overrideResponse: Partial< PlatformGetSyncRunTables200 > = {}): PlatformGetSyncRunTables200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({service_name: faker.string.alpha(20), name: faker.string.alpha(20), started_at: `${faker.date.past().toISOString().split('.')[0]}Z`, completed_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), resources: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), errors: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), panics: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetSyncRunConnectorCredentialsResponseMock = (overrideResponse: Partial< PlatformGetSyncRunConnectorCredentials200 > = {}): PlatformGetSyncRunConnectorCredentials200 => ({aws: faker.helpers.arrayElement([{access_key_id: faker.string.alpha(20), secret_access_key: faker.string.alpha(20), session_token: faker.string.alpha(20), source: faker.string.alpha(20), can_expire: faker.datatype.boolean(), expires: `${faker.date.past().toISOString().split('.')[0]}Z`}, undefined]), oauth: faker.helpers.arrayElement([{access_token: faker.string.alpha(20), expires: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, undefined]), ...overrideResponse})

export const getPlatformGetSyncRunConnectorIdentityResponseMock = (overrideResponse: Partial< PlatformGetSyncRunConnectorIdentity200 > = {}): PlatformGetSyncRunConnectorIdentity200 => ({aws: faker.helpers.arrayElement([{role_arn: faker.string.alpha(20)}, undefined]), ...overrideResponse})

export const getPlatformGetTestConnectionConnectorCredentialsResponseMock = (overrideResponse: Partial< PlatformGetTestConnectionConnectorCredentials200 > = {}): PlatformGetTestConnectionConnectorCredentials200 => ({aws: faker.helpers.arrayElement([{access_key_id: faker.string.alpha(20), secret_access_key: faker.string.alpha(20), session_token: faker.string.alpha(20), source: faker.string.alpha(20), can_expire: faker.datatype.boolean(), expires: `${faker.date.past().toISOString().split('.')[0]}Z`}, undefined]), oauth: faker.helpers.arrayElement([{access_token: faker.string.alpha(20), expires: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])}, undefined]), ...overrideResponse})

export const getPlatformGetTestConnectionConnectorIdentityResponseMock = (overrideResponse: Partial< PlatformGetTestConnectionConnectorIdentity200 > = {}): PlatformGetTestConnectionConnectorIdentity200 => ({aws: faker.helpers.arrayElement([{role_arn: faker.string.alpha(20)}, undefined]), ...overrideResponse})

export const getPlatformListTablesTeamResponseMock = (overrideResponse: Partial< PlatformListTablesTeam200 > = {}): PlatformListTablesTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), total_rows: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableListRowsTeamResponseMock = (overrideResponse: Partial< PlatformTableListRowsTeam200 > = {}): PlatformTableListRowsTeam200 => ({data: {query: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20)})), rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({}))))}, metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableRowByIdTeamResponseMock = (overrideResponse: Partial< PlatformTableRowByIdTeam200 > = {}): PlatformTableRowByIdTeam200 => ({data: {}, matches: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({key: faker.string.alpha(20), value: faker.string.alpha(20), start_index: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), end_index: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])})), ...overrideResponse})

export const getPlatformTableSchemaTeamResponseMock = (overrideResponse: Partial< PlatformTableSchemaTeam200 > = {}): PlatformTableSchemaTeam200 => ({schema: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20), default_kind: faker.string.alpha(20), default_expression: faker.string.alpha(20), comment: faker.string.alpha(20), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), default_columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), ...overrideResponse})

export const getPlatformBatchTableSchemasTeamResponseMock = (overrideResponse: Partial< PlatformBatchTableSchemasTeam200 > = {}): PlatformBatchTableSchemasTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({table_name: faker.string.alpha(20), schema: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), type: faker.string.alpha(20), default_kind: faker.string.alpha(20), default_expression: faker.string.alpha(20), comment: faker.string.alpha(20), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), default_columns: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20)))})), ...overrideResponse})

export const getPlatformTableListColumnsTeamResponseMock = (overrideResponse: Partial< PlatformTableListColumnsTeam200 > = {}): PlatformTableListColumnsTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind)), nullable: faker.datatype.boolean()})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableColumnListValuesTeamResponseMock = (overrideResponse: Partial< PlatformTableColumnListValuesTeam200 > = {}): PlatformTableColumnListValuesTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({value: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), kind: faker.helpers.arrayElement(Object.values(PlatformTableSchemaColumnKind))})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableListFiltersTeamResponseMock = (overrideResponse: Partial< PlatformTableListFiltersTeam200 > = {}): PlatformTableListFiltersTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableSaveFilterTeamResponseMock = (overrideResponse: Partial< PlatformFilter > = {}): PlatformFilter => ({id: faker.string.uuid(), name: faker.string.alpha(20), expression: faker.string.alpha(20), description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), table: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), query_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), user_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]), tags: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), undefined]), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, ...overrideResponse})

export const getPlatformTableListFilterTagsTeamResponseMock = (overrideResponse: Partial< PlatformTableListFilterTagsTeam200 > = {}): PlatformTableListFilterTagsTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformTableListRelationsTeamResponseMock = (overrideResponse: Partial< PlatformTableListRelationsTeam200 > = {}): PlatformTableListRelationsTeam200 => ({data: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({table_name: faker.string.alpha(20), label: faker.string.alpha(20), query: faker.string.alpha(20)})), ...overrideResponse})

export const getPlatformGetTeamUsageSummaryResponseMock = (overrideResponse: Partial< PlatformUsageSummary > = {}): PlatformUsageSummary => ({groups: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.string.alpha(20)})), values: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({timestamp: `${faker.date.past().toISOString().split('.')[0]}Z`, paid_rows: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined]), cloud_vcpu_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined]), cloud_vram_byte_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined]), cloud_egress_bytes: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined])})), metadata: {start: `${faker.date.past().toISOString().split('.')[0]}Z`, end: `${faker.date.past().toISOString().split('.')[0]}Z`, aggregation_period: faker.helpers.arrayElement(['day','month'] as const), metrics: faker.helpers.arrayElements(['paid_rows','cloud_egress_bytes','cloud_vcpu_seconds','cloud_vram_byte_seconds'] as const)}, ...overrideResponse})

export const getPlatformGetGroupedTeamUsageSummaryResponseMock = (overrideResponse: Partial< PlatformUsageSummary > = {}): PlatformUsageSummary => ({groups: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({name: faker.string.alpha(20), value: faker.string.alpha(20)})), values: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({timestamp: `${faker.date.past().toISOString().split('.')[0]}Z`, paid_rows: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined]), cloud_vcpu_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined]), cloud_vram_byte_seconds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined]), cloud_egress_bytes: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), undefined])})), metadata: {start: `${faker.date.past().toISOString().split('.')[0]}Z`, end: `${faker.date.past().toISOString().split('.')[0]}Z`, aggregation_period: faker.helpers.arrayElement(['day','month'] as const), metrics: faker.helpers.arrayElements(['paid_rows','cloud_egress_bytes','cloud_vcpu_seconds','cloud_vram_byte_seconds'] as const)}, ...overrideResponse})

export const getPlatformListUsersByTeamResponseMock = (overrideResponse: Partial< PlatformListUsersByTeam200 > = {}): PlatformListUsersByTeam200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformListUserSnapshotsResponseMock = (overrideResponse: Partial< PlatformListUserSnapshots200 > = {}): PlatformListUserSnapshots200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), table_name: faker.string.alpha(20), query: faker.string.alpha(20), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), schedule: faker.string.alpha(20), ttl_duration: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), status: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatus)), undefined]), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatusReason)), undefined])})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateUserSnapshotResponseMock = (overrideResponse: Partial< PlatformUserSnapshot > = {}): PlatformUserSnapshot => ({id: faker.string.uuid(), team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), table_name: faker.string.alpha(20), query: faker.string.alpha(20), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), schedule: faker.string.alpha(20), ttl_duration: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), status: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatus)), undefined]), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatusReason)), undefined]), ...overrideResponse})

export const getPlatformGetUserSnapshotResponseMock = (overrideResponse: Partial< PlatformUserSnapshot > = {}): PlatformUserSnapshot => ({id: faker.string.uuid(), team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), table_name: faker.string.alpha(20), query: faker.string.alpha(20), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), schedule: faker.string.alpha(20), ttl_duration: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), status: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatus)), undefined]), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatusReason)), undefined]), ...overrideResponse})

export const getPlatformUpdateUserSnapshotResponseMock = (overrideResponse: Partial< PlatformUserSnapshot > = {}): PlatformUserSnapshot => ({id: faker.string.uuid(), team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), table_name: faker.string.alpha(20), query: faker.string.alpha(20), created_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), updated_by: faker.helpers.arrayElement([{id: faker.string.uuid(), name: faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), email: faker.string.alpha(20)}, undefined]), schedule: faker.string.alpha(20), ttl_duration: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), status: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatus)), undefined]), status_reason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(PlatformUserSnapshotStatusReason)), undefined]), ...overrideResponse})

export const getPlatformUploadImageResponseMock = (overrideResponse: Partial< PlatformImageURL > = {}): PlatformImageURL => ({upload_url: faker.string.alpha(20), download_url: faker.string.alpha(20), required_headers: {
        [faker.string.alphanumeric(5)]: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20)))
      }, ...overrideResponse})

export const getPlatformGetCurrentUserResponseMock = (): PlatformGetCurrentUser200 => ({...{created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])},...{event_identifiers: faker.helpers.arrayElement([{}, undefined]), group_identifier: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), registered_team_name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), registered_team_internal: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},})

export const getPlatformUpdateCurrentUserResponseMock = (overrideResponse: Partial< PlatformUser > = {}): PlatformUser => ({created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), ...overrideResponse})

export const getPlatformAuthenticateLocalUserResponseMock = (overrideResponse: Partial< PlatformAuthenticateLocalUser200 > = {}): PlatformAuthenticateLocalUser200 => ({id_token: faker.string.alpha(20), ...overrideResponse})

export const getPlatformListCurrentUserInvitationsResponseMock = (overrideResponse: Partial< PlatformListCurrentUserInvitations200 > = {}): PlatformListCurrentUserInvitations200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({...{team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), email: faker.internet.email(), role: faker.string.alpha(20), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`},...{token: faker.string.uuid()},})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformGetCurrentLocalUserResponseMock = (): PlatformLocalUserWithTeams => ({...{...{created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), id: faker.string.uuid(), email: faker.string.alpha(20), name: faker.helpers.arrayElement([faker.helpers.fromRegExp(`^[a-zA-Z\p{L}][a-zA-Z\p{L} \-']*$`), undefined]), updated_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), profile_image_url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]), last_login_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined])},...{roles: faker.helpers.arrayElements(['admin:write','admin:read'] as const), enabled: faker.datatype.boolean(), provider: faker.helpers.arrayElement(Object.values(PlatformLocalUserProvider)), tracking_opted_in: faker.helpers.arrayElement([faker.datatype.boolean(), undefined])},},...{teams: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), team_name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), created_at: `${faker.date.past().toISOString().split('.')[0]}Z`, updated_at: `${faker.date.past().toISOString().split('.')[0]}Z`}))},})

export const getPlatformGetCurrentUserMembershipsResponseMock = (overrideResponse: Partial< PlatformGetCurrentUserMemberships200 > = {}): PlatformGetCurrentUserMemberships200 => ({items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({roles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha(20))), team: {created_at: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), name: faker.helpers.fromRegExp(`^[a-z](-?[a-z0-9]+)+$`), plan: faker.helpers.arrayElement(Object.values(PlatformTeamPlan)), plan_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), is_trial_active: faker.datatype.boolean(), trial_end_time: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), display_name: faker.string.alpha(20), internal: faker.datatype.boolean()}})), metadata: {total_count: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), last_page: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), page_size: faker.number.int({min: undefined, max: undefined}), time_ms: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined])}, ...overrideResponse})

export const getPlatformCreateUserTokenResponseMock = (overrideResponse: Partial< PlatformCreateUserToken201 > = {}): PlatformCreateUserToken201 => ({custom_token: faker.string.alpha(20), ...overrideResponse})

export const getPlatformAuthRegistryRequestResponseMock = (overrideResponse: Partial< PlatformRegistryAuthToken > = {}): PlatformRegistryAuthToken => ({access_token: faker.string.alpha(20), token: faker.string.alpha(20), ...overrideResponse})


export const getPlatformIndexMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<void> | void)) => {
  return http.get('*/', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  })
}

export const getPlatformListAuditLogsMockHandler = (overrideResponse?: PlatformListAuditLogs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAuditLogs200> | PlatformListAuditLogs200)) => {
  return http.get('*/audit-logs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListAuditLogsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetAuditLogMockHandler = (overrideResponse?: PlatformAuditLogEvent | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformAuditLogEvent> | PlatformAuditLogEvent)) => {
  return http.get('*/audit-logs/:id', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetAuditLogResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListFiltersMockHandler = (overrideResponse?: PlatformListFilters200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListFilters200> | PlatformListFilters200)) => {
  return http.get('*/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListFiltersResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListFilterTagsMockHandler = (overrideResponse?: PlatformListFilterTags200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListFilterTags200> | PlatformListFilterTags200)) => {
  return http.get('*/filters/tags', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListFilterTagsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetFilterByIDMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter)) => {
  return http.get('*/filters/:filterId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetFilterByIDResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateFilterMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter)) => {
  return http.patch('*/filters/:filterId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateFilterResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteFilterMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/filters/:filterId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformHealthCheckHeadMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.head>[1]>[0]) => Promise<void> | void)) => {
  return http.head('*/healthcheck', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  })
}

export const getPlatformHealthCheckMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<void> | void)) => {
  return http.get('*/healthcheck', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  })
}

export const getPlatformGetOpenAPIJSONMockHandler = (overrideResponse?: PlatformGetOpenAPIJSON200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetOpenAPIJSON200> | PlatformGetOpenAPIJSON200)) => {
  return http.get('*/openapi.json', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetOpenAPIJSONResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAssetViewGetStatusMockHandler = (overrideResponse?: PlatformAssetViewGetStatus200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformAssetViewGetStatus200> | PlatformAssetViewGetStatus200)) => {
  return http.get('*/manage/assetview', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAssetViewGetStatusResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAssetViewTriggerMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/manage/assetview', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 201,
        
      })
  })
}

export const getPlatformAssetViewListLogsMockHandler = (overrideResponse?: PlatformAssetViewListLogs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformAssetViewListLogs200> | PlatformAssetViewListLogs200)) => {
  return http.get('*/manage/assetview/logs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAssetViewListLogsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageGetSAMLMockHandler = (overrideResponse?: PlatformSAMLConfig | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSAMLConfig> | PlatformSAMLConfig)) => {
  return http.get('*/manage/auth/saml', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageGetSAMLResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageUpdateSAMLMockHandler = (overrideResponse?: PlatformSAMLConfig | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSAMLConfig> | PlatformSAMLConfig)) => {
  return http.patch('*/manage/auth/saml', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageUpdateSAMLResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageGetPlatformRegistryMockHandler = (overrideResponse?: PlatformManageGetPlatformRegistry200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformManageGetPlatformRegistry200> | PlatformManageGetPlatformRegistry200)) => {
  return http.get('*/manage/register-platform', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageGetPlatformRegistryResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageRegisterPlatformMockHandler = (overrideResponse?: PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205> | PlatformManageRegisterPlatform200 | PlatformManageRegisterPlatform205)) => {
  return http.post('*/manage/register-platform', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageRegisterPlatformResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageRegisterPlatformWithOfflineLicenseMockHandler = (overrideResponse?: PlatformManageRegisterPlatformWithOfflineLicense200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformManageRegisterPlatformWithOfflineLicense200> | PlatformManageRegisterPlatformWithOfflineLicense200)) => {
  return http.post('*/manage/register-platform/offline', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageRegisterPlatformWithOfflineLicenseResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageListAllTeamsMockHandler = (overrideResponse?: PlatformManageListAllTeams200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformManageListAllTeams200> | PlatformManageListAllTeams200)) => {
  return http.get('*/manage/teams', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageListAllTeamsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageGetTeamMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam)) => {
  return http.get('*/manage/teams/:teamName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageGetTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageDeleteTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/manage/teams/:teamName', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformManageListTeamMembersMockHandler = (overrideResponse?: PlatformManageListTeamMembers200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformManageListTeamMembers200> | PlatformManageListTeamMembers200)) => {
  return http.get('*/manage/teams/:teamName/members', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformManageListTeamMembersResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformManageAddTeamMemberMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<void> | void)) => {
  return http.put('*/manage/teams/:teamName/members', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformManageRemoveTeamMemberMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/manage/teams/:teamName/members', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListLocalUsersMockHandler = (overrideResponse?: PlatformListLocalUsers200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListLocalUsers200> | PlatformListLocalUsers200)) => {
  return http.get('*/manage/users', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListLocalUsersResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAddLocalUserMockHandler = (overrideResponse?: PlatformLocalUser | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformLocalUser> | PlatformLocalUser)) => {
  return http.post('*/manage/users/add', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAddLocalUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetLocalUserMockHandler = (overrideResponse?: PlatformLocalUserWithTeams | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformLocalUserWithTeams> | PlatformLocalUserWithTeams)) => {
  return http.get('*/manage/users/:userId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetLocalUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateLocalUserMockHandler = (overrideResponse?: PlatformLocalUser | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformLocalUser> | PlatformLocalUser)) => {
  return http.patch('*/manage/users/:userId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateLocalUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteLocalUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/manage/users/:userId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformCreateLocalUserResetTokenMockHandler = (overrideResponse?: PlatformCreateLocalUserResetToken200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateLocalUserResetToken200> | PlatformCreateLocalUserResetToken200)) => {
  return http.post('*/manage/users/:userId/reset', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateLocalUserResetTokenResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetPlatformInfoMockHandler = (overrideResponse?: PlatformGetPlatformInfo200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetPlatformInfo200> | PlatformGetPlatformInfo200)) => {
  return http.get('*/platform-info', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetPlatformInfoResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListPlatformVersionsMockHandler = (overrideResponse?: PlatformListPlatformVersions200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPlatformVersions200> | PlatformListPlatformVersions200)) => {
  return http.get('*/platform-versions', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPlatformVersionsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListPluginsMockHandler = (overrideResponse?: PlatformListPlugins200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPlugins200> | PlatformListPlugins200)) => {
  return http.get('*/plugins', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPluginsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreatePluginMockHandler = (overrideResponse?: PlatformPlugin | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformPlugin> | PlatformPlugin)) => {
  return http.post('*/plugins', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreatePluginResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetPluginMockHandler = (overrideResponse?: PlatformListPlugin | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPlugin> | PlatformListPlugin)) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetPluginResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdatePluginMockHandler = (overrideResponse?: PlatformPlugin | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformPlugin> | PlatformPlugin)) => {
  return http.patch('*/plugins/:teamName/:pluginKind/:pluginName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdatePluginResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeletePluginByTeamAndPluginNameMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListPluginVersionsMockHandler = (overrideResponse?: PlatformListPluginVersions200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginVersions200> | PlatformListPluginVersions200)) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPluginVersionsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetPluginVersionMockHandler = (overrideResponse?: PlatformPluginVersionDetails | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginVersionDetails> | PlatformPluginVersionDetails)) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetPluginVersionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreatePluginVersionMockHandler = (overrideResponse?: PlatformPluginVersion | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformPluginVersion> | PlatformPluginVersion)) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreatePluginVersionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdatePluginVersionMockHandler = (overrideResponse?: PlatformPluginVersion | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformPluginVersion> | PlatformPluginVersion)) => {
  return http.patch('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdatePluginVersionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDownloadPluginAssetMockHandler = (overrideResponse?: PlatformPluginAsset | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginAsset> | PlatformPluginAsset)) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/assets/:targetName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformDownloadPluginAssetResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUploadPluginAssetMockHandler = (overrideResponse?: PlatformReleaseURL | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformReleaseURL> | PlatformReleaseURL)) => {
  return http.post('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/assets/:targetName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUploadPluginAssetResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListPluginVersionDocsMockHandler = (overrideResponse?: PlatformListPluginVersionDocs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginVersionDocs200> | PlatformListPluginVersionDocs200)) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPluginVersionDocsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreatePluginVersionDocsMockHandler = (overrideResponse?: PlatformCreatePluginVersionDocs201 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformCreatePluginVersionDocs201> | PlatformCreatePluginVersionDocs201)) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreatePluginVersionDocsResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformReplacePluginVersionDocsMockHandler = (overrideResponse?: PlatformReplacePluginVersionDocs201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformReplacePluginVersionDocs201> | PlatformReplacePluginVersionDocs201)) => {
  return http.post('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformReplacePluginVersionDocsResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeletePluginVersionDocsMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/docs', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListPluginVersionTablesMockHandler = (overrideResponse?: PlatformListPluginVersionTables200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginVersionTables200> | PlatformListPluginVersionTables200)) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPluginVersionTablesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreatePluginVersionTablesMockHandler = (overrideResponse?: PlatformCreatePluginVersionTables201 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformCreatePluginVersionTables201> | PlatformCreatePluginVersionTables201)) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreatePluginVersionTablesResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeletePluginVersionTablesMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformGetPluginVersionTableMockHandler = (overrideResponse?: PlatformPluginTableDetails | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginTableDetails> | PlatformPluginTableDetails)) => {
  return http.get('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/tables/:tableName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetPluginVersionTableResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUploadPluginUIAssetsMockHandler = (overrideResponse?: PlatformUploadPluginUIAssets201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformUploadPluginUIAssets201> | PlatformUploadPluginUIAssets201)) => {
  return http.post('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/uiassets', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUploadPluginUIAssetsResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformFinalizePluginUIAssetUploadMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<void> | void)) => {
  return http.put('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/uiassets', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformRemovePluginUIAssetsMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/plugins/:teamName/:pluginKind/:pluginName/versions/:versionName/uiassets', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListTablesMockHandler = (overrideResponse?: PlatformListTables200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTables200> | PlatformListTables200)) => {
  return http.get('*/tables', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListTablesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListRowsMockHandler = (overrideResponse?: PlatformTableListRows200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListRows200> | PlatformTableListRows200)) => {
  return http.get('*/tables/:tableName/data', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListRowsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableRowByIdMockHandler = (overrideResponse?: PlatformTableRowById200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableRowById200> | PlatformTableRowById200)) => {
  return http.get('*/tables/:tableName/data/:tableRowId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableRowByIdResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableSchemaMockHandler = (overrideResponse?: PlatformTableSchema200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableSchema200> | PlatformTableSchema200)) => {
  return http.get('*/tables/:tableName/schema', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableSchemaResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformBatchTableSchemasMockHandler = (overrideResponse?: PlatformBatchTableSchemas200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformBatchTableSchemas200> | PlatformBatchTableSchemas200)) => {
  return http.get('*/tables/schemas', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformBatchTableSchemasResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListColumnsMockHandler = (overrideResponse?: PlatformTableListColumns200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListColumns200> | PlatformTableListColumns200)) => {
  return http.get('*/tables/:tableName/columns', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListColumnsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableColumnListValuesMockHandler = (overrideResponse?: PlatformTableColumnListValues200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableColumnListValues200> | PlatformTableColumnListValues200)) => {
  return http.get('*/tables/:tableName/columns/:columnName/values', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableColumnListValuesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListFiltersMockHandler = (overrideResponse?: PlatformTableListFilters200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListFilters200> | PlatformTableListFilters200)) => {
  return http.get('*/tables/:tableName/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListFiltersResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableSaveFilterMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter)) => {
  return http.post('*/tables/:tableName/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableSaveFilterResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListFilterTagsMockHandler = (overrideResponse?: PlatformTableListFilterTags200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListFilterTags200> | PlatformTableListFilterTags200)) => {
  return http.get('*/tables/:tableName/filters/tags', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListFilterTagsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListRelationsMockHandler = (overrideResponse?: PlatformTableListRelations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListRelations200> | PlatformTableListRelations200)) => {
  return http.get('*/tables/:tableName/relations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListRelationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListTeamsMockHandler = (overrideResponse?: PlatformListTeams200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTeams200> | PlatformListTeams200)) => {
  return http.get('*/teams', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListTeamsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateTeamMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam)) => {
  return http.post('*/teams', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateTeamResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTeamByNameMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam)) => {
  return http.get('*/teams/:teamName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTeamByNameResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateTeamMockHandler = (overrideResponse?: PlatformTeam | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformTeam> | PlatformTeam)) => {
  return http.patch('*/teams/:teamName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListAllAlertsMockHandler = (overrideResponse?: PlatformListAllAlerts200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllAlerts200> | PlatformListAllAlerts200)) => {
  return http.get('*/teams/:teamName/alerts', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListAllAlertsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTestUnsavedAlertMockHandler = (overrideResponse?: PlatformTestUnsavedAlert200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformTestUnsavedAlert200> | PlatformTestUnsavedAlert200)) => {
  return http.post('*/teams/:teamName/alerts/test', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTestUnsavedAlertResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListTeamAPIKeysMockHandler = (overrideResponse?: PlatformListTeamAPIKeys200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTeamAPIKeys200> | PlatformListTeamAPIKeys200)) => {
  return http.get('*/teams/:teamName/apikeys', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListTeamAPIKeysResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateTeamAPIKeyMockHandler = (overrideResponse?: PlatformAPIKey | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformAPIKey> | PlatformAPIKey)) => {
  return http.post('*/teams/:teamName/apikeys', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateTeamAPIKeyResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteTeamAPIKeyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/apikeys/:apikeyId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListConnectorsMockHandler = (overrideResponse?: PlatformListConnectors200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListConnectors200> | PlatformListConnectors200)) => {
  return http.get('*/teams/:teamName/connectors', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListConnectorsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateConnectorMockHandler = (overrideResponse?: PlatformConnector | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnector> | PlatformConnector)) => {
  return http.post('*/teams/:teamName/connectors', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateConnectorResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetConnectorMockHandler = (overrideResponse?: PlatformConnector | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformConnector> | PlatformConnector)) => {
  return http.get('*/teams/:teamName/connectors/:connectorId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetConnectorResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateConnectorMockHandler = (overrideResponse?: PlatformConnector | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformConnector> | PlatformConnector)) => {
  return http.patch('*/teams/:teamName/connectors/:connectorId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateConnectorResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformRevokeConnectorMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/connectors/:connectorId/authenticate', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformGetConnectorAuthStatusAWSMockHandler = (overrideResponse?: PlatformGetConnectorAuthStatusAWS200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetConnectorAuthStatusAWS200> | PlatformGetConnectorAuthStatusAWS200)) => {
  return http.get('*/teams/:teamName/connectors/:connectorId/authenticate/aws', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetConnectorAuthStatusAWSResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAuthenticateConnectorAWSMockHandler = (overrideResponse?: PlatformConnectorAuthResponseAWS | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnectorAuthResponseAWS> | PlatformConnectorAuthResponseAWS)) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/aws', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAuthenticateConnectorAWSResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAuthenticateConnectorFinishAWSMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<void> | void)) => {
  return http.patch('*/teams/:teamName/connectors/:connectorId/authenticate/aws', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformGetConnectorAuthStatusGCPMockHandler = (overrideResponse?: PlatformGetConnectorAuthStatusGCP200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetConnectorAuthStatusGCP200> | PlatformGetConnectorAuthStatusGCP200)) => {
  return http.get('*/teams/:teamName/connectors/:connectorId/authenticate/gcp', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetConnectorAuthStatusGCPResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAuthenticateConnectorGCPMockHandler = (overrideResponse?: PlatformConnectorAuthResponseGCP | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnectorAuthResponseGCP> | PlatformConnectorAuthResponseGCP)) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/gcp', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAuthenticateConnectorGCPResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAuthenticateConnectorFinishGCPMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/gcp/finish', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformAuthenticateConnectorOAuthMockHandler = (overrideResponse?: PlatformConnectorAuthResponseOAuth | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformConnectorAuthResponseOAuth> | PlatformConnectorAuthResponseOAuth)) => {
  return http.post('*/teams/:teamName/connectors/:connectorId/authenticate/oauth', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAuthenticateConnectorOAuthResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformAuthenticateConnectorFinishOAuthMockHandler = (overrideResponse?: PlatformConnectorAuthResponseOAuth | void | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformConnectorAuthResponseOAuth | void> | PlatformConnectorAuthResponseOAuth | void)) => {
  return http.patch('*/teams/:teamName/connectors/:connectorId/authenticate/oauth', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAuthenticateConnectorFinishOAuthResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListAllCustomColumnsMockHandler = (overrideResponse?: PlatformListAllCustomColumns200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllCustomColumns200> | PlatformListAllCustomColumns200)) => {
  return http.get('*/teams/:teamName/custom-columns', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListAllCustomColumnsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformSaveCustomColumnMockHandler = (overrideResponse?: PlatformCustomColumn | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCustomColumn> | PlatformCustomColumn)) => {
  return http.post('*/teams/:teamName/custom-columns', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformSaveCustomColumnResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetCustomColumnMockHandler = (overrideResponse?: PlatformCustomColumn | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformCustomColumn> | PlatformCustomColumn)) => {
  return http.get('*/teams/:teamName/custom-columns/:customColumnId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetCustomColumnResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateCustomColumnMockHandler = (overrideResponse?: PlatformCustomColumn | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformCustomColumn> | PlatformCustomColumn)) => {
  return http.patch('*/teams/:teamName/custom-columns/:customColumnId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateCustomColumnResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteCustomColumnMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/custom-columns/:customColumnId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformPutCustomColumnDataMockHandler = (overrideResponse?: PlatformPutCustomColumnData202 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformPutCustomColumnData202> | PlatformPutCustomColumnData202)) => {
  return http.put('*/teams/:teamName/custom-columns/:customColumnId/import', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformPutCustomColumnDataResponseMock()),
      { status: 202,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformPutCustomColumnValuesMockHandler = (overrideResponse?: PlatformPutCustomColumnValues200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformPutCustomColumnValues200> | PlatformPutCustomColumnValues200)) => {
  return http.put('*/teams/:teamName/custom-columns/:customColumnId/values', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformPutCustomColumnValuesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListFiltersTeamMockHandler = (overrideResponse?: PlatformListFiltersTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListFiltersTeam200> | PlatformListFiltersTeam200)) => {
  return http.get('*/teams/:teamName/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListFiltersTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListFilterTagsTeamMockHandler = (overrideResponse?: PlatformListFilterTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListFilterTagsTeam200> | PlatformListFilterTagsTeam200)) => {
  return http.get('*/teams/:teamName/filters/tags', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListFilterTagsTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetFilterByIDTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter)) => {
  return http.get('*/teams/:teamName/filters/:filterId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetFilterByIDTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateFilterTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter)) => {
  return http.patch('*/teams/:teamName/filters/:filterId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateFilterTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteFilterTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/filters/:filterId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformCreateTeamImagesMockHandler = (overrideResponse?: PlatformCreateTeamImages201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateTeamImages201> | PlatformCreateTeamImages201)) => {
  return http.post('*/teams/:teamName/images', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateTeamImagesResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListTeamInvitationsMockHandler = (overrideResponse?: PlatformListTeamInvitations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTeamInvitations200> | PlatformListTeamInvitations200)) => {
  return http.get('*/teams/:teamName/invitations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListTeamInvitationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteTeamInvitationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/invitations', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformAcceptTeamInvitationMockHandler = (overrideResponse?: PlatformMembershipWithTeam | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformMembershipWithTeam> | PlatformMembershipWithTeam)) => {
  return http.post('*/teams/:teamName/invitations/accept', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAcceptTeamInvitationResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTeamMembershipsMockHandler = (overrideResponse?: PlatformGetTeamMemberships200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetTeamMemberships200> | PlatformGetTeamMemberships200)) => {
  return http.get('*/teams/:teamName/memberships', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTeamMembershipsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformRemoveTeamMembershipMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/memberships', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformDeleteTeamMembershipMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/memberships/:email', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListAllNotificationDestinationsMockHandler = (overrideResponse?: PlatformListAllNotificationDestinations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllNotificationDestinations200> | PlatformListAllNotificationDestinations200)) => {
  return http.get('*/teams/:teamName/notifications/destinations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListAllNotificationDestinationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestination | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformNotificationDestination> | PlatformNotificationDestination)) => {
  return http.post('*/teams/:teamName/notifications/destinations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateNotificationDestinationResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTestUnsavedNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestinationTestResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformNotificationDestinationTestResponse> | PlatformNotificationDestinationTestResponse)) => {
  return http.post('*/teams/:teamName/notifications/destinations/test', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTestUnsavedNotificationDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestination | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformNotificationDestination> | PlatformNotificationDestination)) => {
  return http.get('*/teams/:teamName/notifications/destination/:notificationDestinationId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetNotificationDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestination | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformNotificationDestination> | PlatformNotificationDestination)) => {
  return http.patch('*/teams/:teamName/notifications/destination/:notificationDestinationId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateNotificationDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteNotificationDestinationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/notifications/destination/:notificationDestinationId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformGetNotificationDestinationAlertsMockHandler = (overrideResponse?: PlatformGetNotificationDestinationAlerts200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetNotificationDestinationAlerts200> | PlatformGetNotificationDestinationAlerts200)) => {
  return http.get('*/teams/:teamName/notifications/destination/:notificationDestinationId/alerts', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetNotificationDestinationAlertsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTestNotificationDestinationMockHandler = (overrideResponse?: PlatformNotificationDestinationTestResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformNotificationDestinationTestResponse> | PlatformNotificationDestinationTestResponse)) => {
  return http.post('*/teams/:teamName/notifications/destination/:notificationDestinationId/test', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTestNotificationDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateAWSOnboardingMockHandler = (overrideResponse?: PlatformOnboardingAWSCreateResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformOnboardingAWSCreateResponse> | PlatformOnboardingAWSCreateResponse)) => {
  return http.post('*/teams/:teamName/onboardings/aws/oidc', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateAWSOnboardingResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetAWSOnboardingMockHandler = (overrideResponse?: PlatformOnboardingAWS | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformOnboardingAWS> | PlatformOnboardingAWS)) => {
  return http.get('*/teams/:teamName/onboardings/aws/oidc/:onboardingId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetAWSOnboardingResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformNotifyOnboardingMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/notify', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 202,
        
      })
  })
}

export const getPlatformGetAWSAccountsInRootMockHandler = (overrideResponse?: PlatformOnboardingAWSAccounts | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformOnboardingAWSAccounts> | PlatformOnboardingAWSAccounts)) => {
  return http.get('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/accounts', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetAWSAccountsInRootResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetAWSAccountsInParentMockHandler = (overrideResponse?: PlatformOnboardingAWSAccounts | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformOnboardingAWSAccounts> | PlatformOnboardingAWSAccounts)) => {
  return http.get('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/accounts/:awsOrgunitId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetAWSAccountsInParentResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformProvisionOnboardingConfigurationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/teams/:teamName/onboardings/aws/oidc/:onboardingId/accounts/provision', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 202,
        
      })
  })
}

export const getPlatformListPluginsByTeamMockHandler = (overrideResponse?: PlatformListPluginsByTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPluginsByTeam200> | PlatformListPluginsByTeam200)) => {
  return http.get('*/teams/:teamName/plugins', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPluginsByTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeletePluginsByTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/plugins', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformDownloadPluginAssetByTeamMockHandler = (overrideResponse?: PlatformPluginAsset | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformPluginAsset> | PlatformPluginAsset)) => {
  return http.get('*/teams/:teamName/plugins/:pluginTeam/:pluginKind/:pluginName/versions/:versionName/assets/:targetName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformDownloadPluginAssetByTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListPoliciesMockHandler = (overrideResponse?: PlatformListPolicies200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicies200> | PlatformListPolicies200)) => {
  return http.get('*/teams/:teamName/policies', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPoliciesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreatePolicyMockHandler = (overrideResponse?: PlatformCreatePolicy201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreatePolicy201> | PlatformCreatePolicy201)) => {
  return http.post('*/teams/:teamName/policies', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreatePolicyResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListAllFrameworksMockHandler = (overrideResponse?: PlatformListAllFrameworks200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllFrameworks200> | PlatformListAllFrameworks200)) => {
  return http.get('*/teams/:teamName/policies/frameworks', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListAllFrameworksResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetPolicyMockHandler = (overrideResponse?: PlatformGetPolicy200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetPolicy200> | PlatformGetPolicy200)) => {
  return http.get('*/teams/:teamName/policies/:policyId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetPolicyResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdatePolicyMockHandler = (overrideResponse?: PlatformUpdatePolicy200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformUpdatePolicy200> | PlatformUpdatePolicy200)) => {
  return http.put('*/teams/:teamName/policies/:policyId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdatePolicyResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeletePolicyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/policies/:policyId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListPolicyFrameworksMockHandler = (overrideResponse?: PlatformListPolicyFrameworks200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicyFrameworks200> | PlatformListPolicyFrameworks200)) => {
  return http.get('*/teams/:teamName/policies/:policyId/frameworks', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPolicyFrameworksResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListPolicyRulesMockHandler = (overrideResponse?: PlatformListPolicyRules200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicyRules200> | PlatformListPolicyRules200)) => {
  return http.get('*/teams/:teamName/policies/:policyId/rules', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPolicyRulesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListPolicyRuleDetailsMockHandler = (overrideResponse?: PlatformListPolicyRuleDetails200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListPolicyRuleDetails200> | PlatformListPolicyRuleDetails200)) => {
  return http.get('*/teams/:teamName/policies/:policyId/rules/:ruleId/details', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListPolicyRuleDetailsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTogglePolicyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/teams/:teamName/policies/:policyId/toggle', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  })
}

export const getPlatformGetPolicyViolationsHistoryMockHandler = (overrideResponse?: PlatformGetPolicyViolationsHistory200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetPolicyViolationsHistory200> | PlatformGetPolicyViolationsHistory200)) => {
  return http.get('*/teams/:teamName/policies/:policyId/violations-history', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetPolicyViolationsHistoryResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListAllQueriesTeamMockHandler = (overrideResponse?: PlatformListAllQueriesTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListAllQueriesTeam200> | PlatformListAllQueriesTeam200)) => {
  return http.get('*/teams/:teamName/queries', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListAllQueriesTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformExecuteAdHocQueryTeamMockHandler = (overrideResponse?: PlatformExecuteAdHocQueryTeam200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformExecuteAdHocQueryTeam200> | PlatformExecuteAdHocQueryTeam200)) => {
  return http.post('*/teams/:teamName/queries/execute', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformExecuteAdHocQueryTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformSaveQueryTeamMockHandler = (overrideResponse?: PlatformQueryDetail | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformQueryDetail> | PlatformQueryDetail)) => {
  return http.post('*/teams/:teamName/queries/save', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformSaveQueryTeamResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListQueryTagsTeamMockHandler = (overrideResponse?: PlatformListQueryTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListQueryTagsTeam200> | PlatformListQueryTagsTeam200)) => {
  return http.get('*/teams/:teamName/queries/tags', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListQueryTagsTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSavedQueryTeamMockHandler = (overrideResponse?: PlatformQueryDetail | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformQueryDetail> | PlatformQueryDetail)) => {
  return http.get('*/teams/:teamName/queries/:queryId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSavedQueryTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateQueryTeamMockHandler = (overrideResponse?: PlatformQueryDetail | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformQueryDetail> | PlatformQueryDetail)) => {
  return http.patch('*/teams/:teamName/queries/:queryId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateQueryTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteSavedQueryTeamMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/queries/:queryId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformDeleteAlertMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/queries/:queryId/alert', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformExecuteSavedQueryTeamMockHandler = (overrideResponse?: PlatformExecuteSavedQueryTeam200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformExecuteSavedQueryTeam200> | PlatformExecuteSavedQueryTeam200)) => {
  return http.post('*/teams/:teamName/queries/:queryId/execute', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformExecuteSavedQueryTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformQueryListFiltersTeamMockHandler = (overrideResponse?: PlatformQueryListFiltersTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformQueryListFiltersTeam200> | PlatformQueryListFiltersTeam200)) => {
  return http.get('*/teams/:teamName/queries/:queryId/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformQueryListFiltersTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformQuerySaveFilterTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter)) => {
  return http.post('*/teams/:teamName/queries/:queryId/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformQuerySaveFilterTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformQueryListFilterTagsTeamMockHandler = (overrideResponse?: PlatformQueryListFilterTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformQueryListFilterTagsTeam200> | PlatformQueryListFilterTagsTeam200)) => {
  return http.get('*/teams/:teamName/queries/:queryId/filters/tags', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformQueryListFilterTagsTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListReportsMockHandler = (overrideResponse?: PlatformListReports200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListReports200> | PlatformListReports200)) => {
  return http.get('*/teams/:teamName/reports', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListReportsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateReportMockHandler = (overrideResponse?: PlatformCreateReport201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateReport201> | PlatformCreateReport201)) => {
  return http.post('*/teams/:teamName/reports', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateReportResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetReportMockHandler = (overrideResponse?: PlatformGetReport200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetReport200> | PlatformGetReport200)) => {
  return http.get('*/teams/:teamName/reports/:reportId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetReportResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateReportMockHandler = (overrideResponse?: PlatformUpdateReport200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformUpdateReport200> | PlatformUpdateReport200)) => {
  return http.put('*/teams/:teamName/reports/:reportId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateReportResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteReportMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/reports/:reportId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListReportTemplatesMockHandler = (overrideResponse?: PlatformListReportTemplates200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListReportTemplates200> | PlatformListReportTemplates200)) => {
  return http.get('*/teams/:teamName/reports/templates', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListReportTemplatesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateReportTemplateMockHandler = (overrideResponse?: PlatformCreateReportTemplate201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateReportTemplate201> | PlatformCreateReportTemplate201)) => {
  return http.post('*/teams/:teamName/reports/templates', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateReportTemplateResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetReportTemplateMockHandler = (overrideResponse?: PlatformGetReportTemplate200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetReportTemplate200> | PlatformGetReportTemplate200)) => {
  return http.get('*/teams/:teamName/reports/templates/:templateId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetReportTemplateResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateReportTemplateMockHandler = (overrideResponse?: PlatformUpdateReportTemplate200 | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<PlatformUpdateReportTemplate200> | PlatformUpdateReportTemplate200)) => {
  return http.put('*/teams/:teamName/reports/templates/:templateId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateReportTemplateResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteReportTemplateMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/reports/templates/:templateId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformCreateSyncDestinationTestConnectionMockHandler = (overrideResponse?: PlatformSyncDestinationTestConnection | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncDestinationTestConnection> | PlatformSyncDestinationTestConnection)) => {
  return http.post('*/teams/:teamName/sync-destination-test-connections', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateSyncDestinationTestConnectionResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncDestinationTestConnectionMockHandler = (overrideResponse?: PlatformSyncDestinationTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncDestinationTestConnection> | PlatformSyncDestinationTestConnection)) => {
  return http.get('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncDestinationTestConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncTestConnectionForSyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestinationTestConnection | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncDestinationTestConnection> | PlatformSyncDestinationTestConnection)) => {
  return http.patch('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncTestConnectionForSyncDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncDestinationTestConnectionLogsMockHandler = (overrideResponse?: PlatformGetSyncDestinationTestConnectionLogs200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncDestinationTestConnectionLogs200One | string | void> | PlatformGetSyncDestinationTestConnectionLogs200One | string | void)) => {
  return http.get('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId/logs', async (info) => {await delay(300);
  
    return new HttpResponse(getPlatformGetSyncDestinationTestConnectionLogsResponseMock(),
      { status: 200,
        headers: { 'Content-Type': 'text/plain' }
      })
  })
}

export const getPlatformPromoteSyncDestinationTestConnectionMockHandler = (overrideResponse?: PlatformSyncDestination | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncDestination> | PlatformSyncDestination)) => {
  return http.post('*/teams/:teamName/sync-destination-test-connections/:syncDestinationTestConnectionId/promote', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformPromoteSyncDestinationTestConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListSyncDestinationsMockHandler = (overrideResponse?: PlatformListSyncDestinations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncDestinations200> | PlatformListSyncDestinations200)) => {
  return http.get('*/teams/:teamName/sync-destinations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncDestinationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestination | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncDestination> | PlatformSyncDestination)) => {
  return http.get('*/teams/:teamName/sync-destinations/:syncDestinationName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncDestinationMockHandler = (overrideResponse?: PlatformSyncDestination | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncDestination> | PlatformSyncDestination)) => {
  return http.patch('*/teams/:teamName/sync-destinations/:syncDestinationName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteSyncDestinationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/sync-destinations/:syncDestinationName', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformMigrateSyncDestinationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/teams/:teamName/sync-destinations/:syncDestinationName/migrate', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListSyncDestinationSyncsMockHandler = (overrideResponse?: PlatformListSyncDestinationSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncDestinationSyncs200> | PlatformListSyncDestinationSyncs200)) => {
  return http.get('*/teams/:teamName/sync-destinations/:syncDestinationName/syncs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncDestinationSyncsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTestConnectionForSyncDestinationMockHandler = (overrideResponse?: PlatformSyncTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTestConnection> | PlatformSyncTestConnection)) => {
  return http.get('*/teams/:teamName/sync-destinations/:syncDestinationName/test-connections/:syncTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTestConnectionForSyncDestinationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateSyncSourceTestConnectionMockHandler = (overrideResponse?: PlatformSyncSourceTestConnection | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncSourceTestConnection> | PlatformSyncSourceTestConnection)) => {
  return http.post('*/teams/:teamName/sync-source-test-connections', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateSyncSourceTestConnectionResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncSourceTestConnectionMockHandler = (overrideResponse?: PlatformSyncSourceTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncSourceTestConnection> | PlatformSyncSourceTestConnection)) => {
  return http.get('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncSourceTestConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncTestConnectionForSyncSourceMockHandler = (overrideResponse?: PlatformSyncSourceTestConnection | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncSourceTestConnection> | PlatformSyncSourceTestConnection)) => {
  return http.patch('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncTestConnectionForSyncSourceResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncSourceTestConnectionLogsMockHandler = (overrideResponse?: PlatformGetSyncSourceTestConnectionLogs200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncSourceTestConnectionLogs200One | string | void> | PlatformGetSyncSourceTestConnectionLogs200One | string | void)) => {
  return http.get('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId/logs', async (info) => {await delay(300);
  
    return new HttpResponse(getPlatformGetSyncSourceTestConnectionLogsResponseMock(),
      { status: 200,
        headers: { 'Content-Type': 'text/plain' }
      })
  })
}

export const getPlatformPromoteSyncSourceTestConnectionMockHandler = (overrideResponse?: PlatformSyncSource | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncSource> | PlatformSyncSource)) => {
  return http.post('*/teams/:teamName/sync-source-test-connections/:syncSourceTestConnectionId/promote', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformPromoteSyncSourceTestConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListSyncSourcesMockHandler = (overrideResponse?: PlatformListSyncSources200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncSources200> | PlatformListSyncSources200)) => {
  return http.get('*/teams/:teamName/sync-sources', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncSourcesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncSourceMockHandler = (overrideResponse?: PlatformSyncSource | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncSource> | PlatformSyncSource)) => {
  return http.get('*/teams/:teamName/sync-sources/:syncSourceName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncSourceResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncSourceMockHandler = (overrideResponse?: PlatformSyncSource | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncSource> | PlatformSyncSource)) => {
  return http.patch('*/teams/:teamName/sync-sources/:syncSourceName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncSourceResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteSyncSourceMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/sync-sources/:syncSourceName', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformMigrateSyncSourceMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/teams/:teamName/sync-sources/:syncSourceName/migrate', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListSyncSourceSyncsMockHandler = (overrideResponse?: PlatformListSyncSourceSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncSourceSyncs200> | PlatformListSyncSourceSyncs200)) => {
  return http.get('*/teams/:teamName/sync-sources/:syncSourceName/syncs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncSourceSyncsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTestConnectionForSyncSourceMockHandler = (overrideResponse?: PlatformSyncTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTestConnection> | PlatformSyncTestConnection)) => {
  return http.get('*/teams/:teamName/sync-sources/:syncSourceName/test-connections/:syncTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTestConnectionForSyncSourceResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateSyncTransformerTestConnectionMockHandler = (overrideResponse?: PlatformSyncTransformerTestConnection | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncTransformerTestConnection> | PlatformSyncTransformerTestConnection)) => {
  return http.post('*/teams/:teamName/sync-transformer-test-connections', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateSyncTransformerTestConnectionResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncTransformerTestConnectionMockHandler = (overrideResponse?: PlatformSyncTransformerTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTransformerTestConnection> | PlatformSyncTransformerTestConnection)) => {
  return http.get('*/teams/:teamName/sync-transformer-test-connections/:syncTransformerTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncTransformerTestConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncTestConnectionForSyncTransformerMockHandler = (overrideResponse?: PlatformSyncTransformerTestConnection | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncTransformerTestConnection> | PlatformSyncTransformerTestConnection)) => {
  return http.patch('*/teams/:teamName/sync-transformer-test-connections/:syncTransformerTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncTestConnectionForSyncTransformerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncTransformerTestConnectionLogsMockHandler = (overrideResponse?: PlatformGetSyncTransformerTestConnectionLogs200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncTransformerTestConnectionLogs200One | string | void> | PlatformGetSyncTransformerTestConnectionLogs200One | string | void)) => {
  return http.get('*/teams/:teamName/sync-transformer-test-connections/:syncTransformerTestConnectionId/logs', async (info) => {await delay(300);
  
    return new HttpResponse(getPlatformGetSyncTransformerTestConnectionLogsResponseMock(),
      { status: 200,
        headers: { 'Content-Type': 'text/plain' }
      })
  })
}

export const getPlatformPromoteSyncTransformerTestConnectionMockHandler = (overrideResponse?: PlatformSyncTransformer | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncTransformer> | PlatformSyncTransformer)) => {
  return http.post('*/teams/:teamName/sync-transformer-test-connections/:syncTransformerTestConnectionId/promote', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformPromoteSyncTransformerTestConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListSyncTransformersMockHandler = (overrideResponse?: PlatformListSyncTransformers200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncTransformers200> | PlatformListSyncTransformers200)) => {
  return http.get('*/teams/:teamName/sync-transformers', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncTransformersResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncTransformerMockHandler = (overrideResponse?: PlatformSyncTransformer | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTransformer> | PlatformSyncTransformer)) => {
  return http.get('*/teams/:teamName/sync-transformers/:syncTransformerName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncTransformerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncTransformerMockHandler = (overrideResponse?: PlatformSyncTransformer | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncTransformer> | PlatformSyncTransformer)) => {
  return http.patch('*/teams/:teamName/sync-transformers/:syncTransformerName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncTransformerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteSyncTransformerMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/sync-transformers/:syncTransformerName', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListSyncTransformerSyncsMockHandler = (overrideResponse?: PlatformListSyncTransformerSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncTransformerSyncs200> | PlatformListSyncTransformerSyncs200)) => {
  return http.get('*/teams/:teamName/sync-transformers/:syncTransformerName/syncs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncTransformerSyncsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListSyncTransformerSyncDestinationsMockHandler = (overrideResponse?: PlatformListSyncTransformerSyncDestinations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncTransformerSyncDestinations200> | PlatformListSyncTransformerSyncDestinations200)) => {
  return http.get('*/teams/:teamName/sync-transformers/:syncTransformerName/sync-destinations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncTransformerSyncDestinationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTestConnectionForSyncTransformerMockHandler = (overrideResponse?: PlatformSyncTestConnection | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncTestConnection> | PlatformSyncTestConnection)) => {
  return http.get('*/teams/:teamName/sync-transformers/:syncTransformerName/test-connections/:syncTestConnectionId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTestConnectionForSyncTransformerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListSyncUpgradesMockHandler = (overrideResponse?: PlatformListSyncUpgrades200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncUpgrades200> | PlatformListSyncUpgrades200)) => {
  return http.get('*/teams/:teamName/sync-upgrades', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncUpgradesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListSyncsMockHandler = (overrideResponse?: PlatformListSyncs200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncs200> | PlatformListSyncs200)) => {
  return http.get('*/teams/:teamName/syncs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateSyncMockHandler = (overrideResponse?: PlatformSync | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSync> | PlatformSync)) => {
  return http.post('*/teams/:teamName/syncs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateSyncResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncMockHandler = (overrideResponse?: PlatformSync | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSync> | PlatformSync)) => {
  return http.get('*/teams/:teamName/syncs/:syncName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncMockHandler = (overrideResponse?: PlatformSync | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSync> | PlatformSync)) => {
  return http.patch('*/teams/:teamName/syncs/:syncName', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteSyncMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/teams/:teamName/syncs/:syncName', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListSyncRunsMockHandler = (overrideResponse?: PlatformListSyncRuns200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListSyncRuns200> | PlatformListSyncRuns200)) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListSyncRunsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateSyncRunMockHandler = (overrideResponse?: PlatformSyncRun | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformSyncRun> | PlatformSyncRun)) => {
  return http.post('*/teams/:teamName/syncs/:syncName/runs', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateSyncRunResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncRunMockHandler = (overrideResponse?: PlatformSyncRunDetails | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncRunDetails> | PlatformSyncRunDetails)) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncRunResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateSyncRunMockHandler = (overrideResponse?: PlatformSyncRun | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformSyncRun> | PlatformSyncRun)) => {
  return http.patch('*/teams/:teamName/syncs/:syncName/runs/:syncRunId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateSyncRunResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncRunLogsMockHandler = (overrideResponse?: PlatformGetSyncRunLogs200One | string | void | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunLogs200One | string | void> | PlatformGetSyncRunLogs200One | string | void)) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/logs', async (info) => {await delay(300);
  
    return new HttpResponse(getPlatformGetSyncRunLogsResponseMock(),
      { status: 200,
        headers: { 'Content-Type': 'text/plain' }
      })
  })
}

export const getPlatformCreateSyncRunProgressMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/progress', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformGetSyncRunStatsMockHandler = (overrideResponse?: PlatformSyncRunStats | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformSyncRunStats> | PlatformSyncRunStats)) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/stats', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncRunStatsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncRunTablesMockHandler = (overrideResponse?: PlatformGetSyncRunTables200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunTables200> | PlatformGetSyncRunTables200)) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/tables', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncRunTablesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncRunConnectorCredentialsMockHandler = (overrideResponse?: PlatformGetSyncRunConnectorCredentials200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunConnectorCredentials200> | PlatformGetSyncRunConnectorCredentials200)) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/connector/:connectorId/credentials', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncRunConnectorCredentialsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetSyncRunConnectorIdentityMockHandler = (overrideResponse?: PlatformGetSyncRunConnectorIdentity200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetSyncRunConnectorIdentity200> | PlatformGetSyncRunConnectorIdentity200)) => {
  return http.get('*/teams/:teamName/syncs/:syncName/runs/:syncRunId/connector/:connectorId/identity', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetSyncRunConnectorIdentityResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTestConnectionConnectorCredentialsMockHandler = (overrideResponse?: PlatformGetTestConnectionConnectorCredentials200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetTestConnectionConnectorCredentials200> | PlatformGetTestConnectionConnectorCredentials200)) => {
  return http.get('*/teams/:teamName/syncs/test-connections/:syncTestConnectionId/connector/:connectorId/credentials', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTestConnectionConnectorCredentialsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTestConnectionConnectorIdentityMockHandler = (overrideResponse?: PlatformGetTestConnectionConnectorIdentity200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetTestConnectionConnectorIdentity200> | PlatformGetTestConnectionConnectorIdentity200)) => {
  return http.get('*/teams/:teamName/syncs/test-connections/:syncTestConnectionId/connector/:connectorId/identity', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTestConnectionConnectorIdentityResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListTablesTeamMockHandler = (overrideResponse?: PlatformListTablesTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListTablesTeam200> | PlatformListTablesTeam200)) => {
  return http.get('*/teams/:teamName/tables', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListTablesTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListRowsTeamMockHandler = (overrideResponse?: PlatformTableListRowsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListRowsTeam200> | PlatformTableListRowsTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/data', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListRowsTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableRowByIdTeamMockHandler = (overrideResponse?: PlatformTableRowByIdTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableRowByIdTeam200> | PlatformTableRowByIdTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/data/:tableRowId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableRowByIdTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableSchemaTeamMockHandler = (overrideResponse?: PlatformTableSchemaTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableSchemaTeam200> | PlatformTableSchemaTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/schema', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableSchemaTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformBatchTableSchemasTeamMockHandler = (overrideResponse?: PlatformBatchTableSchemasTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformBatchTableSchemasTeam200> | PlatformBatchTableSchemasTeam200)) => {
  return http.get('*/teams/:teamName/tables/schemas', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformBatchTableSchemasTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListColumnsTeamMockHandler = (overrideResponse?: PlatformTableListColumnsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListColumnsTeam200> | PlatformTableListColumnsTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/columns', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListColumnsTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableColumnListValuesTeamMockHandler = (overrideResponse?: PlatformTableColumnListValuesTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableColumnListValuesTeam200> | PlatformTableColumnListValuesTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/columns/:columnName/values', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableColumnListValuesTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListFiltersTeamMockHandler = (overrideResponse?: PlatformTableListFiltersTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListFiltersTeam200> | PlatformTableListFiltersTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListFiltersTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableSaveFilterTeamMockHandler = (overrideResponse?: PlatformFilter | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformFilter> | PlatformFilter)) => {
  return http.post('*/teams/:teamName/tables/:tableName/filters', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableSaveFilterTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListFilterTagsTeamMockHandler = (overrideResponse?: PlatformTableListFilterTagsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListFilterTagsTeam200> | PlatformTableListFilterTagsTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/filters/tags', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListFilterTagsTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformTableListRelationsTeamMockHandler = (overrideResponse?: PlatformTableListRelationsTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformTableListRelationsTeam200> | PlatformTableListRelationsTeam200)) => {
  return http.get('*/teams/:teamName/tables/:tableName/relations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformTableListRelationsTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetTeamUsageSummaryMockHandler = (overrideResponse?: PlatformUsageSummary | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformUsageSummary> | PlatformUsageSummary)) => {
  return http.get('*/teams/:teamName/usage-summary', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetTeamUsageSummaryResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetGroupedTeamUsageSummaryMockHandler = (overrideResponse?: PlatformUsageSummary | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformUsageSummary> | PlatformUsageSummary)) => {
  return http.get('*/teams/:teamName/usage-summary/:groupBy', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetGroupedTeamUsageSummaryResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListUsersByTeamMockHandler = (overrideResponse?: PlatformListUsersByTeam200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListUsersByTeam200> | PlatformListUsersByTeam200)) => {
  return http.get('*/teams/:teamName/users', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListUsersByTeamResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformListUserSnapshotsMockHandler = (overrideResponse?: PlatformListUserSnapshots200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListUserSnapshots200> | PlatformListUserSnapshots200)) => {
  return http.get('*/teams/:teamName/user-snapshots', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListUserSnapshotsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformCreateUserSnapshotMockHandler = (overrideResponse?: PlatformUserSnapshot | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformUserSnapshot> | PlatformUserSnapshot)) => {
  return http.post('*/teams/:teamName/user-snapshots', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateUserSnapshotResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetUserSnapshotMockHandler = (overrideResponse?: PlatformUserSnapshot | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformUserSnapshot> | PlatformUserSnapshot)) => {
  return http.get('*/teams/:teamName/user-snapshots/:userSnapshotId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetUserSnapshotResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateUserSnapshotMockHandler = (overrideResponse?: PlatformUserSnapshot | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformUserSnapshot> | PlatformUserSnapshot)) => {
  return http.patch('*/teams/:teamName/user-snapshots/:userSnapshotId', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateUserSnapshotResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUploadImageMockHandler = (overrideResponse?: PlatformImageURL | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformImageURL> | PlatformImageURL)) => {
  return http.post('*/upload/image', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUploadImageResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetCurrentUserMockHandler = (overrideResponse?: PlatformGetCurrentUser200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetCurrentUser200> | PlatformGetCurrentUser200)) => {
  return http.get('*/user', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetCurrentUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformUpdateCurrentUserMockHandler = (overrideResponse?: PlatformUser | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<PlatformUser> | PlatformUser)) => {
  return http.patch('*/user', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformUpdateCurrentUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformSendAnonymousEventMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/user/anon-event', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformAuthenticateLocalUserMockHandler = (overrideResponse?: PlatformAuthenticateLocalUser200 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformAuthenticateLocalUser200> | PlatformAuthenticateLocalUser200)) => {
  return http.post('*/user/authenticate', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAuthenticateLocalUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformChangeLocalUserPasswordMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/user/change-password', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformUpdateCustomerMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<void> | void)) => {
  return http.patch('*/user/customer', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 201,
        
      })
  })
}

export const getPlatformSendUserEventMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/user/event', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformListCurrentUserInvitationsMockHandler = (overrideResponse?: PlatformListCurrentUserInvitations200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformListCurrentUserInvitations200> | PlatformListCurrentUserInvitations200)) => {
  return http.get('*/user/invitations', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformListCurrentUserInvitationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformGetCurrentLocalUserMockHandler = (overrideResponse?: PlatformLocalUserWithTeams | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformLocalUserWithTeams> | PlatformLocalUserWithTeams)) => {
  return http.get('*/user/local', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetCurrentLocalUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformLoginUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/user/login', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformLogoutUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/user/login', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformGetCurrentUserMembershipsMockHandler = (overrideResponse?: PlatformGetCurrentUserMemberships200 | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformGetCurrentUserMemberships200> | PlatformGetCurrentUserMemberships200)) => {
  return http.get('*/user/memberships', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformGetCurrentUserMembershipsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformResetLocalUserPasswordMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)) => {
  return http.post('*/user/reset-password-token', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformCreateUserTokenMockHandler = (overrideResponse?: PlatformCreateUserToken201 | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<PlatformCreateUserToken201> | PlatformCreateUserToken201)) => {
  return http.post('*/user/token', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformCreateUserTokenResponseMock()),
      { status: 201,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPlatformDeleteUserMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)) => {
  return http.delete('*/users/:userId', async (info) => {await delay(300);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 204,
        
      })
  })
}

export const getPlatformAuthRegistryRequestMockHandler = (overrideResponse?: PlatformRegistryAuthToken | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PlatformRegistryAuthToken> | PlatformRegistryAuthToken)) => {
  return http.get('*/registry/auth', async (info) => {await delay(300);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPlatformAuthRegistryRequestResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}
export const getCloudQueryPlatformOpenAPISpecMock = () => [
  getPlatformIndexMockHandler(),
  getPlatformListAuditLogsMockHandler(),
  getPlatformGetAuditLogMockHandler(),
  getPlatformListFiltersMockHandler(),
  getPlatformListFilterTagsMockHandler(),
  getPlatformGetFilterByIDMockHandler(),
  getPlatformUpdateFilterMockHandler(),
  getPlatformDeleteFilterMockHandler(),
  getPlatformHealthCheckHeadMockHandler(),
  getPlatformHealthCheckMockHandler(),
  getPlatformGetOpenAPIJSONMockHandler(),
  getPlatformAssetViewGetStatusMockHandler(),
  getPlatformAssetViewTriggerMockHandler(),
  getPlatformAssetViewListLogsMockHandler(),
  getPlatformManageGetSAMLMockHandler(),
  getPlatformManageUpdateSAMLMockHandler(),
  getPlatformManageGetPlatformRegistryMockHandler(),
  getPlatformManageRegisterPlatformMockHandler(),
  getPlatformManageRegisterPlatformWithOfflineLicenseMockHandler(),
  getPlatformManageListAllTeamsMockHandler(),
  getPlatformManageGetTeamMockHandler(),
  getPlatformManageDeleteTeamMockHandler(),
  getPlatformManageListTeamMembersMockHandler(),
  getPlatformManageAddTeamMemberMockHandler(),
  getPlatformManageRemoveTeamMemberMockHandler(),
  getPlatformListLocalUsersMockHandler(),
  getPlatformAddLocalUserMockHandler(),
  getPlatformGetLocalUserMockHandler(),
  getPlatformUpdateLocalUserMockHandler(),
  getPlatformDeleteLocalUserMockHandler(),
  getPlatformCreateLocalUserResetTokenMockHandler(),
  getPlatformGetPlatformInfoMockHandler(),
  getPlatformListPlatformVersionsMockHandler(),
  getPlatformListPluginsMockHandler(),
  getPlatformCreatePluginMockHandler(),
  getPlatformGetPluginMockHandler(),
  getPlatformUpdatePluginMockHandler(),
  getPlatformDeletePluginByTeamAndPluginNameMockHandler(),
  getPlatformListPluginVersionsMockHandler(),
  getPlatformGetPluginVersionMockHandler(),
  getPlatformCreatePluginVersionMockHandler(),
  getPlatformUpdatePluginVersionMockHandler(),
  getPlatformDownloadPluginAssetMockHandler(),
  getPlatformUploadPluginAssetMockHandler(),
  getPlatformListPluginVersionDocsMockHandler(),
  getPlatformCreatePluginVersionDocsMockHandler(),
  getPlatformReplacePluginVersionDocsMockHandler(),
  getPlatformDeletePluginVersionDocsMockHandler(),
  getPlatformListPluginVersionTablesMockHandler(),
  getPlatformCreatePluginVersionTablesMockHandler(),
  getPlatformDeletePluginVersionTablesMockHandler(),
  getPlatformGetPluginVersionTableMockHandler(),
  getPlatformUploadPluginUIAssetsMockHandler(),
  getPlatformFinalizePluginUIAssetUploadMockHandler(),
  getPlatformRemovePluginUIAssetsMockHandler(),
  getPlatformListTablesMockHandler(),
  getPlatformTableListRowsMockHandler(),
  getPlatformTableRowByIdMockHandler(),
  getPlatformTableSchemaMockHandler(),
  getPlatformBatchTableSchemasMockHandler(),
  getPlatformTableListColumnsMockHandler(),
  getPlatformTableColumnListValuesMockHandler(),
  getPlatformTableListFiltersMockHandler(),
  getPlatformTableSaveFilterMockHandler(),
  getPlatformTableListFilterTagsMockHandler(),
  getPlatformTableListRelationsMockHandler(),
  getPlatformListTeamsMockHandler(),
  getPlatformCreateTeamMockHandler(),
  getPlatformGetTeamByNameMockHandler(),
  getPlatformUpdateTeamMockHandler(),
  getPlatformDeleteTeamMockHandler(),
  getPlatformListAllAlertsMockHandler(),
  getPlatformTestUnsavedAlertMockHandler(),
  getPlatformListTeamAPIKeysMockHandler(),
  getPlatformCreateTeamAPIKeyMockHandler(),
  getPlatformDeleteTeamAPIKeyMockHandler(),
  getPlatformListConnectorsMockHandler(),
  getPlatformCreateConnectorMockHandler(),
  getPlatformGetConnectorMockHandler(),
  getPlatformUpdateConnectorMockHandler(),
  getPlatformRevokeConnectorMockHandler(),
  getPlatformGetConnectorAuthStatusAWSMockHandler(),
  getPlatformAuthenticateConnectorAWSMockHandler(),
  getPlatformAuthenticateConnectorFinishAWSMockHandler(),
  getPlatformGetConnectorAuthStatusGCPMockHandler(),
  getPlatformAuthenticateConnectorGCPMockHandler(),
  getPlatformAuthenticateConnectorFinishGCPMockHandler(),
  getPlatformAuthenticateConnectorOAuthMockHandler(),
  getPlatformAuthenticateConnectorFinishOAuthMockHandler(),
  getPlatformListAllCustomColumnsMockHandler(),
  getPlatformSaveCustomColumnMockHandler(),
  getPlatformGetCustomColumnMockHandler(),
  getPlatformUpdateCustomColumnMockHandler(),
  getPlatformDeleteCustomColumnMockHandler(),
  getPlatformPutCustomColumnDataMockHandler(),
  getPlatformPutCustomColumnValuesMockHandler(),
  getPlatformListFiltersTeamMockHandler(),
  getPlatformListFilterTagsTeamMockHandler(),
  getPlatformGetFilterByIDTeamMockHandler(),
  getPlatformUpdateFilterTeamMockHandler(),
  getPlatformDeleteFilterTeamMockHandler(),
  getPlatformCreateTeamImagesMockHandler(),
  getPlatformListTeamInvitationsMockHandler(),
  getPlatformDeleteTeamInvitationMockHandler(),
  getPlatformAcceptTeamInvitationMockHandler(),
  getPlatformGetTeamMembershipsMockHandler(),
  getPlatformRemoveTeamMembershipMockHandler(),
  getPlatformDeleteTeamMembershipMockHandler(),
  getPlatformListAllNotificationDestinationsMockHandler(),
  getPlatformCreateNotificationDestinationMockHandler(),
  getPlatformTestUnsavedNotificationDestinationMockHandler(),
  getPlatformGetNotificationDestinationMockHandler(),
  getPlatformUpdateNotificationDestinationMockHandler(),
  getPlatformDeleteNotificationDestinationMockHandler(),
  getPlatformGetNotificationDestinationAlertsMockHandler(),
  getPlatformTestNotificationDestinationMockHandler(),
  getPlatformCreateAWSOnboardingMockHandler(),
  getPlatformGetAWSOnboardingMockHandler(),
  getPlatformNotifyOnboardingMockHandler(),
  getPlatformGetAWSAccountsInRootMockHandler(),
  getPlatformGetAWSAccountsInParentMockHandler(),
  getPlatformProvisionOnboardingConfigurationMockHandler(),
  getPlatformListPluginsByTeamMockHandler(),
  getPlatformDeletePluginsByTeamMockHandler(),
  getPlatformDownloadPluginAssetByTeamMockHandler(),
  getPlatformListPoliciesMockHandler(),
  getPlatformCreatePolicyMockHandler(),
  getPlatformListAllFrameworksMockHandler(),
  getPlatformGetPolicyMockHandler(),
  getPlatformUpdatePolicyMockHandler(),
  getPlatformDeletePolicyMockHandler(),
  getPlatformListPolicyFrameworksMockHandler(),
  getPlatformListPolicyRulesMockHandler(),
  getPlatformListPolicyRuleDetailsMockHandler(),
  getPlatformTogglePolicyMockHandler(),
  getPlatformGetPolicyViolationsHistoryMockHandler(),
  getPlatformListAllQueriesTeamMockHandler(),
  getPlatformExecuteAdHocQueryTeamMockHandler(),
  getPlatformSaveQueryTeamMockHandler(),
  getPlatformListQueryTagsTeamMockHandler(),
  getPlatformGetSavedQueryTeamMockHandler(),
  getPlatformUpdateQueryTeamMockHandler(),
  getPlatformDeleteSavedQueryTeamMockHandler(),
  getPlatformDeleteAlertMockHandler(),
  getPlatformExecuteSavedQueryTeamMockHandler(),
  getPlatformQueryListFiltersTeamMockHandler(),
  getPlatformQuerySaveFilterTeamMockHandler(),
  getPlatformQueryListFilterTagsTeamMockHandler(),
  getPlatformListReportsMockHandler(),
  getPlatformCreateReportMockHandler(),
  getPlatformGetReportMockHandler(),
  getPlatformUpdateReportMockHandler(),
  getPlatformDeleteReportMockHandler(),
  getPlatformListReportTemplatesMockHandler(),
  getPlatformCreateReportTemplateMockHandler(),
  getPlatformGetReportTemplateMockHandler(),
  getPlatformUpdateReportTemplateMockHandler(),
  getPlatformDeleteReportTemplateMockHandler(),
  getPlatformCreateSyncDestinationTestConnectionMockHandler(),
  getPlatformGetSyncDestinationTestConnectionMockHandler(),
  getPlatformUpdateSyncTestConnectionForSyncDestinationMockHandler(),
  getPlatformGetSyncDestinationTestConnectionLogsMockHandler(),
  getPlatformPromoteSyncDestinationTestConnectionMockHandler(),
  getPlatformListSyncDestinationsMockHandler(),
  getPlatformGetSyncDestinationMockHandler(),
  getPlatformUpdateSyncDestinationMockHandler(),
  getPlatformDeleteSyncDestinationMockHandler(),
  getPlatformMigrateSyncDestinationMockHandler(),
  getPlatformListSyncDestinationSyncsMockHandler(),
  getPlatformGetTestConnectionForSyncDestinationMockHandler(),
  getPlatformCreateSyncSourceTestConnectionMockHandler(),
  getPlatformGetSyncSourceTestConnectionMockHandler(),
  getPlatformUpdateSyncTestConnectionForSyncSourceMockHandler(),
  getPlatformGetSyncSourceTestConnectionLogsMockHandler(),
  getPlatformPromoteSyncSourceTestConnectionMockHandler(),
  getPlatformListSyncSourcesMockHandler(),
  getPlatformGetSyncSourceMockHandler(),
  getPlatformUpdateSyncSourceMockHandler(),
  getPlatformDeleteSyncSourceMockHandler(),
  getPlatformMigrateSyncSourceMockHandler(),
  getPlatformListSyncSourceSyncsMockHandler(),
  getPlatformGetTestConnectionForSyncSourceMockHandler(),
  getPlatformCreateSyncTransformerTestConnectionMockHandler(),
  getPlatformGetSyncTransformerTestConnectionMockHandler(),
  getPlatformUpdateSyncTestConnectionForSyncTransformerMockHandler(),
  getPlatformGetSyncTransformerTestConnectionLogsMockHandler(),
  getPlatformPromoteSyncTransformerTestConnectionMockHandler(),
  getPlatformListSyncTransformersMockHandler(),
  getPlatformGetSyncTransformerMockHandler(),
  getPlatformUpdateSyncTransformerMockHandler(),
  getPlatformDeleteSyncTransformerMockHandler(),
  getPlatformListSyncTransformerSyncsMockHandler(),
  getPlatformListSyncTransformerSyncDestinationsMockHandler(),
  getPlatformGetTestConnectionForSyncTransformerMockHandler(),
  getPlatformListSyncUpgradesMockHandler(),
  getPlatformListSyncsMockHandler(),
  getPlatformCreateSyncMockHandler(),
  getPlatformGetSyncMockHandler(),
  getPlatformUpdateSyncMockHandler(),
  getPlatformDeleteSyncMockHandler(),
  getPlatformListSyncRunsMockHandler(),
  getPlatformCreateSyncRunMockHandler(),
  getPlatformGetSyncRunMockHandler(),
  getPlatformUpdateSyncRunMockHandler(),
  getPlatformGetSyncRunLogsMockHandler(),
  getPlatformCreateSyncRunProgressMockHandler(),
  getPlatformGetSyncRunStatsMockHandler(),
  getPlatformGetSyncRunTablesMockHandler(),
  getPlatformGetSyncRunConnectorCredentialsMockHandler(),
  getPlatformGetSyncRunConnectorIdentityMockHandler(),
  getPlatformGetTestConnectionConnectorCredentialsMockHandler(),
  getPlatformGetTestConnectionConnectorIdentityMockHandler(),
  getPlatformListTablesTeamMockHandler(),
  getPlatformTableListRowsTeamMockHandler(),
  getPlatformTableRowByIdTeamMockHandler(),
  getPlatformTableSchemaTeamMockHandler(),
  getPlatformBatchTableSchemasTeamMockHandler(),
  getPlatformTableListColumnsTeamMockHandler(),
  getPlatformTableColumnListValuesTeamMockHandler(),
  getPlatformTableListFiltersTeamMockHandler(),
  getPlatformTableSaveFilterTeamMockHandler(),
  getPlatformTableListFilterTagsTeamMockHandler(),
  getPlatformTableListRelationsTeamMockHandler(),
  getPlatformGetTeamUsageSummaryMockHandler(),
  getPlatformGetGroupedTeamUsageSummaryMockHandler(),
  getPlatformListUsersByTeamMockHandler(),
  getPlatformListUserSnapshotsMockHandler(),
  getPlatformCreateUserSnapshotMockHandler(),
  getPlatformGetUserSnapshotMockHandler(),
  getPlatformUpdateUserSnapshotMockHandler(),
  getPlatformUploadImageMockHandler(),
  getPlatformGetCurrentUserMockHandler(),
  getPlatformUpdateCurrentUserMockHandler(),
  getPlatformSendAnonymousEventMockHandler(),
  getPlatformAuthenticateLocalUserMockHandler(),
  getPlatformChangeLocalUserPasswordMockHandler(),
  getPlatformUpdateCustomerMockHandler(),
  getPlatformSendUserEventMockHandler(),
  getPlatformListCurrentUserInvitationsMockHandler(),
  getPlatformGetCurrentLocalUserMockHandler(),
  getPlatformLoginUserMockHandler(),
  getPlatformLogoutUserMockHandler(),
  getPlatformGetCurrentUserMembershipsMockHandler(),
  getPlatformResetLocalUserPasswordMockHandler(),
  getPlatformCreateUserTokenMockHandler(),
  getPlatformDeleteUserMockHandler(),
  getPlatformAuthRegistryRequestMockHandler()
]
